import { useState, useEffect, useRef } from "react";
import { Table, Grid3x3, History, Search, ChevronDown, User, Upload, FileJson, Clock, Info } from "lucide-react";

const mockData = [
    { id: 1, buyurtmaId: "372BS", yetkazib: "VODIY STAR TRANS", sana: "2024-09-16", qayerdan: "Bektemir", qayerga: "Farg'ona", avto: "40 303 TBA", tel: "95 632 58 58", tashuvchi: "SHOHJAHON OLTIARIQ TRANS", inn: "302817752", buxgalter: "90 584 94 94", summa: 1450000 },
    { id: 2, buyurtmaId: "452UG", yetkazib: "VODIY STAR TRANS", sana: "2024-09-16", qayerdan: "Bektemir", qayerga: "Farg'ona", avto: "40 877 PBA", tel: "93 979 64 44", tashuvchi: "BIRODARLAR OLTIARIQ AVTO TRANS", inn: "308814088", buxgalter: "94 396 99 88", summa: 2100000 },
    { id: 3, buyurtmaId: "165NL", yetkazib: "VODIY STAR TRANS", sana: "2024-09-16", qayerdan: "Bektemir", qayerga: "Andijon", avto: "40 480 XBA", tel: "94 815 21 51", tashuvchi: "KO'NGIL", inn: "200176947", buxgalter: "94 815 21 51", summa: 980000 },
    { id: 4, buyurtmaId: "735FB", yetkazib: "VODIY STAR TRANS", sana: "2024-09-16", qayerdan: "Bektemir", qayerga: "Andijon", avto: "40 V 517 SA", tel: "91 110 40 01", tashuvchi: "SHOXJAXON ISMOILJON DILYORBEK", inn: "300476855", buxgalter: "91 283 11 10", summa: 1750000 },
    { id: 5, buyurtmaId: "323VT", yetkazib: "VODIY STAR TRANS", sana: "2024-09-16", qayerdan: "Bektemir", qayerga: "Farg'ona", avto: "40 530 WBA", tel: "90 160 89 69", tashuvchi: "ANOR GOLD TRANS", inn: "309215190", buxgalter: "95 107 92 92", summa: 3200000 },
    { id: 6, buyurtmaId: "362ZE", yetkazib: "VODIY STAR TRANS", sana: "2024-09-17", qayerdan: "Bektemir", qayerga: "Honabod", avto: "01 051 WLA", tel: "33 117 03 99", tashuvchi: "DELIVERSWIFT", inn: "310375762", buxgalter: "90 925 70 17", summa: 870000 },
    { id: 7, buyurtmaId: "295MQ", yetkazib: "VODIY STAR TRANS", sana: "2024-09-16", qayerdan: "Bektemir", qayerga: "Farg'ona", avto: "40 049 WBA", tel: "93 736 95 91", tashuvchi: "BIRODARLAR OLTIARIQ AVTO TRANS", inn: "308814088", buxgalter: "94 396 99 88", summa: 1120000 },
    { id: 8, buyurtmaId: "457EI", yetkazib: "VODIY STAR TRANS", sana: "2024-09-13", qayerdan: "Family", qayerga: "Namangan", avto: "50 804 EBA", tel: "50 072 30 00", tashuvchi: "BILOL HAMKOR MEGA TRANS", inn: "309829677", buxgalter: "97 252 55 00", summa: 2580000 },
    { id: 9, buyurtmaId: "229HU", yetkazib: "VODIY STAR TRANS", sana: "2024-09-13", qayerdan: "Family", qayerga: "Namangan", avto: "25 990 VAA", tel: "97 329 90 90", tashuvchi: "ATLANTIK CARGO", inn: "307674027", buxgalter: "93 650 71 79", summa: 1900000 },
    { id: 10, buyurtmaId: "277FA", yetkazib: "VODIY STAR TRANS", sana: "2024-09-17", qayerdan: "Bektemir", qayerga: "Havas", avto: "01 051 WLA", tel: "33 117 03 99", tashuvchi: "DELIVERSWIFT", inn: "310375762", buxgalter: "90 925 70 17", summa: 760000 },
    { id: 11, buyurtmaId: "554GG", yetkazib: "VODIY STAR TRANS", sana: "2024-09-17", qayerdan: "Bektemir", qayerga: "Namangan", avto: "50 320 NBA", tel: "97 467 80 09", tashuvchi: "ISTE'DOD TRANS", inn: "305930951", buxgalter: "90 050 13 01", summa: 1340000 },
    { id: 12, buyurtmaId: "717ZM", yetkazib: "VODIY STAR TRANS", sana: "2024-09-17", qayerdan: "Bektemir", qayerga: "Namangan", avto: "50 920 RBA", tel: "93 409 00 51", tashuvchi: "NURBEK CARGO TRANS", inn: "207111089", buxgalter: "99 315 00 11", summa: 2200000 },
    { id: 13, buyurtmaId: "229FP", yetkazib: "VODIY STAR TRANS", sana: "2024-09-17", qayerdan: "Bektemir", qayerga: "Namangan", avto: "50 654 NBA", tel: "94 706 99 77", tashuvchi: "ISTE'DOD TRANS", inn: "305930951", buxgalter: "90 050 13 01", summa: 990000 },
    { id: 14, buyurtmaId: "837QY", yetkazib: "VODIY STAR TRANS", sana: "2024-09-17", qayerdan: "Bektemir", qayerga: "Samarqand", avto: "30 677 YBA", tel: "93 341 54 56", tashuvchi: "MURODBEK PLUS", inn: "302421527", buxgalter: "97 912 47 40", summa: 1680000 },
];

const CURRENT_USER = "Asilbek";
const ROLE_OPTIONS = [
    { key: "operator", label: "Operator" },
    { key: "buxgalter", label: "Buxgalter" },
];
let ACTIVE_ROLE = "operator";

function actorName() {
    const roleLabel = ROLE_OPTIONS.find(r => r.key === ACTIVE_ROLE)?.label || ACTIVE_ROLE;
    return `${CURRENT_USER} (${roleLabel})`;
}

const AVAIL_OFFSETS = [14, 125, 47, 72, 8, 210, 22, 115, 33, 58, 240, 19, 160, 41].map(m => m * 60000);

const GROUP_MANAGERS = [
    "Jasur Toshmatov", "Dilnoza Yusupova", "Bobur Karimov", "Sarvar Nazarov",
    "Malika Ergasheva", "Otabek Xoliqov", "Zulfiya Mirzayeva", "Hamza Ismoilov",
    "Nodira Abdullayeva", "Ruslan Qodirov", "Feruza Rashidova", "Alisher Umarov",
    "Kamola Hasanova", "Bahrom Tursunov",
];

const GROUP_LIMITS = [45000000, 80000000, 32000000, 120000000, 55000000, 28000000, 67000000, 95000000, 41000000, 73000000, 88000000, 36000000, 62000000, 110000000];

const TRUCK_CAPACITY = {
    "SHOHJAHON OLTIARIQ TRANS": { fura: 3, ref: 1, tent: 2 },
    "BIRODARLAR OLTIARIQ AVTO TRANS": { fura: 5, ref: 2, tent: 3 },
    "KO'NGIL": { fura: 2, ref: 0, tent: 1 },
    "SHOXJAXON ISMOILJON DILYORBEK": { fura: 4, ref: 1, tent: 2 },
    "ANOR GOLD TRANS": { fura: 6, ref: 3, tent: 4 },
    "DELIVERSWIFT": { fura: 3, ref: 2, tent: 2 },
    "BILOL HAMKOR MEGA TRANS": { fura: 7, ref: 2, tent: 5 },
    "ATLANTIK CARGO": { fura: 4, ref: 1, tent: 3 },
    "ISTE'DOD TRANS": { fura: 5, ref: 2, tent: 3 },
    "NURBEK CARGO TRANS": { fura: 3, ref: 1, tent: 2 },
    "MURODBEK PLUS": { fura: 2, ref: 1, tent: 1 },
};

const YETKAZIB_OPTIONS = [...new Set(mockData.map(r => r.yetkazib))];

const GROUP_DEADLINES = ["2026-03-15", "2026-04-01", "2026-02-28", "2026-05-20", "2026-03-05", "2026-06-10", "2026-02-27", "2026-04-15", "2026-03-30", "2026-07-01", "2026-02-25", "2026-05-01", "2026-03-20", "2026-08-15"];

const INITIAL_SF_STATE = {
    "VODIY STAR TRANS||BIRODARLAR OLTIARIQ AVTO TRANS": {
        status: "banded", bandedAt: 1740722000000,
        history: [
            { type: "band", timestamp: "28.02.2026, 07:13", epoch: 1740722000000, author: "Asilbek (Operator)" },
            { type: "faktura", timestamp: "28.02.2026, 09:14", epoch: 1740729240000, author: "Asilbek (Buxgalter)", fileName: "faktura_birodarlar_001.pdf", hasQqs: false },
        ],
    },
    "VODIY STAR TRANS||ANOR GOLD TRANS": {
        status: "banded", bandedAt: 1740560000000,
        history: [
            { type: "band", timestamp: "26.02.2026, 12:13", epoch: 1740560000000, author: "Asilbek (Operator)" },
            { type: "faktura", timestamp: "26.02.2026, 14:32", epoch: 1740569520000, author: "Asilbek (Buxgalter)", fileName: "anor_faktura_fevral.pdf", hasQqs: true },
            { type: "faktura", timestamp: "28.02.2026, 10:05", epoch: 1740732300000, author: "Asilbek (Buxgalter)", fileName: "anor_faktura_qo'shimcha.pdf", hasQqs: false },
        ],
    },
    "VODIY STAR TRANS||DELIVERSWIFT": {
        status: "banded", bandedAt: 1740660000000,
        history: [
            { type: "band", timestamp: "27.02.2026, 14:40", epoch: 1740660000000, author: "Asilbek (Operator)" },
            { type: "faktura", timestamp: "27.02.2026, 16:48", epoch: 1740667680000, author: "Asilbek (Buxgalter)", fileName: "deliverswift_faktura.pdf", hasQqs: false },
        ],
    },
    "VODIY STAR TRANS||BILOL HAMKOR MEGA TRANS": {
        status: "banded", bandedAt: 1740650400000,
        history: [
            { type: "band", timestamp: "27.02.2026, 12:00", epoch: 1740650400000, author: "Asilbek (Operator)" },
            { type: "faktura", timestamp: "27.02.2026, 15:20", epoch: 1740662400000, author: "Asilbek (Buxgalter)", fileName: "bilol_hamkor_sf_001.pdf", hasQqs: false },
        ],
    },
    "VODIY STAR TRANS||NURBEK CARGO TRANS": {
        status: "banded", bandedAt: 1740736800000,
        history: [
            { type: "band", timestamp: "28.02.2026, 11:00", epoch: 1740736800000, author: "Asilbek (Operator)" },
            { type: "faktura", timestamp: "28.02.2026, 13:45", epoch: 1740746700000, author: "Asilbek (Buxgalter)", fileName: "nurbek_cargo_faktura.pdf", hasQqs: false },
        ],
    },
};
const SHARTNOMA_STATUS_OPTIONS = ["to'lov qilish jarayonida", "faktura jo'natmagan", "shartnoma tuzishda"];

function groupData(data) {
    const groups = {};
    data.forEach(row => {
        const key = row.yetkazib + "||" + row.tashuvchi;
        if (!groups[key]) groups[key] = { yetkazib: row.yetkazib, tashuvchi: row.tashuvchi, inn: row.inn, firmaKodi: row.inn, buxgalter: row.buxgalter, rows: [], jamiSumma: 0 };
        groups[key].rows.push(row);
        groups[key].jamiSumma += row.summa || 0;
    });
    return Object.values(groups).map((g, i) => ({
        ...g,
        manager: GROUP_MANAGERS[i % GROUP_MANAGERS.length],
        availableSince: Date.now() - (AVAIL_OFFSETS[i] ?? 30 * 60000),
        limit: GROUP_LIMITS[i % GROUP_LIMITS.length],
        muddat: GROUP_DEADLINES[i % GROUP_DEADLINES.length],
    }));
}

function nowStr() {
    return new Date().toLocaleString("uz-UZ", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

function fmtSum(n) {
    return n ? n.toLocaleString("uz-UZ") + " so'm" : "—";
}

// Returns the hasQqs value of the latest faktura for a group, or null if none
function groupLatestQqs(sfState, key) {
    const hist = sfState?.[key]?.history || [];
    const last = [...hist].reverse().find(h => h.type === "faktura");
    return last ? last.hasQqs !== false : null;
}

// Inline QQS tag to place right after a currency string
function QqsTag({ hasQqs }) {
    if (hasQqs === null || hasQqs === undefined) return null;
    return <span style={{ fontSize: 11, color: hasQqs ? "#4ade80" : "#fbbf24", marginLeft: 4 }}>({hasQqs ? "QQSli" : "QQS'siz"})</span>;
}

function normalizeShartnomaStatus(status) {
    return SHARTNOMA_STATUS_OPTIONS.includes(status) ? status : "shartnoma tuzishda";
}

function latestShartnoma(history = []) {
    for (let i = history.length - 1; i >= 0; i--) {
        if (history[i]?.type === "shartnoma" || history[i]?.type === "chernovik") return history[i]?.shartnoma || null;
    }
    return null;
}

function latestShartnomaDraft(history = []) {
    for (let i = history.length - 1; i >= 0; i--) {
        if (history[i]?.type === "chernovik") return true;
        if (history[i]?.type === "shartnoma") return false;
    }
    return false;
}

function getShartnomaStatus(groupKey, gState, sfState) {
    const contract = latestShartnoma(gState[groupKey]?.history || []);
    if (contract?.status) return normalizeShartnomaStatus(contract.status);
    const hasFaktura = (sfState[groupKey]?.history || []).some(h => h.type === "faktura");
    if (hasFaktura) return "to'lov qilish jarayonida";
    if (contract) return "faktura jo'natmagan";
    return "shartnoma tuzishda";
}

function getLastManualHistoryEntry(history = []) {
    for (let i = history.length - 1; i >= 0; i--) {
        const h = history[i];
        if (!h) continue;
        const text = typeof h.comment === "string" ? h.comment.trim() : "";
        if (!text) continue;
        return { type: h.type, text };
    }
    return null;
}

function getAllShartnomaDrafts(history = []) {
    const drafts = [];
    history.forEach((h, idx) => {
        if (h?.type === "chernovik" && h?.shartnoma) {
            drafts.push({ ...h.shartnoma, historyIndex: idx, draft: true, timestamp: h.timestamp, author: h.author });
        }
    });
    return drafts;
}

function getFinalizeShartnoma(history = []) {
    for (let i = history.length - 1; i >= 0; i--) {
        if (history[i]?.type === "shartnoma" && history[i]?.shartnoma) {
            return { ...history[i].shartnoma, historyIndex: i, draft: false, timestamp: history[i].timestamp, author: history[i].author };
        }
    }
    return null;
}

function DraftShartnomItem({ draft, onEdit, onDelete, onFinalize }) {
    return (
        <div style={{ background: "#0f1f30", border: "1px solid #1e3a5e", borderRadius: 10, padding: 14, marginBottom: 10 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <span style={{ fontSize: 11, fontWeight: 700, background: "#5a1f1f", color: "#f87171", padding: "3px 8px", borderRadius: 5 }}>CHERNOVIK</span>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#d8e6f4" }}>{draft.raqami || "Raqami bo'sh"}</div>
                </div>
                <div style={{ fontSize: 11, color: "#4e6a84" }}>{draft.sana ? new Date(draft.sana + "T00:00").toLocaleDateString("uz") : "Sana bo'sh"}</div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12, fontSize: 12, color: "#8aaac8" }}>
                <div><span style={{ color: "#2e4a5e" }}>Firma:</span> {draft.firma || "—"}</div>
                <div><span style={{ color: "#2e4a5e" }}>Summa:</span> {draft.summa ? fmtSum(draft.summa) : "—"}</div>
                <div><span style={{ color: "#2e4a5e" }}>Tugash:</span> {draft.tugash ? new Date(draft.tugash + "T00:00").toLocaleDateString("uz") : "—"}</div>
                <div><span style={{ color: "#2e4a5e" }}>Muallif:</span> {draft.author || "—"}</div>
            </div>
            <div style={{ display: "flex", gap: 7 }}>
                <button onClick={onEdit} style={{ flex: 1, background: "#1a3a60", border: "1px solid #2563eb", borderRadius: 6, padding: 8, fontSize: 12, color: "#7ec8f4", cursor: "pointer", fontWeight: 600 }}
                    onMouseEnter={e => e.currentTarget.style.background = "#1e4a80"}
                    onMouseLeave={e => e.currentTarget.style.background = "#1a3a60"}>
                    ✏️ Tahrir
                </button>
                <button onClick={onFinalize} style={{ flex: 1, background: "#14532d", border: "1px solid #22c55e", borderRadius: 6, padding: 8, fontSize: 12, color: "#86efac", cursor: "pointer", fontWeight: 600 }}
                    onMouseEnter={e => e.currentTarget.style.background = "#1a6a3a"}
                    onMouseLeave={e => e.currentTarget.style.background = "#14532d"}>
                    ✓ Yakunlash
                </button>
                <button onClick={onDelete} style={{ flex: 1, background: "#5a1f1f", border: "1px solid #dc2626", borderRadius: 6, padding: 8, fontSize: 12, color: "#f87171", cursor: "pointer", fontWeight: 600 }}
                    onMouseEnter={e => e.currentTarget.style.background = "#7f1d1d"}
                    onMouseLeave={e => e.currentTarget.style.background = "#5a1f1f"}>
                    🗑️ O'chirish
                </button>
            </div>
        </div>
    );
}

function FinalizedShartnomaCard({ shartnoma, onViewFile }) {
    return (
        <div style={{ background: "#081f2f", border: "2px solid #22c55e", borderRadius: 10, padding: 16, marginBottom: 10 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <span style={{ fontSize: 11, fontWeight: 700, background: "#14532d", color: "#86efac", padding: "4px 10px", borderRadius: 5 }}>✓ SHARTNOMA</span>
                    <div style={{ fontSize: 14, fontWeight: 600, color: "#d8e6f4" }}>{shartnoma.raqami || "Raqami bo'sh"}</div>
                </div>
                <div style={{ fontSize: 11, color: "#4e6a84" }}>{shartnoma.sana ? new Date(shartnoma.sana + "T00:00").toLocaleDateString("uz") : "Sana bo'sh"}</div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 12, fontSize: 13, color: "#8aaac8" }}>
                <div><span style={{ color: "#2e4a5e", fontWeight: 600 }}>Firma:</span> <span style={{ color: "#c2d0df" }}>{shartnoma.firma || "—"}</span></div>
                <div><span style={{ color: "#2e4a5e", fontWeight: 600 }}>Summa:</span> <span style={{ color: "#c2d0df" }}>{shartnoma.summa ? fmtSum(shartnoma.summa) : "—"}</span></div>
                <div><span style={{ color: "#2e4a5e", fontWeight: 600 }}>Tugash:</span> <span style={{ color: "#c2d0df" }}>{shartnoma.tugash ? new Date(shartnoma.tugash + "T00:00").toLocaleDateString("uz") : "—"}</span></div>
                <div><span style={{ color: "#2e4a5e", fontWeight: 600 }}>INN:</span> <span style={{ color: "#c2d0df" }}>{shartnoma.inn || "—"}</span></div>
                <div style={{ gridColumn: "1 / -1" }}><span style={{ color: "#2e4a5e", fontWeight: 600 }}>Buxgalter:</span> <span style={{ color: "#c2d0df" }}>{shartnoma.buxgalter || "—"}</span></div>
            </div>
            {shartnoma.shFile && (
                <button onClick={onViewFile} style={{ width: "100%", background: "#1a3a60", border: "1px solid #2563eb", borderRadius: 6, padding: 8, fontSize: 12, color: "#7ec8f4", cursor: "pointer", fontWeight: 600 }}
                    onMouseEnter={e => e.currentTarget.style.background = "#1e4a80"}
                    onMouseLeave={e => e.currentTarget.style.background = "#1a3a60"}>
                    📄 Fayl ko'rish: {shartnoma.shFile}
                </button>
            )}
        </div>
    );
}

function ShartnomaListManager({ group, gState, dispatch }) {
    const [showDialog, setShowDialog] = useState(false);
    const [editingDraft, setEditingDraft] = useState(null);
    const history = gState.history || [];
    const drafts = getAllShartnomaDrafts(history);
    const finalized = getFinalizeShartnoma(history);

    const handleEditDraft = (draft) => {
        setEditingDraft(draft);
        setShowDialog(true);
    };

    const handleDeleteDraft = (historyIndex) => {
        dispatch({ type: "DELETE_CHERNOVIK", key: group.ya + "||" + group.ta, historyIndex });
    };

    const handleFinalizeDraft = (historyIndex) => {
        dispatch({ type: "FINALIZE_CHERNOVIK", key: group.ya + "||" + group.ta, historyIndex });
    };

    const handleSaveDraft = (data) => {
        if (editingDraft) {
            dispatch({
                type: "UPDATE_CHERNOVIK",
                key: group.ya + "||" + group.ta,
                historyIndex: editingDraft.historyIndex,
                form: data.form,
                author: actorName(),
            });
        } else {
            dispatch({
                type: "SHARTNOMA",
                key: group.ya + "||" + group.ta,
                form: { ...data.form, chernovik: true },
                author: actorName(),
            });
        }
        setEditingDraft(null);
        setShowDialog(false);
    };

    return (
        <>
            <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
                <button onClick={() => { setEditingDraft(null); setShowDialog(true); }}
                    style={{ background: "#1a3a60", border: "1px solid #2563eb", borderRadius: 7, padding: "8px 14px", fontSize: 12, color: "#7ec8f4", cursor: "pointer", fontWeight: 600 }}
                    onMouseEnter={e => e.currentTarget.style.background = "#1e4a80"}
                    onMouseLeave={e => e.currentTarget.style.background = "#1a3a60"}>
                    + Yangi chernovik
                </button>
            </div>

            {drafts.length === 0 && !finalized && (
                <div style={{ textAlign: "center", padding: 28, background: "#0a1520", border: "1px dashed #1e3a5e", borderRadius: 10, fontSize: 13, color: "#4e6a84" }}>
                    Hali shartnoma yo'q. Yangi chernovik yaratishni boshlang.
                </div>
            )}

            {drafts.map((draft) => (
                <DraftShartnomItem key={draft.historyIndex}
                    draft={draft}
                    onEdit={() => handleEditDraft(draft)}
                    onDelete={() => handleDeleteDraft(draft.historyIndex)}
                    onFinalize={() => handleFinalizeDraft(draft.historyIndex)}
                />
            ))}

            {finalized && (
                <FinalizedShartnomaCard shartnoma={finalized}
                    onViewFile={() => window.open(finalized.shFile, "_blank")}
                />
            )}

            {showDialog && (
                <ShartnomDialog
                    group={group}
                    editingDraft={editingDraft}
                    onSave={handleSaveDraft}
                    onClose={() => { setShowDialog(false); setEditingDraft(null); }}
                />
            )}
        </>
    );
}

// ── Elapsed timer badge ───────────────────────────────────────────────────────
function ElapsedBadge({ since }) {
    const [elapsed, setElapsed] = useState(Date.now() - since);
    useEffect(() => {
        const id = setInterval(() => setElapsed(Date.now() - since), 1000);
        return () => clearInterval(id);
    }, [since]);
    const h = Math.floor(elapsed / 3600000);
    const m = Math.floor((elapsed % 3600000) / 60000);
    const s = Math.floor((elapsed % 60000) / 1000);
    const label = h > 0 ? `${h}s ${m}d` : m > 0 ? `${m}d ${s}s` : `${s}s`;
    const urgent = elapsed > 7200000;
    const warn = elapsed > 3600000;
    return (
        <span style={{
            fontSize: 11, fontWeight: 700, borderRadius: 5, padding: "2px 8px",
            background: urgent ? "#3f0d0d" : warn ? "#3f2e00" : "#0a2040",
            color: urgent ? "#f87171" : warn ? "#fbbf24" : "#60a5fa",
            border: `1px solid ${urgent ? "#c0392b44" : warn ? "#b4580044" : "#2563eb44"}`,
            whiteSpace: "nowrap"
        }}>⏱ {label}</span>
    );
}

// ── Available-since badge ────────────────────────────────────────────────────
function AvailableBadge({ since }) {
    const [elapsed, setElapsed] = useState(Date.now() - since);
    useEffect(() => {
        const id = setInterval(() => setElapsed(Date.now() - since), 60000);
        return () => clearInterval(id);
    }, [since]);
    const h = Math.floor(elapsed / 3600000);
    const m = Math.floor((elapsed % 3600000) / 60000);
    const label = h > 0 ? `${h}s ${m}d` : `${m}d`;
    const urgent = elapsed > 2 * 3600000;
    const warn = elapsed > 1 * 3600000;
    return (
        <span title="Mavjud bo'lgan vaqt" style={{
            fontSize: 11, fontWeight: 600, borderRadius: 5, padding: "2px 8px",
            background: urgent ? "#3f0d0d" : warn ? "#2e2000" : "#0a1825",
            color: urgent ? "#f87171" : warn ? "#fbbf24" : "#94a3b8",
            border: `1px solid ${urgent ? "#7f1d1d" : warn ? "#78350f" : "#1e3a5e"}`,
            whiteSpace: "nowrap", display: "inline-flex", alignItems: "center", gap: 4
        }}>
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
            {label}
        </span>
    );
}

// ── Icons (using lucide-react) ───────────────────────────────────────────────
const TableIcon = () => <Table size={15} strokeWidth={2} />;
const GridIcon = () => <Grid3x3 size={15} strokeWidth={2} />;
const HistoryIcon = () => <History size={14} strokeWidth={2} />;
const SearchIcon = () => <Search size={14} strokeWidth={2} />;
const UserIcon = () => <User size={12} strokeWidth={2} />;
const UploadIcon = () => <Upload size={18} strokeWidth={2} />;
const PdfIcon = () => <FileJson size={20} strokeWidth={1.8} />;
const ClockIcon = () => <Clock size={10} strokeWidth={2.5} />;
const InfoIcon = () => <Info size={12} strokeWidth={2.5} />;

// ── PDF Upload Modal ──────────────────────────────────────────────────────────
function PdfUploadModal({ title, onClose, onSend }) {
    const [file, setFile] = useState(null);
    const [sending, setSending] = useState(false);
    const [success, setSuccess] = useState(false);
    const [drag, setDrag] = useState(false);
    const inputRef = useRef(null);

    const handleFile = (f) => {
        if (f && f.type === "application/pdf") setFile(f);
        else if (f) alert("Faqat PDF fayl qabul qilinadi");
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDrag(false);
        const f = e.dataTransfer.files[0];
        handleFile(f);
    };

    const handleSend = () => {
        if (!file) return;
        setSending(true);
        setTimeout(() => {
            setSending(false);
            setSuccess(true);
            if (onSend) onSend(file.name);
        }, 1800);
    };

    return (
        <div onClick={!success ? onClose : undefined}
            style={{ position: "fixed", inset: 0, background: "#00000099", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
            <div onClick={e => e.stopPropagation()}
                style={{ background: "#0d1825", border: "1px solid #1e3a5e", borderRadius: 12, padding: 28, width: 380, boxShadow: "0 8px 40px #000000cc" }}>
                {success ? (
                    <div style={{ textAlign: "center", padding: "10px 0" }}>
                        <div style={{ fontSize: 48, marginBottom: 14 }}>✅</div>
                        <div style={{ fontSize: 16, fontWeight: 700, color: "#6ee7a0", marginBottom: 8 }}>Muvaffaqiyatli yuborildi!</div>
                        <div style={{ fontSize: 13, color: "#4e6a84", marginBottom: 22 }}>{file?.name} fayl qabul qilindi.</div>
                        <button onClick={onClose}
                            style={{ background: "#1a4a2a", border: "1px solid #22c55e55", borderRadius: 8, padding: "8px 28px", fontSize: 13, color: "#6ee7a0", cursor: "pointer", fontWeight: 600 }}>
                            Yopish
                        </button>
                    </div>
                ) : (
                    <>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
                            <div style={{ fontSize: 14, fontWeight: 700, color: "#d8e6f4" }}>{title || "Faktura yuklash"}</div>
                            <button onClick={onClose} style={{ background: "transparent", border: "none", color: "#4e6a84", fontSize: 20, cursor: "pointer", lineHeight: 1 }}>×</button>
                        </div>

                        {/* Drop zone */}
                        <div
                            onClick={() => inputRef.current?.click()}
                            onDragOver={e => { e.preventDefault(); setDrag(true); }}
                            onDragLeave={() => setDrag(false)}
                            onDrop={handleDrop}
                            style={{
                                border: `2px dashed ${drag ? "#2563eb" : file ? "#22c55e55" : "#1e3a5e"}`,
                                borderRadius: 10, padding: "28px 20px", textAlign: "center", cursor: "pointer",
                                background: drag ? "#0a1e38" : file ? "#0a1e14" : "#08111d",
                                transition: "all 0.2s", marginBottom: 18
                            }}>
                            <input ref={inputRef} type="file" accept=".pdf" style={{ display: "none" }}
                                onChange={e => handleFile(e.target.files[0])} />
                            {file ? (
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
                                    <span style={{ color: "#22c55e" }}><PdfIcon /></span>
                                    <div style={{ textAlign: "left" }}>
                                        <div style={{ fontSize: 13, fontWeight: 600, color: "#6ee7a0" }}>{file.name}</div>
                                        <div style={{ fontSize: 11, color: "#4e6a84" }}>{(file.size / 1024).toFixed(1)} KB</div>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div style={{ color: "#2563eb", marginBottom: 8, display: "flex", justifyContent: "center" }}><UploadIcon /></div>
                                    <div style={{ fontSize: 13, color: "#6a8aaa", marginBottom: 4 }}>PDF faylni shu yerga tashlang</div>
                                    <div style={{ fontSize: 12, color: "#3e5a74" }}>yoki bosib tanlang</div>
                                </div>
                            )}
                        </div>

                        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                            <button onClick={onClose}
                                style={{ background: "transparent", border: "1px solid #1e3a5e", borderRadius: 6, padding: "7px 18px", fontSize: 13, color: "#4e6a84", cursor: "pointer" }}>
                                Bekor
                            </button>
                            <button onClick={handleSend} disabled={!file || sending}
                                style={{
                                    background: file ? "#1a56c4" : "#0f2035", border: "none", borderRadius: 6, padding: "7px 20px", fontSize: 13,
                                    color: file ? "#fff" : "#3e5a74", cursor: file ? "pointer" : "not-allowed", fontWeight: 600, display: "flex", alignItems: "center", gap: 8, transition: "background 0.2s"
                                }}
                                onMouseEnter={e => { if (file && !sending) e.currentTarget.style.background = "#1e66e8"; }}
                                onMouseLeave={e => { if (file) e.currentTarget.style.background = "#1a56c4"; }}
                            >
                                {sending ? (
                                    <>
                                        <span style={{ display: "inline-block", width: 12, height: 12, border: "2px solid #ffffff55", borderTopColor: "#fff", borderRadius: "50%", animation: "spin 0.7s linear infinite" }} />
                                        Yuborilmoqda...
                                    </>
                                ) : "Yuborish"}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

// ── Comment Dialog ────────────────────────────────────────────────────────────
function CommentDialog({ title, subtitle, onSave, onClose, danger }) {
    const [val, setVal] = useState("");
    return (
        <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "#00000099", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
            <div onClick={e => e.stopPropagation()} style={{ background: "#0d1825", border: `1px solid ${danger ? "#c0392b55" : "#78350f55"}`, borderRadius: 10, padding: 24, width: 360, boxShadow: "0 8px 40px #000000cc" }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: danger ? "#f87171" : "#fbbf24", marginBottom: 6 }}>{title || "Sabab"}</div>
                <div style={{ fontSize: 12, color: "#4e6a84", marginBottom: 14 }}>{subtitle || "Nima sababdan?"}</div>
                <textarea autoFocus value={val} onChange={e => setVal(e.target.value)} placeholder="Sabab yozing..."
                    style={{ width: "100%", height: 90, background: "#08111d", border: `1px solid ${danger ? "#c0392b44" : "#78350f44"}`, borderRadius: 7, padding: "10px 12px", fontSize: 13, color: "#c2d0df", resize: "vertical", outline: "none", fontFamily: "inherit" }} />
                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 14 }}>
                    <button onClick={onClose} style={{ background: "transparent", border: "1px solid #1e3a5e", borderRadius: 6, padding: "6px 16px", fontSize: 13, color: "#4e6a84", cursor: "pointer" }}>Bekor</button>
                    <button onClick={() => { onSave(val.trim()); onClose(); }}
                        style={{ background: danger ? "#7f1d1d" : "#78350f", border: `1px solid ${danger ? "#c0392b" : "#b45309"}`, borderRadius: 6, padding: "6px 16px", fontSize: 13, color: danger ? "#fca5a5" : "#fde68a", cursor: "pointer", fontWeight: 600 }}>Saqlash</button>
                </div>
            </div>
        </div>
    );
}

// ── Shartnoma Dialog ──────────────────────────────────────────────────────────
function ShartnomDialog({ group, onSave, onClose, editingDraft = null }) {
    const [yetkazib, setYetkazib] = useState(editingDraft?.yetkazib || group.yetkazib);
    const [form, setForm] = useState({
        raqami: editingDraft?.raqami || "",
        sana: editingDraft?.sana || "",
        summa: editingDraft?.summa || "",
        tugash: editingDraft?.tugash || "",
        firma: editingDraft?.firma || group.tashuvchi,
        buxgalter: editingDraft?.buxgalter || group.buxgalter,
        inn: editingDraft?.inn || group.inn,
    });
    const [hasLimit, setHasLimit] = useState(editingDraft?.limitEnabled ?? false);
    const [file, setFile] = useState(null);
    const [fileErr, setFileErr] = useState("");
    const [extraRows, setExtraRows] = useState(editingDraft?.extraRows || []);
    const fileInputRef = useRef(null);
    const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

    const handleFile = (f) => {
        if (!f) { setFile(null); setFileErr(""); return; }
        if (f.type !== "application/pdf") { setFile(null); setFileErr("Faqat PDF fayl tanlang"); return; }
        setFile(f); setFileErr("");
    };

    const addRow = () => setExtraRows(r => [...r, { id: Date.now(), avtoRaqami: "", avtoTuri: "fura" }]);
    const removeRow = (id) => setExtraRows(r => r.filter(x => x.id !== id));
    const setRow = (id, k, v) => setExtraRows(r => r.map(x => x.id === id ? { ...x, [k]: v } : x));

    const buildPayload = () => ({
        ...form,
        yetkazib,
        summa: hasLimit ? form.summa : "",
        limitEnabled: hasLimit,
        extraRows,
    });

    const handleSubmit = (isDraft) => {
        const payload = buildPayload();
        onSave({ form: { ...payload, chernovik: isDraft }, fileName: file?.name || "" });
        onClose();
    };

    const inp = { width: "100%", background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 7, padding: "9px 12px", fontSize: 13, color: "#c2d0df", outline: "none", fontFamily: "inherit", colorScheme: "dark" };
    const lbl = { fontSize: 13, color: "#8aaac8", marginBottom: 5, display: "block" };
    const inpSm = { background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 6, padding: "7px 10px", fontSize: 12, color: "#c2d0df", outline: "none", fontFamily: "inherit" };
    const fields = [
        { label: "Shartnoma raqami", key: "raqami", type: "text" },
        { label: "Shartnoma sanasi", key: "sana", type: "date" },
        { label: "Shartnoma tugash sanasi", key: "tugash", type: "date" },
        { label: "Tashuvchi firma nomi", key: "firma", type: "text" },
        { label: "Buxgalter raqami", key: "buxgalter", type: "text" },
        { label: "Tashuvchi INN", key: "inn", type: "text" },
    ];
    return (
        <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "#00000099", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, overflowY: "auto", padding: "20px 0" }}>
            <div onClick={e => e.stopPropagation()} style={{ background: "#0d1825", border: "1px solid #1e3a5e", borderRadius: 12, padding: 28, width: 440, boxShadow: "0 8px 40px #000000cc", maxHeight: "90vh", overflowY: "auto" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 22 }}>
                    <div style={{ fontSize: 16, fontWeight: 700, color: "#d8e6f4" }}>
                        Shartnoma ma'lumotlari {editingDraft && <span style={{ fontSize: 12, color: "#fbbf24" }}>- TAHRIR</span>}
                    </div>
                    <button onClick={onClose} style={{ background: "transparent", border: "none", color: "#4e6a84", fontSize: 20, cursor: "pointer", lineHeight: 1 }}>×</button>
                </div>

                {/* Yetkazib beruvchi selector */}
                <div style={{ marginBottom: 14 }}>
                    <label style={lbl}>Yetkazib beruvchi</label>
                    <select value={yetkazib} onChange={e => setYetkazib(e.target.value)}
                        style={{ ...inp, colorScheme: "dark" }}>
                        {YETKAZIB_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                </div>

                <div style={{ marginBottom: 14 }}>
                    <label style={lbl}>Shartnoma summasi</label>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 8 }}>
                        <label style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12, color: "#9fb7cc", cursor: "pointer" }}>
                            <input type="radio" name="summaLimit" checked={hasLimit} onChange={() => setHasLimit(true)} />
                            Limit belgilanadi
                        </label>
                        <label style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12, color: "#9fb7cc", cursor: "pointer" }}>
                            <input type="radio" name="summaLimit" checked={!hasLimit} onChange={() => { setHasLimit(false); set("summa", ""); }} />
                            Limit belgilanmaydi
                        </label>
                    </div>
                    {hasLimit && (
                        <input type="text" value={form.summa} onChange={e => set("summa", e.target.value)}
                            placeholder="Masalan: 50000000" style={inp} />
                    )}
                </div>

                <div style={{ marginBottom: 14 }}>
                    <label style={lbl}>Shartnoma fayli (PDF)</label>
                    <input ref={fileInputRef} type="file" accept=".pdf" style={{ display: "none" }}
                        onChange={e => handleFile(e.target.files?.[0])} />
                    <div style={{ display: "flex", gap: 8 }}>
                        <button type="button" onClick={() => fileInputRef.current?.click()}
                            style={{ background: "#0a1825", border: "1px solid #1e3a5e", borderRadius: 7, padding: "8px 12px", fontSize: 12, color: "#8aaac8", cursor: "pointer", fontWeight: 600 }}>
                            Fayl tanlash
                        </button>
                        <div style={{ flex: 1, minWidth: 0, background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 7, padding: "8px 10px", fontSize: 12, color: file ? "#93c5fd" : "#4e6a84", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {file?.name || "Fayl tanlanmagan"}
                        </div>
                    </div>
                    {fileErr && <div style={{ marginTop: 6, fontSize: 11, color: "#f87171" }}>{fileErr}</div>}
                </div>

                {fields.map(({ label, key, type }) => (
                    <div key={key} style={{ marginBottom: 14 }}>
                        <label style={lbl}>{label}</label>
                        <input type={type} value={form[key]} onChange={e => set(key, e.target.value)} placeholder={label} style={inp} />
                    </div>
                ))}

                {/* Dynamic rows — avtomobillar */}
                <div style={{ marginBottom: 14 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                        <label style={{ ...lbl, marginBottom: 0 }}>Tashuvchi avtomobillari</label>
                        <button type="button" onClick={addRow}
                            style={{ background: "#0a1825", border: "1px solid #1e3a5e", borderRadius: 6, padding: "4px 10px", fontSize: 12, color: "#7ec8f4", cursor: "pointer", fontWeight: 600 }}>
                            + Qo'shish
                        </button>
                    </div>
                    {extraRows.length === 0 && (
                        <div style={{ fontSize: 12, color: "#2e4a5e", fontStyle: "italic", padding: "6px 0" }}>Avtomobil qo'shilmagan</div>
                    )}
                    {extraRows.map((row) => (
                        <div key={row.id} style={{ display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: 6, marginBottom: 6, alignItems: "center" }}>
                            <input placeholder="Avto raqami" value={row.avtoRaqami} onChange={e => setRow(row.id, "avtoRaqami", e.target.value)} style={inpSm} />
                            <select value={row.avtoTuri} onChange={e => setRow(row.id, "avtoTuri", e.target.value)}
                                style={{ ...inpSm, colorScheme: "dark" }}>
                                <option value="fura">Fura</option>
                                <option value="tent">Tent</option>
                                <option value="isuzu5">Isuzu 5</option>
                                <option value="isuzu10">Isuzu 10</option>
                                <option value="ref">Ref</option>
                            </select>
                            <button type="button" onClick={() => removeRow(row.id)}
                                style={{ background: "transparent", border: "1px solid #7f1d1d", borderRadius: 5, padding: "5px 8px", fontSize: 13, color: "#f87171", cursor: "pointer" }}>✕</button>
                        </div>
                    ))}
                </div>

                <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
                    {editingDraft ? (
                        <>
                            <button onClick={() => handleSubmit(true)}
                                style={{ flex: 1, background: "#1a3a60", border: "1px solid #2563eb", borderRadius: 8, padding: 11, fontSize: 13, color: "#7ec8f4", cursor: "pointer", fontWeight: 600 }}
                                onMouseEnter={e => { e.currentTarget.style.background = "#1e4a80"; }}
                                onMouseLeave={e => { e.currentTarget.style.background = "#1a3a60"; }}
                            >💾 Saqlash</button>
                            <button onClick={() => handleSubmit(false)}
                                style={{ flex: 1, background: "#14532d", border: "1px solid #22c55e", borderRadius: 8, padding: 11, fontSize: 13, color: "#86efac", cursor: "pointer", fontWeight: 600 }}
                                onMouseEnter={e => { e.currentTarget.style.background = "#1a6a3a"; }}
                                onMouseLeave={e => { e.currentTarget.style.background = "#14532d"; }}
                            >✓ YAKUNLASH</button>
                        </>
                    ) : (
                        <>
                            <button onClick={() => handleSubmit(true)}
                                style={{ flex: 1, background: "#0f2035", border: "1px solid #1e3a5e", borderRadius: 8, padding: 11, fontSize: 13, color: "#8aaac8", cursor: "pointer", fontWeight: 600 }}
                                onMouseEnter={e => { e.currentTarget.style.background = "#152840"; }}
                                onMouseLeave={e => { e.currentTarget.style.background = "#0f2035"; }}
                            >📝 Chernovik</button>
                            <button onClick={() => handleSubmit(false)}
                                style={{ flex: 2, background: "#1a56c4", border: "none", borderRadius: 8, padding: 11, fontSize: 14, color: "#fff", cursor: "pointer", fontWeight: 600 }}
                                onMouseEnter={e => e.currentTarget.style.background = "#1e66e8"}
                                onMouseLeave={e => e.currentTarget.style.background = "#1a56c4"}
                            >✓ Tasdiqlash</button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

// ── History Dialog ────────────────────────────────────────────────────────────
function HistoryDialog({ group, history, onClose, onAddComment }) {
    const [showAddComment, setShowAddComment] = useState(false);
    const [comment, setComment] = useState("");
    const cfg = {
        band: { label: "🔒 Band qilindi", bg: "#0e2438", bdr: "#1a3d5c", clr: "#7ec8e3" },
        bekor: { label: "❌ Bekor qilindi", bg: "#200e0e", bdr: "#5c1a1a", clr: "#f87171" },
        shartnoma: { label: "✅ Shartnoma tuzildi", bg: "#0e2018", bdr: "#1a5c30", clr: "#6ee7a0" },
        chernovik: { label: "📝 Chernovik", bg: "#1a1200", bdr: "#5c3a00", clr: "#fbbf24" },
        qaytarilgan: { label: "⚠️ Qaytarilgan", bg: "#1e1000", bdr: "#7c3404", clr: "#fb923c" },
        faktura: { label: "📄 Faktura yuborildi", bg: "#0e1830", bdr: "#1a3060", clr: "#93c5fd" },
        sf_qaytarish: { label: "↩️ Qaytarildi", bg: "#1e0a00", bdr: "#7c2004", clr: "#fca5a5" },
        sh_file: { label: "📎 Shartnoma fayli", bg: "#0a1e38", bdr: "#1e3a6e", clr: "#93c5fd" },
        comment: { label: "💬 Izoh", bg: "#0a1b2f", bdr: "#1e3a5e", clr: "#7ec8f4" },
    };

    const saveComment = () => {
        const trimmed = comment.trim();
        if (!trimmed || !onAddComment) return;
        onAddComment(trimmed);
        setComment("");
        setShowAddComment(false);
    };

    return (
        <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "#00000099", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: "20px 0" }}>
            <div onClick={e => e.stopPropagation()} style={{ background: "#0d1825", border: "1px solid #1e3a5e", borderRadius: 12, padding: 24, width: 460, maxHeight: "80vh", display: "flex", flexDirection: "column", boxShadow: "0 8px 40px #000000cc" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
                    <div style={{ fontSize: 15, fontWeight: 700, color: "#d8e6f4" }}>Tarix</div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {onAddComment && (
                            <button
                                type="button"
                                onClick={() => setShowAddComment(v => !v)}
                                style={{ background: "transparent", border: "1px solid #1e3a5e", borderRadius: 6, padding: "5px 9px", fontSize: 12, color: "#7ec8f4", cursor: "pointer", fontWeight: 600 }}
                            >
                                + Izoh
                            </button>
                        )}
                        <button onClick={onClose} style={{ background: "transparent", border: "none", color: "#4e6a84", fontSize: 20, cursor: "pointer", lineHeight: 1 }}>×</button>
                    </div>
                </div>
                <div style={{ fontSize: 12, color: "#3e5a74", marginBottom: 18 }}>{group.tashuvchi}</div>
                {showAddComment && (
                    <div style={{ marginBottom: 12, background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 8, padding: 10 }}>
                        <textarea
                            autoFocus
                            value={comment}
                            onChange={e => setComment(e.target.value)}
                            placeholder="Izoh kiriting..."
                            style={{ width: "100%", minHeight: 64, background: "#060f1a", border: "1px solid #1e3a5e", borderRadius: 6, padding: "8px 10px", fontSize: 12, color: "#c2d0df", outline: "none", fontFamily: "inherit", resize: "vertical", marginBottom: 8 }}
                        />
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 6 }}>
                            <button
                                type="button"
                                onClick={() => { setShowAddComment(false); setComment(""); }}
                                style={{ background: "transparent", border: "1px solid #1e3a5e", borderRadius: 6, padding: "5px 10px", fontSize: 12, color: "#4e6a84", cursor: "pointer" }}
                            >
                                Bekor
                            </button>
                            <button
                                type="button"
                                onClick={saveComment}
                                disabled={!comment.trim()}
                                style={{ background: comment.trim() ? "#1a56c4" : "#0f2035", border: "1px solid #1e3a5e", borderRadius: 6, padding: "5px 10px", fontSize: 12, color: comment.trim() ? "#dbeafe" : "#4e6a84", cursor: comment.trim() ? "pointer" : "not-allowed", fontWeight: 600 }}
                            >
                                Saqlash
                            </button>
                        </div>
                    </div>
                )}
                <div style={{ overflowY: "auto", flex: 1, display: "flex", flexDirection: "column", gap: 10 }}>
                    {history.length === 0 && (
                        <div style={{ color: "#3e5a74", fontSize: 13, textAlign: "center", padding: "30px 0" }}>Hech qanday harakat yo'q</div>
                    )}
                    {[...history].reverse().map((h, i) => {
                        const c = cfg[h.type] || cfg.band;
                        return (
                            <div key={i} style={{ background: c.bg, border: "1px solid " + c.bdr, borderRadius: 8, padding: "12px 14px" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
                                    <span style={{ fontSize: 13, fontWeight: 600, color: c.clr }}>{c.label}</span>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 2 }}>
                                        <span style={{ fontSize: 11, color: "#3e5a74" }}>{h.timestamp}</span>
                                        <span style={{ fontSize: 11, color: "#4e8ab0", fontWeight: 600 }}>👤 {h.author}</span>
                                    </div>
                                </div>
                                {h.comment && <div style={{ fontSize: 12, color: "#a0b8cc", background: "#0008", borderRadius: 5, padding: "6px 10px" }}>💬 {h.comment}</div>}
                                {h.shartnoma && (
                                    <div style={{ fontSize: 12, color: "#a0b8cc", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px 12px", marginTop: 4 }}>
                                        {[["Raqam", h.shartnoma.raqami], ["Sana", h.shartnoma.sana], ["Summa", h.shartnoma.summa], ["Tugash", h.shartnoma.tugash], ["Yetkazib", h.shartnoma.yetkazib]].map(([k, v]) => v ? (
                                            <div key={k}><span style={{ color: "#3e5a74" }}>{k}: </span>{v}</div>
                                        ) : null)}
                                    </div>
                                )}
                                {h.fileName && <div style={{ fontSize: 12, color: "#93c5fd", marginTop: 4 }}>📎 {h.fileName}</div>}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}


// ── Truck Capacity Modal ──────────────────────────────────────────────────────
function TruckCapacityModal({ tashuvchi, onClose }) {
    const cap = TRUCK_CAPACITY[tashuvchi] || { fura: 0, ref: 0, tent: 0 };
    const total = cap.fura + cap.ref + cap.tent;
    const types = [
        { key: "fura", label: "Fura", icon: "🚛", color: "#60a5fa", bg: "#0a1e38", bdr: "#1e3a6e" },
        { key: "ref", label: "Ref (sovutgich)", icon: "❄️", color: "#7ec8f4", bg: "#081e2a", bdr: "#1a4060" },
        { key: "tent", label: "Tent", icon: "🚐", color: "#a78bfa", bg: "#1a0c28", bdr: "#3b1f6e" },
    ];
    return (
        <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "#00000099", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
            <div onClick={e => e.stopPropagation()} style={{ background: "#0d1825", border: "1px solid #1e3a5e", borderRadius: 12, padding: 26, width: 340, boxShadow: "0 8px 40px #000000cc" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
                    <div>
                        <div style={{ fontSize: 14, fontWeight: 700, color: "#d8e6f4" }}>Truck hajmi</div>
                        <div style={{ fontSize: 11, color: "#4e6a84", marginTop: 2 }}>{tashuvchi}</div>
                    </div>
                    <button onClick={onClose} style={{ background: "transparent", border: "none", color: "#4e6a84", fontSize: 20, cursor: "pointer", lineHeight: 1 }}>×</button>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16 }}>
                    {types.map(t => (
                        <div key={t.key} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", background: t.bg, border: `1px solid ${t.bdr}`, borderRadius: 9 }}>
                            <span style={{ fontSize: 18 }}>{t.icon}</span>
                            <span style={{ flex: 1, fontSize: 13, color: t.color, fontWeight: 600 }}>{t.label}</span>
                            <span style={{ fontSize: 20, fontWeight: 800, color: t.color }}>{cap[t.key]}</span>
                            <span style={{ fontSize: 11, color: "#4e6a84" }}>ta</span>
                        </div>
                    ))}
                </div>
                <div style={{ textAlign: "center", fontSize: 12, color: "#8aaac8", background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 8, padding: "8px 0" }}>
                    Jami: <span style={{ fontWeight: 800, color: "#fbbf24", fontSize: 14 }}>{total} ta</span> truck
                </div>
            </div>
        </div>
    );
}

// ── Shared styles ─────────────────────────────────────────────────────────────
const cS = { padding: "9px 14px", fontSize: 13, color: "#c2d0df", borderBottom: "1px solid #172535", verticalAlign: "middle" };
const hS = { padding: "8px 14px", fontSize: 11, color: "#4e6a84", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", background: "#080f18", borderBottom: "1px solid #172535", whiteSpace: "nowrap", textAlign: "left" };

// ══════════════════════════════════════════════════════════════════════════════
// SHARTNOMA PAGE COMPONENTS (original)
// ══════════════════════════════════════════════════════════════════════════════

function GroupActions({ groupKey, group, groupState, dispatch }) {
    const [showShartnoma, setShowShartnoma] = useState(false);
    const [showBekor, setShowBekor] = useState(false);
    const [showHistory, setShowHistory] = useState(false);
    const isBanded = groupState.status === "banded";
    const histCount = groupState.history.length;
    const lastManualNote = getLastManualHistoryEntry(groupState.history);

    return (
        <>
            {showShartnoma && (
                <ShartnomDialog
                    group={group}
                    onSave={({ form, fileName }) => {
                        dispatch({ type: "SHARTNOMA", key: groupKey, form, author: actorName() });
                        if (fileName) dispatch({ type: "SH_FILE", key: groupKey, fileName, author: actorName() });
                    }}
                    onClose={() => setShowShartnoma(false)}
                />
            )}
            {showBekor && <CommentDialog danger title="Bekor qilish sababi" subtitle="Nima sababdan bekor qilayapsiz?" onSave={comment => dispatch({ type: "BEKOR", key: groupKey, comment, author: actorName() })} onClose={() => setShowBekor(false)} />}
            {showHistory && (
                <HistoryDialog
                    group={group}
                    history={groupState.history}
                    onClose={() => setShowHistory(false)}
                    onAddComment={comment => dispatch({ type: "ADD_COMMENT", key: groupKey, comment, author: actorName() })}
                />
            )}

            <div style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
                {isBanded && groupState.bandedAt && <ElapsedBadge since={groupState.bandedAt} />}
                <div style={{ position: "relative" }}>
                    <button onClick={e => { e.stopPropagation(); setShowHistory(true); }}
                        style={{ background: "#0a1825", border: "1px solid #1e3a5e", borderRadius: 6, padding: "6px 8px", color: "#4e6a84", cursor: "pointer", display: "flex", alignItems: "center" }}
                        onMouseEnter={e => { e.currentTarget.style.color = "#7ec8f4"; e.currentTarget.style.borderColor = "#2563eb66"; }}
                        onMouseLeave={e => { e.currentTarget.style.color = "#4e6a84"; e.currentTarget.style.borderColor = "#1e3a5e"; }}
                    ><HistoryIcon /></button>
                    {histCount > 0 && (
                        <span style={{ position: "absolute", top: -6, right: -6, background: "#1a56c4", color: "#fff", fontSize: 10, fontWeight: 700, borderRadius: "50%", width: 16, height: 16, display: "flex", alignItems: "center", justifyContent: "center", pointerEvents: "none" }}>
                            {histCount > 9 ? "9+" : histCount}
                        </span>
                    )}
                </div>
                {lastManualNote && (
                    <span
                        title={lastManualNote.text}
                        style={{ maxWidth: 190, fontSize: 11, color: "#8aaac8", background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 6, padding: "3px 8px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                        💬 {lastManualNote.text}
                    </span>
                )}
                <button onClick={e => { e.stopPropagation(); setShowShartnoma(true); }}
                    style={{ background: "transparent", border: "1px solid #1a3a5e", borderRadius: 6, padding: "5px 10px", fontSize: 15, color: "#3a6a9e", cursor: "pointer" }}
                    onMouseEnter={e => { e.currentTarget.style.color = "#22c55e"; e.currentTarget.style.borderColor = "#22c55e66"; }}
                    onMouseLeave={e => { e.currentTarget.style.color = "#3a6a9e"; e.currentTarget.style.borderColor = "#1a3a5e"; }}
                >✓</button>
                {isBanded ? (
                    <button onClick={e => { e.stopPropagation(); setShowBekor(true); }}
                        style={{ background: "#7f1d1d", border: "1px solid #c0392b", borderRadius: 6, padding: "5px 14px", fontSize: 12, color: "#fca5a5", cursor: "pointer", fontWeight: 600, whiteSpace: "nowrap" }}
                        onMouseEnter={e => e.currentTarget.style.background = "#991b1b"}
                        onMouseLeave={e => e.currentTarget.style.background = "#7f1d1d"}
                    >✕ Bekor qilish</button>
                ) : (
                    <button onClick={e => { e.stopPropagation(); dispatch({ type: "BAND", key: groupKey, author: actorName() }); }}
                        style={{ background: "#163a6e", border: "1px solid #1e5599", borderRadius: 6, padding: "5px 14px", fontSize: 12, color: "#7ec4f0", cursor: "pointer", fontWeight: 600, whiteSpace: "nowrap" }}
                        onMouseEnter={e => e.currentTarget.style.background = "#1a4a8a"}
                        onMouseLeave={e => e.currentTarget.style.background = "#163a6e"}
                    >+ Band qilish</button>
                )}
            </div>
        </>
    );
}

function SubTable({ rows, group }) {
    const [showPdf, setShowPdf] = useState(null);
    return (
        <>
            {showPdf !== null && <ShartnomDialog group={group} onSave={() => { }} onClose={() => setShowPdf(null)} />}
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr>
                        {["№", "Buyurtma ID", "Sana", "Qayerdan", "Qayerga", "Avtomobil", "Telefon", ""].map((h, i) => (
                            <th key={i} style={{ ...hS, paddingLeft: i === 0 ? 52 : 14 }}>{h}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, ri) => (
                        <tr key={row.id} style={{ background: ri % 2 === 0 ? "#070d18" : "#0a1320" }}
                            onMouseEnter={e => e.currentTarget.style.background = "#0c1e30"}
                            onMouseLeave={e => e.currentTarget.style.background = ri % 2 === 0 ? "#070d18" : "#0a1320"}
                        >
                            <td style={{ ...cS, color: "#4e6a84", width: 44, textAlign: "center", paddingLeft: 52 }}>{ri + 1}</td>
                            <td style={{ ...cS, fontWeight: 600 }}>{row.buyurtmaId}</td>
                            <td style={{ ...cS, color: "#6a8aaa" }}>{row.sana}</td>
                            <td style={cS}>{row.qayerdan}</td>
                            <td style={cS}>{row.qayerga}</td>
                            <td style={{ ...cS, color: "#4ba8e8" }}>{row.avto}</td>
                            <td style={cS}>{row.tel}</td>
                            <td style={{ ...cS, textAlign: "center" }}>
                                <button onClick={() => setShowPdf(ri)}
                                    style={{ background: "transparent", border: "1px solid #1a3a5e", borderRadius: 5, padding: "4px 10px", fontSize: 14, color: "#3a6a9e", cursor: "pointer" }}
                                    onMouseEnter={e => { e.currentTarget.style.color = "#22c55e"; e.currentTarget.style.borderColor = "#22c55e66"; }}
                                    onMouseLeave={e => { e.currentTarget.style.color = "#3a6a9e"; e.currentTarget.style.borderColor = "#1a3a5e"; }}
                                >✓</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
}

function TruckInfoBtn({ tashuvchi }) {
    const [show, setShow] = useState(false);
    const cap = TRUCK_CAPACITY[tashuvchi] || { fura: 0, ref: 0, tent: 0 };
    const total = cap.fura + cap.ref + cap.tent;
    return (
        <>
            {show && <TruckCapacityModal tashuvchi={tashuvchi} onClose={() => setShow(false)} />}
            <button onClick={e => { e.stopPropagation(); setShow(true); }} title="Truck capacity"
                style={{ display: "inline-flex", alignItems: "center", gap: 3, background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 5, padding: "2px 7px", fontSize: 11, color: "#6a8aaa", cursor: "pointer" }}
                onMouseEnter={e => { e.currentTarget.style.color = "#7ec8f4"; e.currentTarget.style.borderColor = "#2563eb66"; }}
                onMouseLeave={e => { e.currentTarget.style.color = "#6a8aaa"; e.currentTarget.style.borderColor = "#1e3a5e"; }}
            ><InfoIcon />{total} ta</button>
        </>
    );
}

function TableGroupRow({ group, groupKey, index, groupState, dispatch, sfReturned }) {
    const [open, setOpen] = useState(false);
    const isBanded = groupState.status === "banded";

    const bgNormal = index % 2 === 0 ? "#0b1520" : "#0d1825";
    let bg = open ? "#0a1e38" : bgNormal;
    if (isBanded) bg = index % 2 === 0 ? "#150c0a" : "#180e0a";
    if (sfReturned) bg = index % 2 === 0 ? "#1a0e1e" : "#1e1024";

    const hoverBg = isBanded ? "#1f1008" : sfReturned ? "#2a1438" : open ? "#0a1e38" : "#0f2035";
    const leftBorderColor = isBanded ? "#c0392b" : sfReturned ? "#a855f7" : open ? "#2563eb" : "transparent";

    return (
        <>
            <tr onClick={() => setOpen(o => !o)} style={{ cursor: "pointer", background: bg }}
                onMouseEnter={e => e.currentTarget.style.background = hoverBg}
                onMouseLeave={e => e.currentTarget.style.background = bg}
            >
                <td style={{ ...cS, color: "#4e6a84", width: 44, textAlign: "center" }}>{index + 1}</td>
                <td style={{ ...cS, color: "#7eb0d8", fontSize: 12 }}>{group.firmaKodi}</td>
                <td style={{ ...cS, fontWeight: 600, color: "#d8e6f4" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {isBanded && <span style={{ fontSize: 10, background: "#7f1d1d", color: "#fca5a5", borderRadius: 4, padding: "1px 6px", fontWeight: 700, flexShrink: 0 }}>BAND</span>}
                        {sfReturned && <span style={{ fontSize: 10, background: "#581c87", color: "#e9d5ff", borderRadius: 4, padding: "1px 6px", fontWeight: 700, flexShrink: 0, animation: "pulse 1.8s infinite" }}>📋 FAKTURADAN QAYTARILGAN</span>}
                        <span style={{ color: sfReturned ? "#d8b4fe" : "#d8e6f4" }}>{group.yetkazib}</span>
                    </div>
                </td>
                <td style={{ ...cS, fontWeight: 600, color: sfReturned ? "#c084fc" : "#4ba8e8" }}>{group.tashuvchi}</td>
                <td style={{ ...cS, color: "#7eb0d8", fontSize: 12 }}>{group.inn}</td>
                <td style={{ ...cS, color: "#7eb0d8", fontSize: 12 }}>{group.buxgalter}</td>
                <td style={{ ...cS, fontSize: 12 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 5, color: sfReturned ? "#a78bfa" : "#8aaac8" }}>
                        <UserIcon /><span>{group.manager}</span>
                    </div>
                </td>
                <td style={{ ...cS, textAlign: "right", paddingRight: 16 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 10 }}>
                        <TruckInfoBtn tashuvchi={group.tashuvchi} />
                        <span style={{ fontSize: 12, color: "#4e6a84" }}>{group.rows.length} ta</span>
                        <AvailableBadge since={group.availableSince} />
                        <GroupActions groupKey={groupKey} group={group} groupState={groupState} dispatch={dispatch} />
                        <span style={{ color: "#4e6a84", fontSize: 12, display: "inline-block", transition: "transform 0.2s", transform: open ? "rotate(90deg)" : "rotate(0deg)" }}>▶</span>
                    </div>
                </td>
            </tr>
            {open && (
                <tr>
                    <td colSpan={8} style={{ padding: 0, background: "#060d18", borderBottom: "2px solid #1a3a5e", borderLeft: `3px solid ${leftBorderColor}` }}>
                        <SubTable rows={group.rows} group={group} />
                    </td>
                </tr>
            )}
        </>
    );
}

function CardSubRow({ row, ri, group, totalRows }) {
    const [showDlg, setShowDlg] = useState(false);
    return (
        <>
            {showDlg && <ShartnomDialog group={group} onSave={() => { }} onClose={() => setShowDlg(false)} />}
            <div style={{ display: "grid", gridTemplateColumns: "22px 1fr 1fr 1fr auto", gap: "4px 12px", padding: "10px 16px", borderBottom: ri < totalRows - 1 ? "1px solid #0f1a28" : "none", background: ri % 2 === 0 ? "#070d18" : "#0a1320", alignItems: "center" }}
                onMouseEnter={e => e.currentTarget.style.background = "#0c1e30"}
                onMouseLeave={e => e.currentTarget.style.background = ri % 2 === 0 ? "#070d18" : "#0a1320"}
            >
                <span style={{ fontSize: 11, color: "#3e5a74" }}>{ri + 1}</span>
                <div><div style={{ fontSize: 12, fontWeight: 600, color: "#d8e6f4" }}>{row.buyurtmaId}</div><div style={{ fontSize: 11, color: "#4e6a84" }}>{row.sana}</div></div>
                <div><div style={{ fontSize: 12, color: "#c2d0df" }}>{row.qayerdan} → {row.qayerga}</div><div style={{ fontSize: 11, color: "#4ba8e8" }}>{row.avto}</div></div>
                <div style={{ fontSize: 12, color: "#c2d0df" }}>{row.tel}</div>
                <button onClick={() => setShowDlg(true)}
                    style={{ background: "transparent", border: "1px solid #1a3a5e", borderRadius: 5, padding: "4px 10px", fontSize: 14, color: "#3a6a9e", cursor: "pointer" }}
                    onMouseEnter={e => { e.currentTarget.style.color = "#22c55e"; e.currentTarget.style.borderColor = "#22c55e66"; }}
                    onMouseLeave={e => { e.currentTarget.style.color = "#3a6a9e"; e.currentTarget.style.borderColor = "#1a3a5e"; }}
                >✓</button>
            </div>
        </>
    );
}

function CardGroupItem({ group, groupKey, index, groupState, dispatch, sfReturned }) {
    const [open, setOpen] = useState(false);
    const isBanded = groupState.status === "banded";

    const borderColor = sfReturned ? "#a855f766" : isBanded ? "#c0392b55" : open ? "#2563eb55" : "#172535";
    const bgColor = sfReturned ? (open ? "#1e1030" : "#180c28") : open ? "#0a1e38" : "#0d1825";

    return (
        <div style={{ background: bgColor, border: `1px solid ${borderColor}`, borderRadius: 10, overflow: "hidden", transition: "border-color 0.2s, background 0.2s" }}>
            <div onClick={() => setOpen(o => !o)} style={{ padding: "14px 16px", cursor: "pointer", userSelect: "none" }}>
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 10 }}>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                        <span style={{ fontSize: 12, color: "#3e5a74", marginTop: 2, minWidth: 18 }}>{index + 1}</span>
                        <div>
                            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 3 }}>
                                {isBanded && <span style={{ fontSize: 10, background: "#7f1d1d", color: "#fca5a5", borderRadius: 4, padding: "1px 6px", fontWeight: 700 }}>BAND</span>}
                                {sfReturned && <span style={{ fontSize: 10, background: "#581c87", color: "#e9d5ff", borderRadius: 4, padding: "1px 6px", fontWeight: 700 }}>📋 FAKTURADAN QAYTARILGAN</span>}
                                <span style={{ fontSize: 13, fontWeight: 700, color: sfReturned ? "#d8b4fe" : "#d8e6f4" }}>{group.yetkazib}</span>
                            </div>
                            <div style={{ fontSize: 13, fontWeight: 600, color: sfReturned ? "#c084fc" : "#4ba8e8" }}>{group.tashuvchi}</div>
                        </div>
                    </div>
                    <span style={{ color: "#4e6a84", fontSize: 12, transition: "transform 0.2s", transform: open ? "rotate(90deg)" : "rotate(0deg)", marginTop: 3 }}>▶</span>
                </div>
                <div style={{ display: "flex", gap: "6px 20px", flexWrap: "wrap", marginBottom: 12, paddingLeft: 26 }}>
                    <div><div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>INN</div><div style={{ fontSize: 12, color: "#7eb0d8" }}>{group.inn}</div></div>
                    <div><div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>Buxgalter</div><div style={{ fontSize: 12, color: "#7eb0d8" }}>{group.buxgalter}</div></div>
                    <div>
                        <div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>Menejer</div>
                        <div style={{ fontSize: 12, color: sfReturned ? "#a78bfa" : "#8aaac8", display: "flex", alignItems: "center", gap: 4 }}><UserIcon />{group.manager}</div>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 8, paddingLeft: 26 }} onClick={e => e.stopPropagation()}>
                    <span style={{ fontSize: 12, color: "#4e6a84", marginRight: "auto" }}>{group.rows.length} ta</span>
                    <TruckInfoBtn tashuvchi={group.tashuvchi} />
                    <AvailableBadge since={group.availableSince} />
                    <GroupActions groupKey={groupKey} group={group} groupState={groupState} dispatch={dispatch} />
                </div>
            </div>
            {open && (
                <div style={{ borderTop: `1px solid ${sfReturned ? "#3a1a5e" : "#172535"}` }}>
                    {group.rows.map((row, ri) => (
                        <CardSubRow key={row.id} row={row} ri={ri} group={group} totalRows={group.rows.length} />
                    ))}
                </div>
            )}
        </div>
    );
}

// ══════════════════════════════════════════════════════════════════════════════
// SCHET FAKTURA PAGE COMPONENTS
// ══════════════════════════════════════════════════════════════════════════════

function SFGroupActions({ groupKey, group, groupState, dispatch }) {
    const [showPdf, setShowPdf] = useState(false);
    const [showBekor, setShowBekor] = useState(false);
    const [showQaytarish, setShowQaytarish] = useState(false);
    const [showHistory, setShowHistory] = useState(false);
    const isBanded = groupState.status === "banded";
    const isQaytarilgan = groupState.status === "sf_qaytarilgan";
    const histCount = groupState.history.length;
    const lastManualNote = getLastManualHistoryEntry(groupState.history);

    return (
        <>
            {showPdf && (
                <PdfUploadModal
                    title={`Faktura yuklash — ${group.tashuvchi}`}
                    onSend={fileName => dispatch({ type: "SF_FAKTURA", key: groupKey, fileName, author: actorName() })}
                    onClose={() => setShowPdf(false)}
                />
            )}
            {showBekor && (
                <CommentDialog danger title="Bekor qilish sababi" subtitle="Nima sababdan bekor qilayapsiz?"
                    onSave={comment => dispatch({ type: "SF_BEKOR", key: groupKey, comment, author: actorName() })}
                    onClose={() => setShowBekor(false)} />
            )}
            {showQaytarish && (
                <CommentDialog
                    title="↩️ Qaytarish sababi"
                    subtitle="Faktura bilan bog'liq muammoni tushuntiring"
                    onSave={comment => dispatch({ type: "SF_QAYTARISH", key: groupKey, comment, author: actorName() })}
                    onClose={() => setShowQaytarish(false)} />
            )}
            {showHistory && (
                <HistoryDialog
                    group={group}
                    history={groupState.history}
                    onClose={() => setShowHistory(false)}
                    onAddComment={comment => dispatch({ type: "SF_COMMENT", key: groupKey, comment, author: actorName() })}
                />
            )}

            <div style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
                {isBanded && groupState.bandedAt && <ElapsedBadge since={groupState.bandedAt} />}

                <div style={{ position: "relative" }}>
                    <button onClick={e => { e.stopPropagation(); setShowHistory(true); }}
                        style={{ background: "#0a1825", border: "1px solid #1e3a5e", borderRadius: 6, padding: "6px 8px", color: "#4e6a84", cursor: "pointer", display: "flex", alignItems: "center" }}
                        onMouseEnter={e => { e.currentTarget.style.color = "#7ec8f4"; e.currentTarget.style.borderColor = "#2563eb66"; }}
                        onMouseLeave={e => { e.currentTarget.style.color = "#4e6a84"; e.currentTarget.style.borderColor = "#1e3a5e"; }}
                    ><HistoryIcon /></button>
                    {histCount > 0 && (
                        <span style={{ position: "absolute", top: -6, right: -6, background: "#1a56c4", color: "#fff", fontSize: 10, fontWeight: 700, borderRadius: "50%", width: 16, height: 16, display: "flex", alignItems: "center", justifyContent: "center", pointerEvents: "none" }}>
                            {histCount > 9 ? "9+" : histCount}
                        </span>
                    )}
                </div>
                {lastManualNote && (
                    <span
                        title={lastManualNote.text}
                        style={{ maxWidth: 190, fontSize: 11, color: "#8aaac8", background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 6, padding: "3px 8px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                    >
                        💬 {lastManualNote.text}
                    </span>
                )}

                <button onClick={e => { e.stopPropagation(); setShowPdf(true); }}
                    title="Faktura yuklash"
                    style={{ background: "transparent", border: "1px solid #1a3a5e", borderRadius: 6, padding: "5px 10px", fontSize: 15, color: "#3a6a9e", cursor: "pointer" }}
                    onMouseEnter={e => { e.currentTarget.style.color = "#22c55e"; e.currentTarget.style.borderColor = "#22c55e66"; }}
                    onMouseLeave={e => { e.currentTarget.style.color = "#3a6a9e"; e.currentTarget.style.borderColor = "#1a3a5e"; }}
                >✓</button>

                {!isQaytarilgan && (
                    <button onClick={e => { e.stopPropagation(); setShowQaytarish(true); }}
                        title="Qaytarish"
                        style={{ background: "transparent", border: "1px solid #7c2004", borderRadius: 6, padding: "5px 10px", fontSize: 12, color: "#c23a0c", cursor: "pointer", fontWeight: 700, whiteSpace: "nowrap" }}
                        onMouseEnter={e => { e.currentTarget.style.background = "#1e0a00"; e.currentTarget.style.color = "#fca5a5"; }}
                        onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#c23a0c"; }}
                    >↩</button>
                )}

                {isBanded ? (
                    <button onClick={e => { e.stopPropagation(); setShowBekor(true); }}
                        style={{ background: "#7f1d1d", border: "1px solid #c0392b", borderRadius: 6, padding: "5px 14px", fontSize: 12, color: "#fca5a5", cursor: "pointer", fontWeight: 600, whiteSpace: "nowrap" }}
                        onMouseEnter={e => e.currentTarget.style.background = "#991b1b"}
                        onMouseLeave={e => e.currentTarget.style.background = "#7f1d1d"}
                    >✕ Bekor</button>
                ) : (
                    <button onClick={e => { e.stopPropagation(); dispatch({ type: "SF_BAND", key: groupKey, author: actorName() }); }}
                        style={{ background: "#163a6e", border: "1px solid #1e5599", borderRadius: 6, padding: "5px 14px", fontSize: 12, color: "#7ec4f0", cursor: "pointer", fontWeight: 600, whiteSpace: "nowrap" }}
                        onMouseEnter={e => e.currentTarget.style.background = "#1a4a8a"}
                        onMouseLeave={e => e.currentTarget.style.background = "#163a6e"}
                    >+ Band</button>
                )}
            </div>
        </>
    );
}

function SFSubTable({ rows, group, groupKey, dispatch, groupState }) {
    const [pdfRow, setPdfRow] = useState(null);
    return (
        <>
            {pdfRow !== null && (
                <PdfUploadModal
                    title={`Faktura — ${rows[pdfRow]?.buyurtmaId}`}
                    onSend={fileName => dispatch({ type: "SF_FAKTURA", key: groupKey, fileName, author: actorName() })}
                    onClose={() => setPdfRow(null)}
                />
            )}
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr>
                        {["№", "Buyurtma ID", "Sana", "Qayerdan", "Qayerga", "Avtomobil", "Telefon", "Summa", ""].map((h, i) => (
                            <th key={i} style={{ ...hS, paddingLeft: i === 0 ? 52 : 14 }}>{h}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, ri) => (
                        <tr key={row.id} style={{ background: ri % 2 === 0 ? "#070d18" : "#0a1320" }}
                            onMouseEnter={e => e.currentTarget.style.background = "#0c1e30"}
                            onMouseLeave={e => e.currentTarget.style.background = ri % 2 === 0 ? "#070d18" : "#0a1320"}
                        >
                            <td style={{ ...cS, color: "#4e6a84", width: 44, textAlign: "center", paddingLeft: 52 }}>{ri + 1}</td>
                            <td style={{ ...cS, fontWeight: 600 }}>{row.buyurtmaId}</td>
                            <td style={{ ...cS, color: "#6a8aaa" }}>{row.sana}</td>
                            <td style={cS}>{row.qayerdan}</td>
                            <td style={cS}>{row.qayerga}</td>
                            <td style={{ ...cS, color: "#4ba8e8" }}>{row.avto}</td>
                            <td style={cS}>{row.tel}</td>
                            <td style={{ ...cS, color: "#fbbf24", fontWeight: 600, fontSize: 12 }}>{fmtSum(row.summa)}<QqsTag hasQqs={(() => { const f = [...(groupState?.history||[])].reverse().find(h=>h.type==="faktura"); return f ? f.hasQqs !== false : null; })()} /></td>
                            <td style={{ ...cS, textAlign: "center" }}>
                                <button onClick={() => setPdfRow(ri)}
                                    title="Faktura yuklash"
                                    style={{ background: "transparent", border: "1px solid #1a3a5e", borderRadius: 5, padding: "4px 10px", fontSize: 14, color: "#3a6a9e", cursor: "pointer" }}
                                    onMouseEnter={e => { e.currentTarget.style.color = "#22c55e"; e.currentTarget.style.borderColor = "#22c55e66"; }}
                                    onMouseLeave={e => { e.currentTarget.style.color = "#3a6a9e"; e.currentTarget.style.borderColor = "#1a3a5e"; }}
                                >✓</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
}

function SFTableGroupRow({ group, groupKey, index, groupState, dispatch }) {
    const [open, setOpen] = useState(false);
    const isBanded = groupState.status === "banded";
    const isQaytarilgan = groupState.status === "sf_qaytarilgan";

    const bgNormal = index % 2 === 0 ? "#0b1520" : "#0d1825";
    let bg = open ? "#0a1e38" : bgNormal;
    if (isBanded) bg = index % 2 === 0 ? "#150c0a" : "#180e0a";
    if (isQaytarilgan) bg = index % 2 === 0 ? "#1e0500" : "#1a0400";

    const hoverBg = isBanded ? "#1f1008" : isQaytarilgan ? "#2a0600" : open ? "#0a1e38" : "#0f2035";
    const leftBorderColor = isBanded ? "#c0392b" : isQaytarilgan ? "#dc2626" : open ? "#2563eb" : "transparent";

    return (
        <>
            <tr onClick={() => setOpen(o => !o)} style={{ cursor: "pointer", background: bg }}
                onMouseEnter={e => e.currentTarget.style.background = hoverBg}
                onMouseLeave={e => e.currentTarget.style.background = bg}
            >
                <td style={{ ...cS, color: "#4e6a84", width: 44, textAlign: "center" }}>{index + 1}</td>
                <td style={{ ...cS, fontWeight: 600, color: "#d8e6f4" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {isBanded && <span style={{ fontSize: 10, background: "#7f1d1d", color: "#fca5a5", borderRadius: 4, padding: "1px 6px", fontWeight: 700, flexShrink: 0 }}>BAND</span>}
                        {isQaytarilgan && <span style={{ fontSize: 10, background: "#7f1d1d", color: "#fca5a5", borderRadius: 4, padding: "1px 6px", fontWeight: 700, flexShrink: 0 }}>↩️ QAYTARILGAN</span>}
                        <span style={{ color: isQaytarilgan ? "#fca5a5" : "#d8e6f4" }}>{group.yetkazib}</span>
                    </div>
                </td>
                <td style={{ ...cS, fontWeight: 600, color: isQaytarilgan ? "#f87171" : "#4ba8e8" }}>{group.tashuvchi}</td>
                <td style={{ ...cS, color: "#7eb0d8", fontSize: 12 }}>{group.inn}</td>
                <td style={{ ...cS, color: "#7eb0d8", fontSize: 12 }}>{group.buxgalter}</td>
                <td style={{ ...cS, fontSize: 12 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 5, color: "#8aaac8" }}>
                        <UserIcon /><span>{group.manager}</span>
                    </div>
                </td>
                <td style={{ ...cS, fontWeight: 700, fontSize: 13, color: "#fbbf24", whiteSpace: "nowrap" }}>
                    {fmtSum(group.jamiSumma)}<QqsTag hasQqs={(() => { const f = [...(groupState.history||[])].reverse().find(h=>h.type==="faktura"); return f ? f.hasQqs !== false : null; })()} />
                </td>
                <td style={{ ...cS, textAlign: "right", paddingRight: 16 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 10 }}>
                        <span style={{ fontSize: 12, color: "#4e6a84" }}>{group.rows.length} ta</span>
                        <AvailableBadge since={group.availableSince} />
                        <SFGroupActions groupKey={groupKey} group={group} groupState={groupState} dispatch={dispatch} />
                        <span style={{ color: "#4e6a84", fontSize: 12, display: "inline-block", transition: "transform 0.2s", transform: open ? "rotate(90deg)" : "rotate(0deg)" }}>▶</span>
                    </div>
                </td>
            </tr>
            {open && (
                <tr>
                    <td colSpan={8} style={{ padding: 0, background: "#060d18", borderBottom: "2px solid #1a3a5e", borderLeft: `3px solid ${leftBorderColor}` }}>
                        <SFSubTable rows={group.rows} group={group} groupKey={groupKey} dispatch={dispatch} groupState={groupState} />
                    </td>
                </tr>
            )}
        </>
    );
}

function SFCardSubRow({ row, ri, totalRows, groupState }) {
    const [showPdf, setShowPdf] = useState(false);
    return (
        <>
            {showPdf && <PdfUploadModal title={`Faktura — ${row.buyurtmaId}`} onClose={() => setShowPdf(false)} />}
            <div style={{ display: "grid", gridTemplateColumns: "22px 1fr 1fr 1fr 80px auto", gap: "4px 12px", padding: "10px 16px", borderBottom: ri < totalRows - 1 ? "1px solid #0f1a28" : "none", background: ri % 2 === 0 ? "#070d18" : "#0a1320", alignItems: "center" }}
                onMouseEnter={e => e.currentTarget.style.background = "#0c1e30"}
                onMouseLeave={e => e.currentTarget.style.background = ri % 2 === 0 ? "#070d18" : "#0a1320"}
            >
                <span style={{ fontSize: 11, color: "#3e5a74" }}>{ri + 1}</span>
                <div><div style={{ fontSize: 12, fontWeight: 600, color: "#d8e6f4" }}>{row.buyurtmaId}</div><div style={{ fontSize: 11, color: "#4e6a84" }}>{row.sana}</div></div>
                <div><div style={{ fontSize: 12, color: "#c2d0df" }}>{row.qayerdan} → {row.qayerga}</div><div style={{ fontSize: 11, color: "#4ba8e8" }}>{row.avto}</div></div>
                <div style={{ fontSize: 12, color: "#c2d0df" }}>{row.tel}</div>
                <div style={{ fontSize: 12, fontWeight: 600, color: "#fbbf24" }}>{fmtSum(row.summa)}<QqsTag hasQqs={(() => { const f = [...(groupState?.history||[])].reverse().find(h=>h.type==="faktura"); return f ? f.hasQqs !== false : null; })()} /></div>
                <button onClick={() => setShowPdf(true)}
                    title="Faktura yuklash"
                    style={{ background: "transparent", border: "1px solid #1a3a5e", borderRadius: 5, padding: "4px 10px", fontSize: 14, color: "#3a6a9e", cursor: "pointer" }}
                    onMouseEnter={e => { e.currentTarget.style.color = "#22c55e"; e.currentTarget.style.borderColor = "#22c55e66"; }}
                    onMouseLeave={e => { e.currentTarget.style.color = "#3a6a9e"; e.currentTarget.style.borderColor = "#1a3a5e"; }}
                >✓</button>
            </div>
        </>
    );
}

function SFCardGroupItem({ group, groupKey, index, groupState, dispatch }) {
    const [open, setOpen] = useState(false);
    const isBanded = groupState.status === "banded";
    const isQaytarilgan = groupState.status === "sf_qaytarilgan";

    const borderColor = isQaytarilgan ? "#dc262666" : isBanded ? "#c0392b55" : open ? "#2563eb55" : "#172535";
    const bgColor = isQaytarilgan ? (open ? "#1e0400" : "#180300") : open ? "#0a1e38" : "#0d1825";

    return (
        <div style={{ background: bgColor, border: `1px solid ${borderColor}`, borderRadius: 10, overflow: "hidden", transition: "border-color 0.2s, background 0.2s" }}>
            <div onClick={() => setOpen(o => !o)} style={{ padding: "14px 16px", cursor: "pointer", userSelect: "none" }}>
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 10 }}>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                        <span style={{ fontSize: 12, color: "#3e5a74", marginTop: 2, minWidth: 18 }}>{index + 1}</span>
                        <div>
                            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 3 }}>
                                {isBanded && <span style={{ fontSize: 10, background: "#7f1d1d", color: "#fca5a5", borderRadius: 4, padding: "1px 6px", fontWeight: 700 }}>BAND</span>}
                                {isQaytarilgan && <span style={{ fontSize: 10, background: "#7f1d1d", color: "#fca5a5", borderRadius: 4, padding: "1px 6px", fontWeight: 700 }}>↩️ QAYTARILGAN</span>}
                                <span style={{ fontSize: 13, fontWeight: 700, color: isQaytarilgan ? "#fca5a5" : "#d8e6f4" }}>{group.yetkazib}</span>
                            </div>
                            <div style={{ fontSize: 13, fontWeight: 600, color: isQaytarilgan ? "#f87171" : "#4ba8e8" }}>{group.tashuvchi}</div>
                        </div>
                    </div>
                    <span style={{ color: "#4e6a84", fontSize: 12, transition: "transform 0.2s", transform: open ? "rotate(90deg)" : "rotate(0deg)", marginTop: 3 }}>▶</span>
                </div>
                <div style={{ display: "flex", gap: "6px 20px", flexWrap: "wrap", marginBottom: 10, paddingLeft: 26 }}>
                    <div><div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>INN</div><div style={{ fontSize: 12, color: "#7eb0d8" }}>{group.inn}</div></div>
                    <div><div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>Buxgalter</div><div style={{ fontSize: 12, color: "#7eb0d8" }}>{group.buxgalter}</div></div>
                    <div>
                        <div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>Menejer</div>
                        <div style={{ fontSize: 12, color: "#8aaac8", display: "flex", alignItems: "center", gap: 4 }}><UserIcon />{group.manager}</div>
                    </div>
                    <div style={{ marginLeft: "auto" }}>
                        <div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>Jami summa</div>
                        <div style={{ fontSize: 13, fontWeight: 700, color: "#fbbf24" }}>{fmtSum(group.jamiSumma)}<QqsTag hasQqs={(() => { const f = [...(groupState.history||[])].reverse().find(h=>h.type==="faktura"); return f ? f.hasQqs !== false : null; })()} /></div>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 8, paddingLeft: 26 }} onClick={e => e.stopPropagation()}>
                    <span style={{ fontSize: 12, color: "#4e6a84", marginRight: "auto" }}>{group.rows.length} ta</span>
                    <AvailableBadge since={group.availableSince} />
                    <SFGroupActions groupKey={groupKey} group={group} groupState={groupState} dispatch={dispatch} />
                </div>
            </div>
            {open && (
                <div style={{ borderTop: `1px solid ${isQaytarilgan ? "#3a0500" : "#172535"}` }}>
                    {group.rows.map((row, ri) => (
                        <SFCardSubRow key={row.id} row={row} ri={ri} totalRows={group.rows.length} groupState={groupState} />
                    ))}
                </div>
            )}
        </div>
    );
}

// ── Reducers ──────────────────────────────────────────────────────────────────
function groupReducer(state, action) {
    const prev = state[action.key] || { status: null, history: [], bandedAt: null };
    const epoch = Date.now();
    switch (action.type) {
        case "BAND":
            return { ...state, [action.key]: { status: "banded", bandedAt: epoch, history: [...prev.history, { type: "band", timestamp: nowStr(), epoch, author: action.author }] } };
        case "BEKOR":
            return { ...state, [action.key]: { status: null, bandedAt: null, history: [...prev.history, { type: "bekor", timestamp: nowStr(), epoch, author: action.author, comment: action.comment }] } };
        case "SHARTNOMA":
            return { ...state, [action.key]: { ...prev, history: [...prev.history, { type: action.form?.chernovik ? "chernovik" : "shartnoma", timestamp: nowStr(), epoch, author: action.author, shartnoma: action.form }] } };
        case "CHERNOVIK":
            return { ...state, [action.key]: { ...prev, history: [...prev.history, { type: "chernovik", timestamp: nowStr(), epoch, author: action.author, shartnoma: action.form }] } };
        case "UPDATE_CHERNOVIK":
            const updatedHistory1 = [...prev.history];
            if (action.historyIndex >= 0 && action.historyIndex < updatedHistory1.length) {
                updatedHistory1[action.historyIndex] = { ...updatedHistory1[action.historyIndex], shartnoma: action.form, timestamp: nowStr(), author: action.author };
            }
            return { ...state, [action.key]: { ...prev, history: updatedHistory1 } };
        case "DELETE_CHERNOVIK":
            const filteredHistory = prev.history.filter((_, idx) => idx !== action.historyIndex);
            return { ...state, [action.key]: { ...prev, history: filteredHistory } };
        case "FINALIZE_CHERNOVIK":
            const finalizedHistory = [...prev.history];
            if (action.historyIndex >= 0 && action.historyIndex < finalizedHistory.length) {
                finalizedHistory[action.historyIndex] = { ...finalizedHistory[action.historyIndex], type: "shartnoma" };
            }
            return { ...state, [action.key]: { ...prev, history: finalizedHistory } };
        case "QAYTARILGAN":
            return { ...state, [action.key]: { ...prev, status: "qaytarilgan", history: [...prev.history, { type: "qaytarilgan", timestamp: nowStr(), epoch, author: action.author, comment: action.comment }] } };
        case "SH_FILE":
            return { ...state, [action.key]: { ...prev, shFile: action.fileName, history: [...prev.history, { type: "sh_file", timestamp: nowStr(), epoch, author: action.author, fileName: action.fileName }] } };
        case "ADD_COMMENT":
            return { ...state, [action.key]: { ...prev, history: [...prev.history, { type: "comment", timestamp: nowStr(), epoch, author: action.author, comment: action.comment }] } };
        default: return state;
    }
}

function sfReducer(state, action) {
    const prev = state[action.key] || { status: null, history: [], bandedAt: null };
    const epoch = Date.now();
    switch (action.type) {
        case "SF_BAND":
            return { ...state, [action.key]: { status: "banded", bandedAt: epoch, history: [...prev.history, { type: "band", timestamp: nowStr(), epoch, author: action.author }] } };
        case "SF_BEKOR":
            return { ...state, [action.key]: { status: null, bandedAt: null, history: [...prev.history, { type: "bekor", timestamp: nowStr(), epoch, author: action.author, comment: action.comment }] } };
        case "SF_FAKTURA":
            return { ...state, [action.key]: { ...prev, history: [...prev.history, { type: "faktura", timestamp: nowStr(), epoch, author: action.author, fileName: action.fileName, hasQqs: true }] } };
        case "SF_QQS_TOGGLE": {
            const newHist = prev.history.map((h, i) => i === action.index ? { ...h, hasQqs: !h.hasQqs } : h);
            return { ...state, [action.key]: { ...prev, history: newHist } };
        }
        case "SF_QAYTARISH":
            return { ...state, [action.key]: { ...prev, status: "sf_qaytarilgan", history: [...prev.history, { type: "sf_qaytarish", timestamp: nowStr(), epoch, author: action.author, comment: action.comment }] } };
        case "SF_OT_RETURN":
            return { ...state, [action.key]: { ...prev, status: null, history: [...prev.history, { type: "sf_qaytarish", timestamp: nowStr(), epoch, author: action.author, comment: "O'tkazmadan qaytarildi: " + (action.comment || "") }] } };
        case "SF_COMMENT":
            return { ...state, [action.key]: { ...prev, history: [...prev.history, { type: "comment", timestamp: nowStr(), epoch, author: action.author, comment: action.comment }] } };
        default: return state;
    }
}

function otReducer(state, action) {
    const prev = state[action.key] || { status: null, history: [], confirmedAt: null };
    const epoch = Date.now();
    switch (action.type) {
        case "OT_TASDIQLASH":
            return { ...state, [action.key]: { ...prev, status: "tasdiqlangan", confirmedAt: epoch, history: [...prev.history, { type: "ot_tasdiqlash", timestamp: nowStr(), epoch, author: action.author }] } };
        case "OT_QAYTARISH":
            return { ...state, [action.key]: { ...prev, status: "ot_qaytarilgan", history: [...prev.history, { type: "ot_qaytarish", timestamp: nowStr(), epoch, author: action.author, comment: action.comment, destination: action.destination }] } };
        case "OT_FILE":
            return { ...state, [action.key]: { ...prev, otFile: action.fileName } };
        case "OT_COMMENT":
            return { ...state, [action.key]: { ...prev, history: [...prev.history, { type: "ot_comment", timestamp: nowStr(), epoch, author: action.author, comment: action.comment }] } };
        default: return state;
    }
}

// ── O'tkazma Qaytarish Modal ─────────────────────────────────────────────────
function OtkazmaQaytarishModal({ label, onSave, onClose }) {
    const [dest, setDest] = useState("sf");
    const [comment, setComment] = useState("");
    const opts = [
        { key: "sf", label: "Schet fakturaga qaytarish", icon: "📄", clr: "#93c5fd", bg: "#0e1830", bdr: "#1e3a6e" },
        { key: "shartnoma", label: "Shartnoma tuzishga qaytarish", icon: "📋", clr: "#c084fc", bg: "#1a0c28", bdr: "#5b21b6" },
    ];
    return (
        <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "#00000099", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
            <div onClick={e => e.stopPropagation()} style={{ background: "#0d1825", border: "1px solid #7c2d0c55", borderRadius: 12, padding: 26, width: 400, boxShadow: "0 8px 40px #000000cc" }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: "#fbbf24", marginBottom: 4 }}>↩ Qaytarish</div>
                <div style={{ fontSize: 12, color: "#4e6a84", marginBottom: 18 }}>{label} — qaysi bosqichga qaytarilsin?</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 18 }}>
                    {opts.map(o => (
                        <div key={o.key} onClick={() => setDest(o.key)}
                            style={{
                                display: "flex", alignItems: "center", gap: 12, padding: "11px 14px", borderRadius: 9, cursor: "pointer",
                                background: dest === o.key ? o.bg : "#08111d", border: `1px solid ${dest === o.key ? o.bdr : "#1e3a5e"}`, transition: "all 0.15s"
                            }}>
                            <span style={{ width: 16, height: 16, borderRadius: "50%", border: `2px solid ${dest === o.key ? o.clr : "#3e5a74"}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                {dest === o.key && <span style={{ width: 8, height: 8, borderRadius: "50%", background: o.clr, display: "block" }} />}
                            </span>
                            <span style={{ fontSize: 13 }}>{o.icon}</span>
                            <span style={{ fontSize: 13, fontWeight: dest === o.key ? 600 : 400, color: dest === o.key ? o.clr : "#8aaac8" }}>{o.label}</span>
                        </div>
                    ))}
                </div>
                <div style={{ fontSize: 12, color: "#4e6a84", marginBottom: 6 }}>Sabab / izoh</div>
                <textarea autoFocus value={comment} onChange={e => setComment(e.target.value)} placeholder="Nima sababdan qaytarilmoqda..."
                    style={{ width: "100%", height: 80, background: "#08111d", border: "1px solid #78350f44", borderRadius: 7, padding: "10px 12px", fontSize: 13, color: "#c2d0df", resize: "vertical", outline: "none", fontFamily: "inherit", marginBottom: 16 }} />
                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                    <button onClick={onClose} style={{ background: "transparent", border: "1px solid #1e3a5e", borderRadius: 6, padding: "7px 18px", fontSize: 13, color: "#4e6a84", cursor: "pointer" }}>Bekor</button>
                    <button onClick={() => { onSave(dest, comment.trim()); onClose(); }}
                        style={{ background: "#78350f", border: "1px solid #b45309", borderRadius: 6, padding: "7px 20px", fontSize: 13, color: "#fde68a", cursor: "pointer", fontWeight: 600 }}>Saqlash</button>
                </div>
            </div>
        </div>
    );
}

function OtkazmaHistoryDialog({ label, history, onClose, onAddComment }) {
    const [showAddComment, setShowAddComment] = useState(false);
    const [comment, setComment] = useState("");
    const cfg = {
        ot_tasdiqlash: { label: "✅ Tasdiqlandi", bg: "#0e2018", bdr: "#1a5c30", clr: "#6ee7a0" },
        ot_qaytarish: { label: "↩️ Qaytarildi", bg: "#1e0a00", bdr: "#7c2004", clr: "#fca5a5" },
        ot_comment: { label: "💬 Izoh", bg: "#0a1b2f", bdr: "#1e3a5e", clr: "#7ec8f4" },
    };
    const destLabel = { sf: "📄 Schet faktura", shartnoma: "📋 Shartnoma tuzish" };

    const saveComment = () => {
        const trimmed = comment.trim();
        if (!trimmed || !onAddComment) return;
        onAddComment(trimmed);
        setComment("");
        setShowAddComment(false);
    };

    return (
        <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "#00000099", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: "20px 0" }}>
            <div onClick={e => e.stopPropagation()} style={{ background: "#0d1825", border: "1px solid #1e3a5e", borderRadius: 12, padding: 24, width: 460, maxHeight: "80vh", display: "flex", flexDirection: "column", boxShadow: "0 8px 40px #000000cc" }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                    <div style={{ fontSize: 15, fontWeight: 700, color: "#d8e6f4" }}>O'tkazma tarixi</div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {onAddComment && (
                            <button
                                type="button"
                                onClick={() => setShowAddComment(v => !v)}
                                style={{ background: "transparent", border: "1px solid #1e3a5e", borderRadius: 6, padding: "5px 9px", fontSize: 12, color: "#7ec8f4", cursor: "pointer", fontWeight: 600 }}
                            >
                                + Izoh
                            </button>
                        )}
                        <button onClick={onClose} style={{ background: "transparent", border: "none", color: "#4e6a84", fontSize: 20, cursor: "pointer", lineHeight: 1 }}>×</button>
                    </div>
                </div>
                <div style={{ fontSize: 12, color: "#3e5a74", marginBottom: 18 }}>{label}</div>
                {showAddComment && (
                    <div style={{ marginBottom: 12, background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 8, padding: 10 }}>
                        <textarea
                            autoFocus
                            value={comment}
                            onChange={e => setComment(e.target.value)}
                            placeholder="Izoh kiriting..."
                            style={{ width: "100%", minHeight: 64, background: "#060f1a", border: "1px solid #1e3a5e", borderRadius: 6, padding: "8px 10px", fontSize: 12, color: "#c2d0df", outline: "none", fontFamily: "inherit", resize: "vertical", marginBottom: 8 }}
                        />
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 6 }}>
                            <button
                                type="button"
                                onClick={() => { setShowAddComment(false); setComment(""); }}
                                style={{ background: "transparent", border: "1px solid #1e3a5e", borderRadius: 6, padding: "5px 10px", fontSize: 12, color: "#4e6a84", cursor: "pointer" }}
                            >
                                Bekor
                            </button>
                            <button
                                type="button"
                                onClick={saveComment}
                                disabled={!comment.trim()}
                                style={{ background: comment.trim() ? "#1a56c4" : "#0f2035", border: "1px solid #1e3a5e", borderRadius: 6, padding: "5px 10px", fontSize: 12, color: comment.trim() ? "#dbeafe" : "#4e6a84", cursor: comment.trim() ? "pointer" : "not-allowed", fontWeight: 600 }}
                            >
                                Saqlash
                            </button>
                        </div>
                    </div>
                )}
                <div style={{ overflowY: "auto", flex: 1, display: "flex", flexDirection: "column", gap: 10 }}>
                    {history.length === 0 && <div style={{ color: "#3e5a74", fontSize: 13, textAlign: "center", padding: "30px 0" }}>Hech qanday harakat yo'q</div>}
                    {[...history].reverse().map((h, i) => {
                        const c = cfg[h.type] || { label: h.type, bg: "#0e2438", bdr: "#1a3d5c", clr: "#7ec8e3" };
                        return (
                            <div key={i} style={{ background: c.bg, border: "1px solid " + c.bdr, borderRadius: 8, padding: "12px 14px" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
                                    <span style={{ fontSize: 13, fontWeight: 600, color: c.clr }}>{c.label}</span>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 2 }}>
                                        <span style={{ fontSize: 11, color: "#3e5a74" }}>{h.timestamp}</span>
                                        <span style={{ fontSize: 11, color: "#4e8ab0", fontWeight: 600 }}>👤 {h.author}</span>
                                    </div>
                                </div>
                                {h.destination && <div style={{ fontSize: 12, color: "#a0b8cc", marginBottom: h.comment ? 4 : 0 }}>→ {destLabel[h.destination] || h.destination}</div>}
                                {h.comment && <div style={{ fontSize: 12, color: "#a0b8cc", background: "#0008", borderRadius: 5, padding: "6px 10px" }}>💬 {h.comment}</div>}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

function OtkazmaFakturaRow({ faktura, index, total, trucks, dispatchSF, groupKey, fakturaIndex }) {
    const [expanded, setExpanded] = useState(false);
    const hasQqs = faktura.hasQqs !== false;
    const toggleQqs = (e) => {
        e.stopPropagation();
        if (dispatchSF && groupKey != null && fakturaIndex != null)
            dispatchSF({ type: "SF_QQS_TOGGLE", key: groupKey, index: fakturaIndex });
    };
    return (
        <>
            <div onClick={() => setExpanded(e => !e)}
                style={{ display: "flex", alignItems: "center", padding: "11px 52px 11px 52px", background: index % 2 === 0 ? "#070d18" : "#0a1320", borderBottom: "1px solid #0f1a28", cursor: "pointer", userSelect: "none" }}
                onMouseEnter={e => e.currentTarget.style.background = "#0a1e30"}
                onMouseLeave={e => e.currentTarget.style.background = index % 2 === 0 ? "#070d18" : "#0a1320"}
            >
                <span style={{ fontSize: 11, color: "#3e5a74", width: 22 }}>{index + 1}</span>
                <div style={{ flex: 1, display: "flex", alignItems: "center", gap: 10 }}>
                    <span style={{ color: "#3b6fbc" }}><PdfIcon /></span>
                    <div>
                        <div style={{ fontSize: 12, fontWeight: 600, color: "#60a5fa" }}>
                            {faktura.fileName || "faktura.pdf"}
                            <button onClick={toggleQqs}
                                title="QQS holatini o'zgartirish"
                                style={{ background: "none", border: "none", cursor: dispatchSF ? "pointer" : "default", padding: 0, marginLeft: 6, fontSize: 11, fontWeight: 600, color: hasQqs ? "#4ade80" : "#fbbf24" }}>
                                ({hasQqs ? "QQSli" : "QQS'siz"})
                            </button>
                        </div>
                        <div style={{ fontSize: 11, color: "#4e6a84", marginTop: 2 }}>Upload: {faktura.timestamp}</div>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 12, marginLeft: "auto" }}>
                    <span style={{ fontSize: 11, color: "#8aaac8", display: "flex", alignItems: "center", gap: 4 }}><UserIcon />👤 {faktura.author}</span>
                    <span style={{ fontSize: 11, background: "#0a1e38", color: "#60a5fa", border: "1px solid #1e3a6e", borderRadius: 5, padding: "2px 8px" }}>{trucks.length} ta yuk</span>
                    <span style={{ color: "#4e6a84", fontSize: 11, transition: "transform 0.2s", transform: expanded ? "rotate(90deg)" : "rotate(0deg)" }}>▶</span>
                </div>
            </div>
            {expanded && (
                <div style={{ background: "#060d18", borderLeft: "3px solid #60a5fa55", borderBottom: index === total - 1 ? "none" : "1px solid #0f1a28" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr>
                                {["№", "Buyurtma ID", "Sana", "Qayerdan", "Qayerga", "Avtomobil", "Telefon", "Summa", ""].map((h, i) => (
                                    <th key={i} style={{ ...hS, paddingLeft: i === 0 ? 60 : 14, fontSize: 11 }}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {trucks.map((truck, ti) => (
                                <tr key={truck.id} style={{ background: ti % 2 === 0 ? "#0a0f1a" : "#080d18" }}
                                    onMouseEnter={e => e.currentTarget.style.background = "#0c1620"}
                                    onMouseLeave={e => e.currentTarget.style.background = ti % 2 === 0 ? "#0a0f1a" : "#080d18"}
                                >
                                    <td style={{ ...cS, color: "#4e6a84", width: 40, textAlign: "center", paddingLeft: 60, fontSize: 11 }}>{ti + 1}</td>
                                    <td style={{ ...cS, fontWeight: 600, fontSize: 12 }}>{truck.buyurtmaId}</td>
                                    <td style={{ ...cS, color: "#6a8aaa", fontSize: 11 }}>{truck.sana}</td>
                                    <td style={{ ...cS, fontSize: 11 }}>{truck.qayerdan}</td>
                                    <td style={{ ...cS, fontSize: 11 }}>{truck.qayerga}</td>
                                    <td style={{ ...cS, color: "#4ba8e8", fontSize: 11 }}>{truck.avto}</td>
                                    <td style={{ ...cS, fontSize: 11 }}>{truck.tel}</td>
                                    <td style={{ ...cS, color: "#fbbf24", fontWeight: 600, fontSize: 12, whiteSpace: "nowrap" }}>
                                        {fmtSum(truck.summa)}<QqsTag hasQqs={hasQqs} />
                                    </td>
                                    <td style={{ ...cS, textAlign: "center" }}>
                                        <span style={{ fontSize: 10, background: "#0a1e38", color: "#60a5fa", border: "1px solid #1e3a6e", borderRadius: 4, padding: "2px 7px", display: "inline-block" }}>📋</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    );
}

function OtkazmaGroupRow({ group, groupKey, index, otState, dispatch, sfState, dispatchSF }) {
    const [open, setOpen] = useState(false);
    const [showTasdiq, setShowTasdiq] = useState(false);
    const [showQayt, setShowQayt] = useState(false);
    const [showHist, setShowHist] = useState(false);
    const [confirmPayFile, setConfirmPayFile] = useState(null);
    const [confirmPayErr, setConfirmPayErr] = useState("");
    const confirmPayInputRef = useRef(null);

    const gs = otState[groupKey] || { status: null, history: [], otFile: null };
    const isTasdiqlangan = gs.status === "tasdiqlangan";
    const isQaytarilgan = gs.status === "ot_qaytarilgan";
    const histCount = gs.history.length;
    const lastManualNote = getLastManualHistoryEntry(gs.history);
    const otFile = gs.otFile;

    const sfHistory = sfState[groupKey]?.history || [];
    const fakturaList = sfHistory.filter(h => h.type === "faktura");

    const handleQaytarish = (destination, comment) => {
        dispatch({ type: "OT_QAYTARISH", key: groupKey, destination, comment, author: actorName() });
        if (destination === "sf") {
            dispatchSF({ type: "SF_OT_RETURN", key: groupKey, author: actorName(), comment });
        } else {
            dispatchSF({ type: "SF_QAYTARISH", key: groupKey, author: actorName(), comment });
        }
    };

    const handleConfirmPayFile = (file) => {
        if (!file) {
            setConfirmPayFile(null);
            setConfirmPayErr("");
            return;
        }
        if (file.type !== "application/pdf") {
            setConfirmPayFile(null);
            setConfirmPayErr("Faqat PDF fayl tanlang");
            return;
        }
        setConfirmPayFile(file);
        setConfirmPayErr("");
    };

    let bg = index % 2 === 0 ? "#0b1520" : "#0d1825";
    if (isTasdiqlangan) bg = index % 2 === 0 ? "#081a10" : "#091e12";
    if (isQaytarilgan) bg = index % 2 === 0 ? "#1a0800" : "#1e0a00";
    const leftBorder = isQaytarilgan ? "#ea580c" : isTasdiqlangan ? "#22c55e" : open ? "#2563eb" : "transparent";
    const hoverBg = isQaytarilgan ? "#2a1000" : isTasdiqlangan ? "#0a2418" : open ? "#0a1e38" : "#0f2035";

    return (
        <>
            {showQayt && <OtkazmaQaytarishModal label={`${group.yetkazib} — ${group.tashuvchi}`} onSave={handleQaytarish} onClose={() => setShowQayt(false)} />}
            {showHist && (
                <OtkazmaHistoryDialog
                    label={`${group.yetkazib} — ${group.tashuvchi}`}
                    history={gs.history}
                    onClose={() => setShowHist(false)}
                    onAddComment={comment => dispatch({ type: "OT_COMMENT", key: groupKey, comment, author: actorName() })}
                />
            )}
            {showTasdiq && (
                <div onClick={() => setShowTasdiq(false)} style={{ position: "fixed", inset: 0, background: "#00000099", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
                    <div onClick={e => e.stopPropagation()} style={{ background: "#0d1825", border: "1px solid #1a5c30", borderRadius: 12, padding: 28, width: 360, textAlign: "center", boxShadow: "0 8px 40px #000" }}>
                        <div style={{ fontSize: 36, marginBottom: 12 }}>💸</div>
                        <div style={{ fontSize: 15, fontWeight: 700, color: "#d8e6f4", marginBottom: 4 }}>O'tkazmani tasdiqlash</div>
                        <div style={{ fontSize: 13, color: "#4ba8e8", marginBottom: 2 }}>{group.tashuvchi}</div>
                        <div style={{ fontSize: 12, color: "#4e6a84", marginBottom: 14 }}>{group.yetkazib}</div>
                        <div style={{ fontSize: 20, fontWeight: 800, color: "#fbbf24", marginBottom: 8 }}>{fmtSum(group.jamiSumma)}<QqsTag hasQqs={groupLatestQqs(sfState, groupKey)} /></div>
                        <div style={{ fontSize: 12, color: "#3e5a74", marginBottom: 14 }}>{fakturaList.length} ta faktura · {group.rows.length} ta yuklanma</div>
                        <div style={{ textAlign: "left", marginBottom: 16 }}>
                            <div style={{ fontSize: 12, color: "#8aaac8", marginBottom: 6 }}>To'lov hujjati (PDF) <span style={{ color: "#f87171" }}>*</span></div>
                            <input
                                ref={confirmPayInputRef}
                                type="file"
                                accept=".pdf"
                                style={{ display: "none" }}
                                onChange={e => handleConfirmPayFile(e.target.files?.[0])}
                            />
                            <div style={{ display: "flex", gap: 8 }}>
                                <button
                                    type="button"
                                    onClick={() => confirmPayInputRef.current?.click()}
                                    style={{ background: "#0a1825", border: "1px solid #1e3a5e", borderRadius: 6, padding: "7px 10px", fontSize: 12, color: "#8aaac8", cursor: "pointer", fontWeight: 600 }}
                                >
                                    Fayl tanlash
                                </button>
                                <div style={{ flex: 1, minWidth: 0, background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 6, padding: "7px 10px", fontSize: 12, color: (confirmPayFile || otFile) ? "#93c5fd" : "#4e6a84", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {confirmPayFile?.name || otFile || "Fayl tanlanmagan"}
                                </div>
                            </div>
                            {confirmPayErr && <div style={{ marginTop: 6, fontSize: 11, color: "#f87171" }}>{confirmPayErr}</div>}
                        </div>
                        <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
                            <button onClick={() => setShowTasdiq(false)} style={{ background: "transparent", border: "1px solid #1e3a5e", borderRadius: 6, padding: "8px 20px", fontSize: 13, color: "#4e6a84", cursor: "pointer" }}>Bekor</button>
                            <button
                                onClick={() => {
                                    if (confirmPayFile) dispatch({ type: "OT_FILE", key: groupKey, fileName: confirmPayFile.name });
                                    dispatch({ type: "OT_TASDIQLASH", key: groupKey, author: actorName() });
                                    setShowTasdiq(false);
                                    setConfirmPayFile(null);
                                    setConfirmPayErr("");
                                }}
                                disabled={!confirmPayFile && !otFile}
                                style={{ background: (!confirmPayFile && !otFile) ? "#0f2035" : "#14532d", border: "1px solid #22c55e55", borderRadius: 6, padding: "8px 22px", fontSize: 13, color: (!confirmPayFile && !otFile) ? "#4e6a84" : "#86efac", cursor: (!confirmPayFile && !otFile) ? "not-allowed" : "pointer", fontWeight: 700 }}
                            >
                                ✓ Tasdiqlash
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <tr onClick={() => setOpen(o => !o)} style={{ cursor: "pointer", background: bg, borderLeft: `3px solid ${leftBorder}` }}
                onMouseEnter={e => e.currentTarget.style.background = hoverBg}
                onMouseLeave={e => e.currentTarget.style.background = bg}
            >
                <td style={{ ...cS, color: "#4e6a84", width: 44, textAlign: "center" }}>{index + 1}</td>
                <td style={{ ...cS, fontWeight: 600 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {isTasdiqlangan && <span style={{ fontSize: 10, background: "#14532d", color: "#86efac", borderRadius: 4, padding: "1px 6px", fontWeight: 700, flexShrink: 0 }}>✅ TASDIQLANGAN</span>}
                        {isQaytarilgan && <span style={{ fontSize: 10, background: "#7c2d0c", color: "#fde68a", borderRadius: 4, padding: "1px 6px", fontWeight: 700, flexShrink: 0 }}>↩️ QAYTARILGAN</span>}
                        <span style={{ color: isQaytarilgan ? "#fca882" : isTasdiqlangan ? "#86efac" : "#d8e6f4" }}>{group.yetkazib}</span>
                    </div>
                </td>
                <td style={{ ...cS, fontWeight: 600, color: isQaytarilgan ? "#f97316" : isTasdiqlangan ? "#4ade80" : "#4ba8e8" }}>{group.tashuvchi}</td>
                <td style={{ ...cS, color: "#7eb0d8", fontSize: 12 }}>{group.inn}</td>
                <td style={{ ...cS, color: "#7eb0d8", fontSize: 12 }}>{group.buxgalter}</td>
                <td style={{ ...cS }}>
                    {fakturaList.length > 0 ? (
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 12, color: "#60a5fa", background: "#0a1e38", border: "1px solid #1e3a6e", borderRadius: 6, padding: "3px 10px" }}>
                            <PdfIcon />{fakturaList.length} ta faktura
                        </span>
                    ) : (
                        <span style={{ fontSize: 12, color: "#2e4a5e", fontStyle: "italic" }}>yuklanmagan</span>
                    )}
                </td>
                <td style={{ ...cS, fontWeight: 700, fontSize: 13, color: "#fbbf24", whiteSpace: "nowrap" }}>{fmtSum(group.jamiSumma)}<QqsTag hasQqs={groupLatestQqs(sfState, groupKey)} /></td>
                <td style={{ ...cS, textAlign: "right", paddingRight: 16 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6 }}>
                        <span style={{ fontSize: 12, color: "#4e6a84" }}>{group.rows.length} ta yuk</span>
                        <div style={{ position: "relative" }}>
                            <button onClick={e => { e.stopPropagation(); setShowHist(true); }}
                                style={{ background: "#0a1825", border: "1px solid #1e3a5e", borderRadius: 6, padding: "6px 8px", color: "#4e6a84", cursor: "pointer", display: "flex", alignItems: "center" }}
                                onMouseEnter={e => { e.currentTarget.style.color = "#7ec8f4"; e.currentTarget.style.borderColor = "#2563eb66"; }}
                                onMouseLeave={e => { e.currentTarget.style.color = "#4e6a84"; e.currentTarget.style.borderColor = "#1e3a5e"; }}
                            ><HistoryIcon /></button>
                            {histCount > 0 && <span style={{ position: "absolute", top: -6, right: -6, background: "#1a56c4", color: "#fff", fontSize: 10, fontWeight: 700, borderRadius: "50%", width: 16, height: 16, display: "flex", alignItems: "center", justifyContent: "center", pointerEvents: "none" }}>{histCount > 9 ? "9+" : histCount}</span>}
                        </div>
                        {lastManualNote && (
                            <span
                                title={lastManualNote.text}
                                style={{ maxWidth: 190, fontSize: 11, color: "#8aaac8", background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 6, padding: "3px 8px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                            >
                                💬 {lastManualNote.text}
                            </span>
                        )}
                        <button onClick={e => { e.stopPropagation(); setConfirmPayFile(null); setConfirmPayErr(""); setShowTasdiq(true); }}
                            style={{ background: "transparent", border: "1px solid #1a3a5e", borderRadius: 6, padding: "5px 12px", fontSize: 14, color: "#3a6a9e", cursor: "pointer" }}
                            onMouseEnter={e => { e.currentTarget.style.color = "#22c55e"; e.currentTarget.style.borderColor = "#22c55e66"; }}
                            onMouseLeave={e => { e.currentTarget.style.color = "#3a6a9e"; e.currentTarget.style.borderColor = "#1a3a5e"; }}
                        >✓</button>
                        {!isQaytarilgan && (
                            <button onClick={e => { e.stopPropagation(); setShowQayt(true); }}
                                style={{ background: "transparent", border: "1px solid #7c2004", borderRadius: 6, padding: "5px 10px", fontSize: 12, color: "#c23a0c", cursor: "pointer", fontWeight: 700 }}
                                onMouseEnter={e => { e.currentTarget.style.background = "#1e0a00"; e.currentTarget.style.color = "#fca5a5"; }}
                                onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#c23a0c"; }}
                            >↩</button>
                        )}
                        <span style={{ color: "#4e6a84", fontSize: 12, transition: "transform 0.2s", transform: open ? "rotate(90deg)" : "rotate(0deg)" }}>▶</span>
                    </div>
                </td>
            </tr>

            {open && (
                <tr>
                    <td colSpan={8} style={{ padding: 0, background: "#060d18", borderBottom: "2px solid #1a3a5e", borderLeft: `3px solid ${leftBorder}` }}>
                        {fakturaList.length === 0 ? (
                            <div style={{ padding: "20px 52px", fontSize: 13, color: "#2e4a5e", fontStyle: "italic" }}>
                                Bu guruh uchun hali hech qanday faktura yuklanmagan.
                            </div>
                        ) : (
                            <div style={{ padding: 0 }}>
                                {fakturaList.map((f, fi) => (
                                    <OtkazmaFakturaRow key={fi} faktura={f} index={fi} total={fakturaList.length} trucks={group.rows}
                                        dispatchSF={dispatchSF} groupKey={groupKey} fakturaIndex={sfHistory.indexOf(f)} />
                                ))}
                            </div>
                        )}
                    </td>
                </tr>
            )}
        </>
    );
}

// ── Deadline helper ───────────────────────────────────────────────────────────
function daysUntil(dateStr) {
    if (!dateStr) return null;
    return Math.ceil((new Date(dateStr) - new Date()) / 86400000);
}

// ── File View Modal ───────────────────────────────────────────────────────────
function FileViewModal({ title, fileName, onClose }) {
    return (
        <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "#00000099", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
            <div onClick={e => e.stopPropagation()} style={{ background: "#0d1825", border: "1px solid #1e3a5e", borderRadius: 12, padding: 28, width: 380, boxShadow: "0 8px 40px #000000cc" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: "#d8e6f4" }}>{title}</div>
                    <button onClick={onClose} style={{ background: "transparent", border: "none", color: "#4e6a84", fontSize: 20, cursor: "pointer", lineHeight: 1 }}>×</button>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 14, padding: 16, background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 10, marginBottom: 20 }}>
                    <span style={{ color: "#3b6fbc", flexShrink: 0 }}><PdfIcon /></span>
                    <div>
                        <div style={{ fontSize: 13, fontWeight: 600, color: "#60a5fa" }}>{fileName}</div>
                        <div style={{ fontSize: 11, color: "#4e6a84", marginTop: 3 }}>PDF hujjat</div>
                    </div>
                </div>
                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                    <button onClick={onClose} style={{ background: "transparent", border: "1px solid #1e3a5e", borderRadius: 6, padding: "7px 18px", fontSize: 13, color: "#4e6a84", cursor: "pointer" }}>Yopish</button>
                    <button
                        style={{ background: "#1a56c4", border: "none", borderRadius: 6, padding: "7px 20px", fontSize: 13, color: "#fff", cursor: "pointer", fontWeight: 600 }}
                        onMouseEnter={e => e.currentTarget.style.background = "#1e66e8"}
                        onMouseLeave={e => e.currentTarget.style.background = "#1a56c4"}
                    >↓ Yuklab olish</button>
                </div>
            </div>
        </div>
    );
}

// ══════════════════════════════════════════════════════════════════════════════
// SHARTNOMALAR PAGE (4-level: Contract → Payment → Faktura → Trucks)
// ══════════════════════════════════════════════════════════════════════════════

function ShartnomalarPaymentSection({ group, groupKey, otState, dispatchOT, sfState, dispatchSF }) {
    const [open, setOpen] = useState(false);
    const [showPayFileUp, setShowPayFileUp] = useState(false);
    const [showPayFileView, setShowPayFileView] = useState(false);

    const gs = otState[groupKey] || { status: null, history: [], otFile: null };
    const isTasdiqlangan = gs.status === "tasdiqlangan";
    const isQaytarilgan = gs.status === "ot_qaytarilgan";
    const otFile = gs.otFile;

    const sfHistory = sfState[groupKey]?.history || [];
    const fakturaList = sfHistory.filter(h => h.type === "faktura");

    const payBg = isTasdiqlangan ? "#071a0e" : isQaytarilgan ? "#1a0600" : "#08111d";
    const leftAccent = isTasdiqlangan ? "#22c55e" : isQaytarilgan ? "#ea580c" : "#2563eb";

    return (
        <div style={{ background: "#060b14", borderTop: "1px solid #0f1a28" }}>
            {showPayFileUp && <PdfUploadModal title={`To'lov hujjati — ${group.tashuvchi}`} onSend={fileName => dispatchOT({ type: "OT_FILE", key: groupKey, fileName })} onClose={() => setShowPayFileUp(false)} />}
            {showPayFileView && <FileViewModal title={`To'lov hujjati — ${group.tashuvchi}`} fileName={otFile} onClose={() => setShowPayFileView(false)} />}

            {/* Payment sub-row (level 2) */}
            <div
                onClick={() => setOpen(o => !o)}
                style={{ display: "flex", alignItems: "center", gap: 10, padding: "11px 20px 11px 52px", background: payBg, cursor: "pointer", userSelect: "none", borderLeft: `3px solid ${leftAccent}` }}
                onMouseEnter={e => e.currentTarget.style.background = isTasdiqlangan ? "#0a2418" : isQaytarilgan ? "#240a00" : "#0a1e38"}
                onMouseLeave={e => e.currentTarget.style.background = payBg}
            >
                <span style={{ fontSize: 12, fontWeight: 700, color: "#60a5fa", letterSpacing: "0.04em", minWidth: 90 }}>💸 TO'LOVLAR</span>
                {isTasdiqlangan && <span style={{ fontSize: 10, background: "#14532d", color: "#86efac", borderRadius: 4, padding: "1px 8px", fontWeight: 700, flexShrink: 0 }}>✅ TASDIQLANGAN</span>}
                {isQaytarilgan && <span style={{ fontSize: 10, background: "#7c2d0c", color: "#fde68a", borderRadius: 4, padding: "1px 8px", fontWeight: 700, flexShrink: 0 }}>↩️ QAYTARILGAN</span>}
                {!isTasdiqlangan && !isQaytarilgan && <span style={{ fontSize: 10, background: "#0a1825", color: "#4e6a84", border: "1px solid #1e3a5e", borderRadius: 4, padding: "1px 8px", fontWeight: 600 }}>KUTILMOQDA</span>}
                <span style={{ fontSize: 13, fontWeight: 800, color: "#fbbf24", marginLeft: 8 }}>{fmtSum(group.jamiSumma)}<QqsTag hasQqs={groupLatestQqs(sfState, groupKey)} /></span>
                {isTasdiqlangan && (() => {
                    const tasdiqH = gs.history?.find(h => h.type === "ot_tasdiqlash");
                    return tasdiqH ? <span style={{ fontSize: 11, color: "#4ade80", marginLeft: 6, display: "flex", alignItems: "center", gap: 3 }}><ClockIcon />{tasdiqH.timestamp}</span> : null;
                })()}
                {!isTasdiqlangan && !isQaytarilgan && fakturaList.length > 0 && (() => {
                    const lastF = fakturaList[fakturaList.length - 1];
                    return <span style={{ fontSize: 10, color: "#6a8aaa", marginLeft: 6, display: "flex", alignItems: "center", gap: 3 }}><ClockIcon />Faktura: {lastF.timestamp}</span>;
                })()}

                <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ fontSize: 12, color: "#4e6a84" }}>{fakturaList.length > 0 ? `${fakturaList.length} ta faktura` : "faktura yo'q"}</span>
                    <span style={{ fontSize: 12, color: "#3e5a74" }}>·</span>
                    <span style={{ fontSize: 12, color: "#4e6a84" }}>{group.rows.length} ta yuk</span>
                    <div onClick={e => e.stopPropagation()} style={{ display: "flex", alignItems: "center", gap: 5 }}>
                        {/* Payment file */}
                        <button
                            onClick={() => otFile ? setShowPayFileView(true) : setShowPayFileUp(true)}
                            title={otFile ? `📎 ${otFile}` : "To'lov hujjati yuklash"}
                            style={{ background: otFile ? "#0a1e38" : "transparent", border: `1px solid ${otFile ? "#1e3a6e" : "#1a3a5e"}`, borderRadius: 6, padding: "5px 7px", fontSize: 12, color: otFile ? "#60a5fa" : "#3a5a7e", cursor: "pointer" }}
                            onMouseEnter={e => { e.currentTarget.style.borderColor = "#60a5fa88"; e.currentTarget.style.color = "#7ec8f4"; }}
                            onMouseLeave={e => { e.currentTarget.style.borderColor = otFile ? "#1e3a6e" : "#1a3a5e"; e.currentTarget.style.color = otFile ? "#60a5fa" : "#3a5a7e"; }}
                        >{otFile ? "📎" : "📤"}</button>
                    </div>
                    <span style={{ color: "#4e6a84", fontSize: 11, display: "inline-block", transition: "transform 0.2s", transform: open ? "rotate(90deg)" : "rotate(0deg)" }}>▶</span>
                </div>
            </div>

            {/* Fakturalar list (level 3) → each expands to trucks (level 4) */}
            {open && (
                <div style={{ background: "#050b14", borderTop: "1px solid #0d1520" }}>
                    {fakturaList.length === 0 ? (
                        <div style={{ padding: "16px 52px", fontSize: 13, color: "#2e4a5e", fontStyle: "italic" }}>Bu guruh uchun hali hech qanday faktura yuklanmagan.</div>
                    ) : (
                        fakturaList.map((f, fi) => (
                            <OtkazmaFakturaRow key={fi} faktura={f} index={fi} total={fakturaList.length} trucks={group.rows}
                                dispatchSF={dispatchSF} groupKey={groupKey} fakturaIndex={sfHistory.indexOf(f)} />
                        ))
                    )}
                </div>
            )}
        </div>
    );
}

const AVTO_TURI_LABELS = { fura: "Fura", tent: "Tent", isuzu5: "Isuzu 5", isuzu10: "Isuzu 10", ref: "Ref" };

function ShartnomalarContractRow({ group, groupKey, index, gState, sfState, otState, dispatchG, dispatchOT, dispatchSF }) {
    const [open, setOpen] = useState(false);
    const [showShFileUp, setShowShFileUp] = useState(false);
    const [showShFileView, setShowShFileView] = useState(false);
    const [showAvtoTip, setShowAvtoTip] = useState(false);

    const gs = gState[groupKey] || { status: null, history: [], bandedAt: null, shFile: null };
    const otGs = otState[groupKey] || { status: null, history: [] };
    const contractInfo = latestShartnoma(gs.history || []);
    const isChernovik = latestShartnomaDraft(gs.history || []);
    const shFile = gs.shFile;

    const isTasdiqlangan = otGs.status === "tasdiqlangan";
    const isQaytarilgan = otGs.status === "ot_qaytarilgan";

    const deadline = contractInfo?.tugash || group.muddat;
    const days = daysUntil(deadline);
    const deadlineColor = days === null ? "#4e6a84" : days < 0 ? "#f87171" : days < 14 ? "#fb923c" : days < 30 ? "#fbbf24" : "#94a3b8";
    const deadlinePrefix = days !== null && days < 0 ? "⚠️ MUDDATI O'TGAN · " : days !== null && days < 14 ? "⚠️ " : "";
    const displayLimit = contractInfo?.limitEnabled === false
        ? null
        : contractInfo?.summa
            ? contractInfo.summa + " so'm"
            : group.limit
                ? fmtSum(group.limit)
                : null;

    let bg = index % 2 === 0 ? "#0b1520" : "#0d1825";
    if (isTasdiqlangan) bg = index % 2 === 0 ? "#081a10" : "#091e12";
    if (isQaytarilgan) bg = index % 2 === 0 ? "#1a0800" : "#1e0a00";
    const hoverBg = isTasdiqlangan ? "#0a2418" : isQaytarilgan ? "#2a1000" : open ? "#0a1e38" : "#0f2035";
    const leftBorder = isQaytarilgan ? "#ea580c" : isTasdiqlangan ? "#22c55e" : open ? "#2563eb" : "transparent";

    return (
        <>
            {showShFileUp && <PdfUploadModal title={`Shartnoma hujjati — ${group.tashuvchi}`} onSend={fileName => dispatchG({ type: "SH_FILE", key: groupKey, fileName, author: actorName() })} onClose={() => setShowShFileUp(false)} />}
            {showShFileView && <FileViewModal title={`Shartnoma hujjati — ${group.tashuvchi}`} fileName={shFile} onClose={() => setShowShFileView(false)} />}

            <tr onClick={() => setOpen(o => !o)} style={{ cursor: "pointer", background: bg, borderLeft: `3px solid ${leftBorder}` }}
                onMouseEnter={e => e.currentTarget.style.background = hoverBg}
                onMouseLeave={e => e.currentTarget.style.background = bg}
            >
                <td style={{ ...cS, color: "#4e6a84", width: 44, textAlign: "center" }}>{index + 1}</td>
                {/* Shartnoma raqami + sana */}
                <td style={{ ...cS }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <span style={{ fontSize: 13, fontWeight: 700, color: contractInfo?.raqami ? "#93c5fd" : "#d8e6f4" }}>
                            {contractInfo?.raqami ? `📋 ${contractInfo.raqami}` : `📋 ${group.tashuvchi.split(" ")[0]}-${index + 1}`}
                        </span>
                        {isChernovik && <span style={{ fontSize: 10, background: "#1a1200", color: "#fbbf24", border: "1px solid #5c3a00", borderRadius: 4, padding: "1px 6px", fontWeight: 700 }}>CHERNOVIK</span>}
                    </div>
                    {contractInfo?.sana
                        ? <div style={{ fontSize: 11, color: "#4e6a84", marginTop: 2 }}>{contractInfo.sana}</div>
                        : <div style={{ fontSize: 11, color: "#2e4a5e", marginTop: 2 }}>Sana ko'rsatilmagan</div>
                    }
                </td>
                {/* Yetkazib beruvchi */}
                <td style={{ ...cS, fontWeight: 600, color: isTasdiqlangan ? "#4ade80" : isQaytarilgan ? "#f97316" : "#d8e6f4" }}>{group.yetkazib}</td>
                {/* Tashuvchi */}
                <td style={{ ...cS, fontWeight: 600, color: isTasdiqlangan ? "#86efac" : isQaytarilgan ? "#fca882" : "#4ba8e8" }}>{group.tashuvchi}</td>
                {/* INN */}
                <td style={{ ...cS, color: "#7eb0d8", fontSize: 12 }}>{group.inn}</td>
                {/* Buxgalter */}
                <td style={{ ...cS, color: "#7eb0d8", fontSize: 12 }}>{group.buxgalter}</td>
                {/* Limit */}
                <td style={{ ...cS }}>
                    {displayLimit
                        ? <span style={{ fontSize: 13, fontWeight: 700, color: "#a78bfa" }}>{displayLimit}</span>
                        : <span style={{ color: "#2e4a5e", fontSize: 12 }}>—</span>
                    }
                </td>
                {/* Muddat */}
                <td style={{ ...cS }}>
                    {deadline
                        ? <span style={{ fontSize: 12, fontWeight: days !== null && days < 14 ? 700 : 400, color: deadlineColor }}>{deadlinePrefix}{deadline}</span>
                        : <span style={{ color: "#2e4a5e", fontSize: 12 }}>—</span>
                    }
                </td>
                {/* Avto soni */}
                <td style={{ ...cS, position: "relative" }} onClick={e => e.stopPropagation()}>
                    {(() => {
                        const avtoRows = contractInfo?.extraRows || [];
                        const total = avtoRows.length;
                        if (total === 0) return <span style={{ color: "#2e4a5e", fontSize: 12 }}>—</span>;
                        const breakdown = avtoRows.reduce((acc, r) => { acc[r.avtoTuri] = (acc[r.avtoTuri] || 0) + 1; return acc; }, {});
                        return (
                            <div style={{ position: "relative", display: "inline-block" }}>
                                <button onClick={() => setShowAvtoTip(t => !t)}
                                    style={{ background: showAvtoTip ? "#0e2e18" : "#0a1e30", border: `1px solid ${showAvtoTip ? "#22c55e66" : "#1e4a70"}`, borderRadius: 6, padding: "3px 9px", fontSize: 12, fontWeight: 700, color: "#4ade80", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 4 }}
                                    onMouseEnter={e => { e.currentTarget.style.borderColor = "#22c55e88"; }}
                                    onMouseLeave={e => { e.currentTarget.style.borderColor = showAvtoTip ? "#22c55e66" : "#1e4a70"; }}
                                >
                                    {total}<span style={{ fontSize: 10, color: "#3a8a5e", marginLeft: 1 }}>ta</span>
                                    <span style={{ fontSize: 10, color: showAvtoTip ? "#4ade80" : "#3a8a5e" }}>ℹ</span>
                                </button>
                                {showAvtoTip && (
                                    <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, zIndex: 999, background: "#0d1e30", border: "1px solid #1e3a5e", borderRadius: 8, padding: "10px 14px", minWidth: 160, boxShadow: "0 4px 20px #000000bb" }}>
                                        <div style={{ fontSize: 11, color: "#4e6a84", marginBottom: 8, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>Avto konfiguratsiyasi</div>
                                        {Object.entries(breakdown).map(([turi, cnt]) => (
                                            <div key={turi} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 20, marginBottom: 5 }}>
                                                <span style={{ fontSize: 12, color: "#c2d0df" }}>{AVTO_TURI_LABELS[turi] || turi}</span>
                                                <span style={{ fontSize: 12, fontWeight: 700, color: "#4ade80" }}>{cnt} ta</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    })()}
                </td>
                {/* Jami summa */}
                <td style={{ ...cS, fontWeight: 700, fontSize: 13, color: "#fbbf24", whiteSpace: "nowrap" }}>
                    {fmtSum(group.jamiSumma)}<QqsTag hasQqs={groupLatestQqs(sfState, groupKey)} />
                </td>
                {/* Actions */}
                <td style={{ ...cS, textAlign: "right", paddingRight: 16 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6 }}>
                        {isTasdiqlangan && <span style={{ fontSize: 10, background: "#14532d", color: "#86efac", borderRadius: 4, padding: "1px 8px", fontWeight: 700, flexShrink: 0 }}>✅ TO'LANDI</span>}
                        {isQaytarilgan && <span style={{ fontSize: 10, background: "#7c2d0c", color: "#fde68a", borderRadius: 4, padding: "1px 8px", fontWeight: 700, flexShrink: 0 }}>↩️ QAYTARILGAN</span>}
                        <div onClick={e => e.stopPropagation()} style={{ display: "flex", gap: 5, alignItems: "center" }}>
                            {/* Shartnoma file button */}
                            <button
                                onClick={() => shFile ? setShowShFileView(true) : setShowShFileUp(true)}
                                title={shFile ? `📎 ${shFile}` : "Shartnoma hujjati yuklash"}
                                style={{ background: shFile ? "#0e1e38" : "transparent", border: `1px solid ${shFile ? "#1e3a6e" : "#1a3a5e"}`, borderRadius: 6, padding: "5px 7px", fontSize: 12, color: shFile ? "#60a5fa" : "#3a5a7e", cursor: "pointer" }}
                                onMouseEnter={e => { e.currentTarget.style.borderColor = "#60a5fa88"; e.currentTarget.style.color = "#7ec8f4"; }}
                                onMouseLeave={e => { e.currentTarget.style.borderColor = shFile ? "#1e3a6e" : "#1a3a5e"; e.currentTarget.style.color = shFile ? "#60a5fa" : "#3a5a7e"; }}
                            >{shFile ? "📎" : "📤"}</button>
                        </div>
                        <span style={{ color: "#4e6a84", fontSize: 12, display: "inline-block", transition: "transform 0.2s", transform: open ? "rotate(90deg)" : "rotate(0deg)" }}>▶</span>
                    </div>
                </td>
            </tr>
            {open && (
                <tr>
                    <td colSpan={11} style={{ padding: 0, background: "#060b14", borderBottom: "2px solid #1a3a5e", borderLeft: `3px solid ${leftBorder}` }}>
                        <div style={{ padding: "0 0 16px 0" }}>
                            <ShartnomalarPaymentSection
                                group={group} groupKey={groupKey}
                                otState={otState} dispatchOT={dispatchOT}
                                sfState={sfState} dispatchSF={dispatchSF}
                            />
                        </div>
                    </td>
                </tr>
            )}
        </>
    );
}

// ── Custom Dropdown ───────────────────────────────────────────────────────────
function Dropdown({ options, value, onChange, counts }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const displayLabel = (opt) => {
        const n = counts[opt];
        return n !== undefined ? `${opt} (${n})` : opt;
    };

    return (
        <div ref={ref} style={{ position: "relative" }}>
            <button onClick={() => setOpen(o => !o)}
                style={{ display: "flex", alignItems: "center", gap: 8, background: "#0a1825", border: "1px solid #1e3a5e", borderRadius: 8, padding: "7px 14px", fontSize: 13, color: "#7ec8f4", cursor: "pointer", fontWeight: 600, minWidth: 200 }}
                onMouseEnter={e => e.currentTarget.style.borderColor = "#2563eb"}
                onMouseLeave={e => e.currentTarget.style.borderColor = "#1e3a5e"}
            >
                <span style={{ flex: 1, textAlign: "left" }}>{displayLabel(value)}</span>
                <span style={{ display: "inline-block", transition: "transform 0.2s", transform: open ? "rotate(180deg)" : "rotate(0deg)" }}><ChevronDown size={12} strokeWidth={2.5} /></span>
            </button>
            {open && (
                <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, background: "#0d1825", border: "1px solid #1e3a5e", borderRadius: 8, overflow: "hidden", zIndex: 100, minWidth: 240, boxShadow: "0 8px 24px #000000aa" }}>
                    {options.map(opt => {
                        const n = counts[opt];
                        const isSelected = opt === value;
                        return (
                            <button key={opt} onClick={() => { onChange(opt); setOpen(false); }}
                                style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", textAlign: "left", background: isSelected ? "#163a6e" : "transparent", border: "none", padding: "9px 14px", fontSize: 13, color: isSelected ? "#7ec8f4" : "#c2d0df", cursor: "pointer", gap: 10 }}
                                onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = "#0f2035"; }}
                                onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = "transparent"; }}
                            >
                                <span>{opt}</span>
                                {n !== undefined && (
                                    <span style={{ fontSize: 11, fontWeight: 700, background: isSelected ? "#1a4a8e" : "#0f1e30", color: isSelected ? "#93c5fd" : "#4e7a9e", borderRadius: 999, padding: "1px 8px", minWidth: 22, textAlign: "center" }}>
                                        {n}
                                    </span>
                                )}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

// ── O'tkazma card item ────────────────────────────────────────────────────────
function OtkazmaCardItem({ group, groupKey, index, otState, dispatch, sfState, dispatchSF }) {
    const [open, setOpen] = useState(false);
    const [showTasdiq, setShowTasdiq] = useState(false);
    const [showQayt, setShowQayt] = useState(false);
    const [showHist, setShowHist] = useState(false);
    const [confirmPayFile, setConfirmPayFile] = useState(null);
    const [confirmPayErr, setConfirmPayErr] = useState("");
    const confirmPayInputRef = useRef(null);

    const gs = otState[groupKey] || { status: null, history: [], otFile: null };
    const isTasdiqlangan = gs.status === "tasdiqlangan";
    const isQaytarilgan = gs.status === "ot_qaytarilgan";
    const histCount = gs.history.length;
    const lastManualNote = getLastManualHistoryEntry(gs.history);
    const otFile = gs.otFile;

    const sfHistory = sfState[groupKey]?.history || [];
    const fakturaList = sfHistory.filter(h => h.type === "faktura");

    const handleQaytarish = (destination, comment) => {
        dispatch({ type: "OT_QAYTARISH", key: groupKey, destination, comment, author: actorName() });
        if (destination === "sf") dispatchSF({ type: "SF_OT_RETURN", key: groupKey, author: actorName(), comment });
        else dispatchSF({ type: "SF_QAYTARISH", key: groupKey, author: actorName(), comment });
    };

    const handleConfirmPayFile = (file) => {
        if (!file) {
            setConfirmPayFile(null);
            setConfirmPayErr("");
            return;
        }
        if (file.type !== "application/pdf") {
            setConfirmPayFile(null);
            setConfirmPayErr("Faqat PDF fayl tanlang");
            return;
        }
        setConfirmPayFile(file);
        setConfirmPayErr("");
    };

    const borderColor = isQaytarilgan ? "#ea580c55" : isTasdiqlangan ? "#22c55e44" : open ? "#2563eb55" : "#172535";
    const bgColor = isQaytarilgan ? (open ? "#1e0800" : "#180600") : isTasdiqlangan ? (open ? "#0a2010" : "#081a0e") : open ? "#0a1e38" : "#0d1825";

    return (
        <div style={{ background: bgColor, border: `1px solid ${borderColor}`, borderRadius: 10, overflow: "hidden", transition: "border-color 0.2s, background 0.2s" }}>
            {showQayt && <OtkazmaQaytarishModal label={`${group.yetkazib} — ${group.tashuvchi}`} onSave={handleQaytarish} onClose={() => setShowQayt(false)} />}
            {showHist && (
                <OtkazmaHistoryDialog
                    label={`${group.yetkazib} — ${group.tashuvchi}`}
                    history={gs.history}
                    onClose={() => setShowHist(false)}
                    onAddComment={comment => dispatch({ type: "OT_COMMENT", key: groupKey, comment, author: actorName() })}
                />
            )}
            {showTasdiq && (
                <div onClick={() => setShowTasdiq(false)} style={{ position: "fixed", inset: 0, background: "#00000099", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
                    <div onClick={e => e.stopPropagation()} style={{ background: "#0d1825", border: "1px solid #1a5c30", borderRadius: 12, padding: 28, width: 360, textAlign: "center", boxShadow: "0 8px 40px #000" }}>
                        <div style={{ fontSize: 36, marginBottom: 12 }}>💸</div>
                        <div style={{ fontSize: 15, fontWeight: 700, color: "#d8e6f4", marginBottom: 4 }}>O'tkazmani tasdiqlash</div>
                        <div style={{ fontSize: 13, color: "#4ba8e8", marginBottom: 2 }}>{group.tashuvchi}</div>
                        <div style={{ fontSize: 12, color: "#4e6a84", marginBottom: 14 }}>{group.yetkazib}</div>
                        <div style={{ fontSize: 20, fontWeight: 800, color: "#fbbf24", marginBottom: 8 }}>{fmtSum(group.jamiSumma)}<QqsTag hasQqs={groupLatestQqs(sfState, groupKey)} /></div>
                        <div style={{ fontSize: 12, color: "#3e5a74", marginBottom: 14 }}>{fakturaList.length} ta faktura · {group.rows.length} ta yuklanma</div>
                        <div style={{ textAlign: "left", marginBottom: 16 }}>
                            <div style={{ fontSize: 12, color: "#8aaac8", marginBottom: 6 }}>To'lov hujjati (PDF) <span style={{ color: "#f87171" }}>*</span></div>
                            <input
                                ref={confirmPayInputRef}
                                type="file"
                                accept=".pdf"
                                style={{ display: "none" }}
                                onChange={e => handleConfirmPayFile(e.target.files?.[0])}
                            />
                            <div style={{ display: "flex", gap: 8 }}>
                                <button
                                    type="button"
                                    onClick={() => confirmPayInputRef.current?.click()}
                                    style={{ background: "#0a1825", border: "1px solid #1e3a5e", borderRadius: 6, padding: "7px 10px", fontSize: 12, color: "#8aaac8", cursor: "pointer", fontWeight: 600 }}
                                >
                                    Fayl tanlash
                                </button>
                                <div style={{ flex: 1, minWidth: 0, background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 6, padding: "7px 10px", fontSize: 12, color: (confirmPayFile || otFile) ? "#93c5fd" : "#4e6a84", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {confirmPayFile?.name || otFile || "Fayl tanlanmagan"}
                                </div>
                            </div>
                            {confirmPayErr && <div style={{ marginTop: 6, fontSize: 11, color: "#f87171" }}>{confirmPayErr}</div>}
                        </div>
                        <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
                            <button onClick={() => setShowTasdiq(false)} style={{ background: "transparent", border: "1px solid #1e3a5e", borderRadius: 6, padding: "8px 20px", fontSize: 13, color: "#4e6a84", cursor: "pointer" }}>Bekor</button>
                            <button
                                onClick={() => {
                                    if (confirmPayFile) dispatch({ type: "OT_FILE", key: groupKey, fileName: confirmPayFile.name });
                                    dispatch({ type: "OT_TASDIQLASH", key: groupKey, author: actorName() });
                                    setShowTasdiq(false);
                                    setConfirmPayFile(null);
                                    setConfirmPayErr("");
                                }}
                                disabled={!confirmPayFile && !otFile}
                                style={{ background: (!confirmPayFile && !otFile) ? "#0f2035" : "#14532d", border: "1px solid #22c55e55", borderRadius: 6, padding: "8px 22px", fontSize: 13, color: (!confirmPayFile && !otFile) ? "#4e6a84" : "#86efac", cursor: (!confirmPayFile && !otFile) ? "not-allowed" : "pointer", fontWeight: 700 }}
                            >
                                ✓ Tasdiqlash
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div onClick={() => setOpen(o => !o)} style={{ padding: "14px 16px", cursor: "pointer", userSelect: "none" }}>
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 10 }}>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                        <span style={{ fontSize: 12, color: "#3e5a74", marginTop: 2, minWidth: 18 }}>{index + 1}</span>
                        <div>
                            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 3, flexWrap: "wrap" }}>
                                {isTasdiqlangan && <span style={{ fontSize: 10, background: "#14532d", color: "#86efac", borderRadius: 4, padding: "1px 6px", fontWeight: 700 }}>✅ TASDIQLANGAN</span>}
                                {isQaytarilgan && <span style={{ fontSize: 10, background: "#7c2d0c", color: "#fde68a", borderRadius: 4, padding: "1px 6px", fontWeight: 700 }}>↩️ QAYTARILGAN</span>}
                                <span style={{ fontSize: 13, fontWeight: 700, color: isQaytarilgan ? "#fca882" : isTasdiqlangan ? "#86efac" : "#d8e6f4" }}>{group.yetkazib}</span>
                            </div>
                            <div style={{ fontSize: 13, fontWeight: 600, color: isQaytarilgan ? "#f97316" : isTasdiqlangan ? "#4ade80" : "#4ba8e8" }}>{group.tashuvchi}</div>
                        </div>
                    </div>
                    <span style={{ color: "#4e6a84", fontSize: 12, transition: "transform 0.2s", transform: open ? "rotate(90deg)" : "rotate(0deg)", marginTop: 3 }}>▶</span>
                </div>

                <div style={{ display: "flex", gap: "6px 20px", flexWrap: "wrap", marginBottom: 10, paddingLeft: 26 }}>
                    <div><div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>INN</div><div style={{ fontSize: 12, color: "#7eb0d8" }}>{group.inn}</div></div>
                    <div><div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>Buxgalter</div><div style={{ fontSize: 12, color: "#7eb0d8" }}>{group.buxgalter}</div></div>
                    <div>
                        <div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>Fakturalar</div>
                        {fakturaList.length > 0
                            ? <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 12, color: "#60a5fa" }}><PdfIcon />{fakturaList.length} ta</span>
                            : <span style={{ fontSize: 12, color: "#2e4a5e", fontStyle: "italic" }}>yuklanmagan</span>}
                    </div>
                    <div style={{ marginLeft: "auto" }}>
                        <div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>Jami summa</div>
                        <div style={{ fontSize: 13, fontWeight: 700, color: "#fbbf24" }}>{fmtSum(group.jamiSumma)}<QqsTag hasQqs={groupLatestQqs(sfState, groupKey)} /></div>
                    </div>
                </div>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6, paddingLeft: 26 }} onClick={e => e.stopPropagation()}>
                    <span style={{ fontSize: 12, color: "#4e6a84", marginRight: "auto" }}>{group.rows.length} ta yuk</span>
                    <div style={{ position: "relative" }}>
                        <button onClick={() => setShowHist(true)}
                            style={{ background: "#0a1825", border: "1px solid #1e3a5e", borderRadius: 6, padding: "6px 8px", color: "#4e6a84", cursor: "pointer", display: "flex", alignItems: "center" }}
                            onMouseEnter={e => { e.currentTarget.style.color = "#7ec8f4"; e.currentTarget.style.borderColor = "#2563eb66"; }}
                            onMouseLeave={e => { e.currentTarget.style.color = "#4e6a84"; e.currentTarget.style.borderColor = "#1e3a5e"; }}
                        ><HistoryIcon /></button>
                        {histCount > 0 && <span style={{ position: "absolute", top: -6, right: -6, background: "#1a56c4", color: "#fff", fontSize: 10, fontWeight: 700, borderRadius: "50%", width: 16, height: 16, display: "flex", alignItems: "center", justifyContent: "center", pointerEvents: "none" }}>{histCount > 9 ? "9+" : histCount}</span>}
                    </div>
                    {lastManualNote && (
                        <span
                            title={lastManualNote.text}
                            style={{ maxWidth: 190, fontSize: 11, color: "#8aaac8", background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 6, padding: "3px 8px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                        >
                            💬 {lastManualNote.text}
                        </span>
                    )}
                    <button onClick={() => { setConfirmPayFile(null); setConfirmPayErr(""); setShowTasdiq(true); }}
                        style={{ background: "transparent", border: "1px solid #1a3a5e", borderRadius: 6, padding: "5px 12px", fontSize: 14, color: "#3a6a9e", cursor: "pointer" }}
                        onMouseEnter={e => { e.currentTarget.style.color = "#22c55e"; e.currentTarget.style.borderColor = "#22c55e66"; }}
                        onMouseLeave={e => { e.currentTarget.style.color = "#3a6a9e"; e.currentTarget.style.borderColor = "#1a3a5e"; }}
                    >✓</button>
                    {!isQaytarilgan && (
                        <button onClick={() => setShowQayt(true)}
                            style={{ background: "transparent", border: "1px solid #7c2004", borderRadius: 6, padding: "5px 10px", fontSize: 12, color: "#c23a0c", cursor: "pointer", fontWeight: 700 }}
                            onMouseEnter={e => { e.currentTarget.style.background = "#1e0a00"; e.currentTarget.style.color = "#fca5a5"; }}
                            onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#c23a0c"; }}
                        >↩</button>
                    )}
                </div>
            </div>

            {open && (
                <div style={{ borderTop: `1px solid ${isQaytarilgan ? "#3a0a00" : isTasdiqlangan ? "#0f2e18" : "#172535"}` }}>
                    {fakturaList.length === 0
                        ? <div style={{ padding: "16px 20px", fontSize: 13, color: "#2e4a5e", fontStyle: "italic" }}>Bu guruh uchun hali hech qanday faktura yuklanmagan.</div>
                        : fakturaList.map((f, fi) => <OtkazmaFakturaRow key={fi} faktura={f} index={fi} total={fakturaList.length} trucks={group.rows} />)
                    }
                </div>
            )}
        </div>
    );
}

// ── Shartnomalar card item ─────────────────────────────────────────────────────
function ShartnomalarCardItem({ group, groupKey, index, gState, sfState, otState, dispatchG, dispatchOT, dispatchSF }) {
    const [open, setOpen] = useState(false);
    const [showShFileUp, setShowShFileUp] = useState(false);
    const [showShFileView, setShowShFileView] = useState(false);

    const gs = gState[groupKey] || { status: null, history: [], shFile: null };
    const otGs = otState[groupKey] || { status: null, history: [] };
    const contractInfo = latestShartnoma(gs.history || []);
    const isChernovik = latestShartnomaDraft(gs.history || []);
    const shFile = gs.shFile;

    const isTasdiqlangan = otGs.status === "tasdiqlangan";
    const isQaytarilgan = otGs.status === "ot_qaytarilgan";

    const deadline = contractInfo?.tugash || group.muddat;
    const days = daysUntil(deadline);
    const deadlineColor = days === null ? "#4e6a84" : days < 0 ? "#f87171" : days < 14 ? "#fb923c" : days < 30 ? "#fbbf24" : "#94a3b8";
    const deadlinePrefix = days !== null && days < 0 ? "⚠️ O'TGAN · " : days !== null && days < 14 ? "⚠️ " : "";
    const displayLimit = contractInfo?.limitEnabled === false
        ? null
        : contractInfo?.summa
            ? contractInfo.summa + " so'm"
            : group.limit
                ? fmtSum(group.limit)
                : null;

    const borderColor = isQaytarilgan ? "#ea580c55" : isTasdiqlangan ? "#22c55e44" : open ? "#2563eb55" : "#172535";
    const bgColor = isQaytarilgan ? (open ? "#1e0800" : "#180600") : isTasdiqlangan ? (open ? "#0a2010" : "#081a0e") : open ? "#0a1e38" : "#0d1825";

    return (
        <div style={{ background: bgColor, border: `1px solid ${borderColor}`, borderRadius: 10, overflow: "hidden", transition: "border-color 0.2s, background 0.2s" }}>
            {showShFileUp && <PdfUploadModal title={`Shartnoma hujjati — ${group.tashuvchi}`} onSend={fn => dispatchG({ type: "SH_FILE", key: groupKey, fileName: fn, author: actorName() })} onClose={() => setShowShFileUp(false)} />}
            {showShFileView && <FileViewModal title={`Shartnoma hujjati — ${group.tashuvchi}`} fileName={shFile} onClose={() => setShowShFileView(false)} />}

            <div onClick={() => setOpen(o => !o)} style={{ padding: "14px 16px", cursor: "pointer", userSelect: "none" }}>
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 10 }}>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                        <span style={{ fontSize: 12, color: "#3e5a74", marginTop: 2, minWidth: 18 }}>{index + 1}</span>
                        <div>
                            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 3, flexWrap: "wrap" }}>
                                {isTasdiqlangan && <span style={{ fontSize: 10, background: "#14532d", color: "#86efac", borderRadius: 4, padding: "1px 6px", fontWeight: 700 }}>✅ TO'LANDI</span>}
                                {isQaytarilgan && <span style={{ fontSize: 10, background: "#7c2d0c", color: "#fde68a", borderRadius: 4, padding: "1px 6px", fontWeight: 700 }}>↩️ QAYTARILGAN</span>}
                                <span style={{ fontSize: 13, fontWeight: 700, color: contractInfo?.raqami ? "#93c5fd" : "#d8e6f4" }}>
                                    {contractInfo?.raqami ? `📋 ${contractInfo.raqami}` : `📋 ${group.tashuvchi.split(" ")[0]}-${index + 1}`}
                                </span>
                                {isChernovik && <span style={{ fontSize: 10, background: "#1a1200", color: "#fbbf24", border: "1px solid #5c3a00", borderRadius: 4, padding: "1px 6px", fontWeight: 700 }}>CHERNOVIK</span>}
                            </div>
                            <div style={{ fontSize: 12, fontWeight: 600, color: isTasdiqlangan ? "#4ade80" : isQaytarilgan ? "#f97316" : "#d8e6f4" }}>{group.yetkazib}</div>
                            <div style={{ fontSize: 12, fontWeight: 600, color: isTasdiqlangan ? "#86efac" : isQaytarilgan ? "#fca882" : "#4ba8e8" }}>{group.tashuvchi}</div>
                        </div>
                    </div>
                    <span style={{ color: "#4e6a84", fontSize: 12, transition: "transform 0.2s", transform: open ? "rotate(90deg)" : "rotate(0deg)", marginTop: 3 }}>▶</span>
                </div>

                <div style={{ display: "flex", gap: "6px 16px", flexWrap: "wrap", marginBottom: 10, paddingLeft: 26 }}>
                    <div>
                        <div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>INN</div>
                        <div style={{ fontSize: 12, color: "#7eb0d8" }}>{group.inn}</div>
                    </div>
                    <div>
                        <div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>Buxgalter</div>
                        <div style={{ fontSize: 12, color: "#7eb0d8" }}>{group.buxgalter}</div>
                    </div>
                    {displayLimit && (
                        <div>
                            <div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>Limit</div>
                            <div style={{ fontSize: 12, fontWeight: 700, color: "#a78bfa" }}>{displayLimit}</div>
                        </div>
                    )}
                    {deadline && (
                        <div>
                            <div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>Muddat</div>
                            <div style={{ fontSize: 12, fontWeight: days !== null && days < 14 ? 700 : 400, color: deadlineColor }}>{deadlinePrefix}{deadline}</div>
                        </div>
                    )}
                    <div style={{ marginLeft: "auto" }}>
                        <div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>Jami summa</div>
                        <div style={{ fontSize: 13, fontWeight: 700, color: "#fbbf24" }}>{fmtSum(group.jamiSumma)}<QqsTag hasQqs={groupLatestQqs(sfState, groupKey)} /></div>
                    </div>
                </div>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6, paddingLeft: 26 }} onClick={e => e.stopPropagation()}>
                    <span style={{ fontSize: 12, color: "#4e6a84", marginRight: "auto" }}>{group.rows.length} ta yuk</span>
                    <button
                        onClick={() => shFile ? setShowShFileView(true) : setShowShFileUp(true)}
                        title={shFile ? `📎 ${shFile}` : "Shartnoma hujjati yuklash"}
                        style={{ background: shFile ? "#0e1e38" : "transparent", border: `1px solid ${shFile ? "#1e3a6e" : "#1a3a5e"}`, borderRadius: 6, padding: "5px 7px", fontSize: 12, color: shFile ? "#60a5fa" : "#3a5a7e", cursor: "pointer" }}
                        onMouseEnter={e => { e.currentTarget.style.borderColor = "#60a5fa88"; e.currentTarget.style.color = "#7ec8f4"; }}
                        onMouseLeave={e => { e.currentTarget.style.borderColor = shFile ? "#1e3a6e" : "#1a3a5e"; e.currentTarget.style.color = shFile ? "#60a5fa" : "#3a5a7e"; }}
                    >{shFile ? "📎" : "📤"}</button>
                </div>
            </div>

            {open && (
                <div style={{ borderTop: `1px solid ${isQaytarilgan ? "#3a0a00" : isTasdiqlangan ? "#0f2e18" : "#172535"}` }}>
                    <ShartnomalarPaymentSection
                        group={group} groupKey={groupKey}
                        otState={otState} dispatchOT={dispatchOT}
                        sfState={sfState} dispatchSF={dispatchSF}
                    />
                </div>
            )}
        </div>
    );
}

// ── O'tkazma Statusi Trip Card ────────────────────────────────────────────────
function TripStatusCard({ row, index, gState, sfState, otState }) {
    const { group, hasFaktura, isQaytarilgan, isPaid, groupKey } = row;
    const [showDocModal, setShowDocModal] = useState(false);
    const [viewFile, setViewFile] = useState(null);

    const shFile = gState?.[groupKey]?.shFile;
    const otFile = otState?.[groupKey]?.otFile;
    const fakturaFiles = (sfState?.[groupKey]?.history || []).filter(h => h.type === "faktura");
    const docCount = (shFile ? 1 : 0) + (otFile ? 1 : 0) + fakturaFiles.length;

    const borderColor = isPaid ? "#22c55e44" : isQaytarilgan ? "#ea580c55" : hasFaktura ? "#2563eb44" : "#172535";
    const bgColor = isPaid ? "#081a0e" : isQaytarilgan ? "#1a0600" : "#0d1825";

    return (
        <div style={{ background: bgColor, border: `1px solid ${borderColor}`, borderRadius: 10, padding: "14px 16px", display: "flex", flexDirection: "column", gap: 10, transition: "border-color 0.2s" }}>
            {viewFile && <FileViewModal title="Hujjat" fileName={viewFile} onClose={() => setViewFile(null)} />}
            {showDocModal && (
                <div onClick={() => setShowDocModal(false)} style={{ position: "fixed", inset: 0, background: "#00000099", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
                    <div onClick={e => e.stopPropagation()} style={{ background: "#0d1825", border: "1px solid #1e3a5e", borderRadius: 12, padding: 24, width: 360, boxShadow: "0 8px 40px #000" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                            <div style={{ fontSize: 14, fontWeight: 700, color: "#d8e6f4" }}>Hujjatlar</div>
                            <button onClick={() => setShowDocModal(false)} style={{ background: "transparent", border: "none", color: "#4e6a84", fontSize: 20, cursor: "pointer" }}>×</button>
                        </div>
                        {docCount === 0 && <div style={{ fontSize: 13, color: "#2e4a5e", fontStyle: "italic" }}>Hujjat yuklanmagan</div>}
                        {shFile && (
                            <div onClick={() => { setShowDocModal(false); setViewFile(shFile); }}
                                style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 8, marginBottom: 8, cursor: "pointer" }}
                                onMouseEnter={e => e.currentTarget.style.background = "#0c1a2e"}
                                onMouseLeave={e => e.currentTarget.style.background = "#08111d"}>
                                <span style={{ color: "#3b6fbc" }}><PdfIcon /></span>
                                <div><div style={{ fontSize: 12, fontWeight: 600, color: "#60a5fa" }}>{shFile}</div><div style={{ fontSize: 11, color: "#4e6a84" }}>Shartnoma hujjati</div></div>
                            </div>
                        )}
                        {fakturaFiles.map((f, i) => (
                            <div key={i} onClick={() => { setShowDocModal(false); setViewFile(f.fileName); }}
                                style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 8, marginBottom: 8, cursor: "pointer" }}
                                onMouseEnter={e => e.currentTarget.style.background = "#0c1a2e"}
                                onMouseLeave={e => e.currentTarget.style.background = "#08111d"}>
                                <span style={{ color: "#3b6fbc" }}><PdfIcon /></span>
                                <div><div style={{ fontSize: 12, fontWeight: 600, color: "#60a5fa" }}>{f.fileName || "faktura.pdf"}</div><div style={{ fontSize: 11, color: "#4e6a84" }}>Faktura #{i + 1} · {f.timestamp}</div></div>
                            </div>
                        ))}
                        {otFile && (
                            <div onClick={() => { setShowDocModal(false); setViewFile(otFile); }}
                                style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 8, marginBottom: 8, cursor: "pointer" }}
                                onMouseEnter={e => e.currentTarget.style.background = "#0c1a2e"}
                                onMouseLeave={e => e.currentTarget.style.background = "#08111d"}>
                                <span style={{ color: "#3b6fbc" }}><PdfIcon /></span>
                                <div><div style={{ fontSize: 12, fontWeight: 600, color: "#60a5fa" }}>{otFile}</div><div style={{ fontSize: 11, color: "#4e6a84" }}>To'lov hujjati</div></div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Header row */}
            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ fontSize: 11, color: "#3e5a74" }}>{index + 1}</span>
                    <div>
                        <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                            {isPaid && <span style={{ fontSize: 10, background: "#14532d", color: "#86efac", borderRadius: 4, padding: "1px 6px", fontWeight: 700 }}>✅ TO'LANGAN</span>}
                            {isQaytarilgan && <span style={{ fontSize: 10, background: "#7c2d0c", color: "#fde68a", borderRadius: 4, padding: "1px 6px", fontWeight: 700 }}>↩️ QAYTARILGAN</span>}
                            <span style={{ fontSize: 14, fontWeight: 700, color: isPaid ? "#4ade80" : isQaytarilgan ? "#fca882" : "#d8e6f4" }}>{row.buyurtmaId}</span>
                        </div>
                        <div style={{ fontSize: 11, color: "#4e6a84", marginTop: 2 }}>{row.sana}</div>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <button onClick={() => setShowDocModal(true)} title="Hujjatlar"
                        style={{ background: docCount > 0 ? "#0a1e38" : "transparent", border: `1px solid ${docCount > 0 ? "#1e3a6e" : "#1e3a5e"}`, borderRadius: 6, padding: "4px 8px", fontSize: 11, color: docCount > 0 ? "#60a5fa" : "#3a5a7e", cursor: "pointer", display: "flex", alignItems: "center", gap: 4 }}
                        onMouseEnter={e => { e.currentTarget.style.borderColor = "#60a5fa88"; }}
                        onMouseLeave={e => { e.currentTarget.style.borderColor = docCount > 0 ? "#1e3a6e" : "#1e3a5e"; }}
                    >📎{docCount > 0 ? ` ${docCount}` : ""}</button>
                    <span style={{ fontSize: 13, fontWeight: 700, color: "#fbbf24", whiteSpace: "nowrap" }}>{fmtSum(row.summa)}</span>
                </div>
            </div>

            {/* Route */}
            <div style={{ background: "#070d18", borderRadius: 7, padding: "8px 12px", display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ fontSize: 12, color: "#c2d0df", fontWeight: 600 }}>{row.qayerdan}</span>
                <span style={{ color: "#2563eb", fontSize: 14, fontWeight: 700 }}>→</span>
                <span style={{ fontSize: 12, color: "#7ec8f4", fontWeight: 600 }}>{row.qayerga}</span>
                <span style={{ marginLeft: "auto", fontSize: 11, color: "#4ba8e8" }}>{row.avto}</span>
            </div>

            {/* Meta */}
            <div style={{ display: "flex", gap: "6px 18px", flexWrap: "wrap" }}>
                <div>
                    <div style={{ fontSize: 10, color: "#3e5a74", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 }}>Tashuvchi</div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "#4ba8e8" }}>{group.tashuvchi}</div>
                    <div style={{ fontSize: 11, color: "#3e5a74" }}>{group.yetkazib}</div>
                </div>
            </div>

            {/* Status badges */}
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {hasFaktura
                    ? <span style={{ fontSize: 11, background: "#0a1e38", color: "#60a5fa", border: "1px solid #1e3a6e", borderRadius: 5, padding: "3px 10px", fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 4 }}><PdfIcon />Fakturalangan</span>
                    : <span style={{ fontSize: 11, background: "#08111d", color: "#2e4a5e", border: "1px solid #121e2e", borderRadius: 5, padding: "3px 10px" }}>Faktura yo'q</span>
                }
                {isPaid
                    ? <span style={{ fontSize: 11, background: "#0f2a1a", color: "#4ade80", border: "1px solid #166534", borderRadius: 5, padding: "3px 10px", fontWeight: 600 }}>✅ To'lov tasdiqlangan</span>
                    : isQaytarilgan
                        ? <span style={{ fontSize: 11, background: "#7c2d0c", color: "#fde68a", borderRadius: 5, padding: "3px 10px", fontWeight: 700 }}>↩️ Qaytarilgan</span>
                        : hasFaktura
                            ? <span style={{ fontSize: 11, background: "#0a1e2a", color: "#38bdf8", border: "1px solid #0e3a5e", borderRadius: 5, padding: "3px 10px", fontWeight: 600 }}>⏳ Ko'rib chiqilmoqda</span>
                            : <span style={{ fontSize: 11, background: "#0a1825", color: "#4e6a84", border: "1px solid #1e3a5e", borderRadius: 5, padding: "3px 10px" }}>Kutilmoqda</span>
                }
            </div>
        </div>
    );
}

// ── Doc Table Row (for O'tkazmalar statusi table) ─────────────────────────────
function DocTableRow({ row, i, rowBg, hoverBg, leftAccent, statusStyle, statusText, docCount, shFile, otFile, fakturaFiles }) {
    const [showDocModal, setShowDocModal] = useState(false);
    const [viewFile, setViewFile] = useState(null);
    return (
        <>
            {viewFile && <FileViewModal title="Hujjat" fileName={viewFile} onClose={() => setViewFile(null)} />}
            {showDocModal && (
                <div onClick={() => setShowDocModal(false)} style={{ position: "fixed", inset: 0, background: "#00000099", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
                    <div onClick={e => e.stopPropagation()} style={{ background: "#0d1825", border: "1px solid #1e3a5e", borderRadius: 12, padding: 24, width: 340, boxShadow: "0 8px 40px #000" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
                            <div style={{ fontSize: 14, fontWeight: 700, color: "#d8e6f4" }}>Hujjatlar</div>
                            <button onClick={() => setShowDocModal(false)} style={{ background: "transparent", border: "none", color: "#4e6a84", fontSize: 20, cursor: "pointer" }}>×</button>
                        </div>
                        {docCount === 0 && <div style={{ fontSize: 13, color: "#2e4a5e", fontStyle: "italic" }}>Hujjat yuklanmagan</div>}
                        {shFile && <div onClick={() => { setShowDocModal(false); setViewFile(shFile); }} style={{ display: "flex", alignItems: "center", gap: 8, padding: "9px 12px", background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 8, marginBottom: 6, cursor: "pointer" }} onMouseEnter={e => e.currentTarget.style.background = "#0c1a2e"} onMouseLeave={e => e.currentTarget.style.background = "#08111d"}><PdfIcon /><div><div style={{ fontSize: 12, fontWeight: 600, color: "#60a5fa" }}>{shFile}</div><div style={{ fontSize: 11, color: "#4e6a84" }}>Shartnoma hujjati</div></div></div>}
                        {fakturaFiles.map((f, fi) => <div key={fi} onClick={() => { setShowDocModal(false); setViewFile(f.fileName); }} style={{ display: "flex", alignItems: "center", gap: 8, padding: "9px 12px", background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 8, marginBottom: 6, cursor: "pointer" }} onMouseEnter={e => e.currentTarget.style.background = "#0c1a2e"} onMouseLeave={e => e.currentTarget.style.background = "#08111d"}><PdfIcon /><div><div style={{ fontSize: 12, fontWeight: 600, color: "#60a5fa" }}>{f.fileName || "faktura.pdf"}</div><div style={{ fontSize: 11, color: "#4e6a84" }}>Faktura #{fi + 1}</div></div></div>)}
                        {otFile && <div onClick={() => { setShowDocModal(false); setViewFile(otFile); }} style={{ display: "flex", alignItems: "center", gap: 8, padding: "9px 12px", background: "#08111d", border: "1px solid #1e3a5e", borderRadius: 8, cursor: "pointer" }} onMouseEnter={e => e.currentTarget.style.background = "#0c1a2e"} onMouseLeave={e => e.currentTarget.style.background = "#08111d"}><PdfIcon /><div><div style={{ fontSize: 12, fontWeight: 600, color: "#60a5fa" }}>{otFile}</div><div style={{ fontSize: 11, color: "#4e6a84" }}>To'lov hujjati</div></div></div>}
                    </div>
                </div>
            )}
            <tr style={{ background: rowBg, borderLeft: `3px solid ${leftAccent}` }}
                onMouseEnter={e => e.currentTarget.style.background = hoverBg}
                onMouseLeave={e => e.currentTarget.style.background = rowBg}>
                <td style={{ ...cS, color: "#4e6a84", textAlign: "center" }}>{i + 1}</td>
                <td style={{ ...cS, color: "#7eb0d8", fontSize: 12 }}>{row.group.firmaKodi || row.group.inn}</td>
                <td style={{ ...cS }}>
                    <div style={{ fontWeight: 700, color: row.isPaid ? "#4ade80" : "#d8e6f4" }}>{row.buyurtmaId}</div>
                    {row.isPaid && <div style={{ fontSize: 10, color: "#166534", fontWeight: 600, marginTop: 1 }}>✅ TO'LANGAN</div>}
                </td>
                <td style={{ ...cS, color: "#6a8aaa", fontSize: 12 }}>{row.sana}</td>
                <td style={{ ...cS }}>
                    <span style={{ color: "#c2d0df" }}>{row.qayerdan}</span>
                    <span style={{ color: "#3e5a74", margin: "0 4px" }}>→</span>
                    <span style={{ color: "#7ec8f4" }}>{row.qayerga}</span>
                </td>
                <td style={{ ...cS, color: "#4ba8e8", fontSize: 12 }}>{row.avto}</td>
                <td style={{ ...cS, fontSize: 12 }}>
                    <div style={{ fontWeight: 600, color: "#4ba8e8" }}>{row.group.tashuvchi}</div>
                    <div style={{ fontSize: 11, color: "#3e5a74", marginTop: 1 }}>{row.group.yetkazib}</div>
                </td>
                <td style={{ ...cS }}>
                    <span style={{ fontSize: 11, background: statusStyle.bg, border: `1px solid ${statusStyle.bdr}`, color: statusStyle.clr, borderRadius: 5, padding: "2px 8px", fontWeight: 600 }}>
                        {statusText}
                    </span>
                </td>
                <td style={{ ...cS }}>
                    <button onClick={() => setShowDocModal(true)}
                        style={{ background: docCount > 0 ? "#0a1e38" : "transparent", border: `1px solid ${docCount > 0 ? "#1e3a6e" : "#1e3a5e"}`, borderRadius: 6, padding: "4px 8px", fontSize: 11, color: docCount > 0 ? "#60a5fa" : "#2e4a5e", cursor: "pointer" }}>
                        📎 {docCount > 0 ? `${docCount} ta` : "yo'q"}
                    </button>
                </td>
                <td style={{ ...cS, fontWeight: 600, color: "#fbbf24", fontSize: 12, whiteSpace: "nowrap" }}>{fmtSum(row.summa)}</td>
            </tr>
        </>
    );
}

// ── O'tkazma Statusi Page ─────────────────────────────────────────────────────
const HOURS_48 = 48 * 3600000;
function OtkazmaStatusiPage({ allGroups, gState, sfState, otState, activeTab, q, layout }) {
    const [kompaniyaKodiFilter, setKompaniyaKodiFilter] = useState("");
    const now = Date.now();

    const allRows = [];
    allGroups.forEach(g => {
        const key = g.yetkazib + "||" + g.tashuvchi;
        // 48 soatdan o'tgan guruhlar ko'rinmaydi
        if (now - g.availableSince > HOURS_48) return;
        if (activeTab !== "Hammasi" && g.yetkazib !== activeTab) return;
        const isPaid = otState[key]?.status === "tasdiqlangan";
        const hasFaktura = sfState[key]?.history?.some(h => h.type === "faktura") || false;
        const isQaytarilgan = otState[key]?.status === "ot_qaytarilgan";
        g.rows.forEach(row => {
            if (q && !(
                row.buyurtmaId.toLowerCase().includes(q) ||
                row.avto.toLowerCase().includes(q) ||
                row.qayerdan.toLowerCase().includes(q) ||
                row.qayerga.toLowerCase().includes(q) ||
                g.tashuvchi.toLowerCase().includes(q) ||
                g.yetkazib.toLowerCase().includes(q)
            )) return;
            allRows.push({ ...row, group: g, groupKey: key, hasFaktura, isQaytarilgan, isPaid });
        });
    });

    const kompaniyaKodiOptions = [...new Set(allRows.map(r => r.group.firmaKodi || r.group.inn).filter(Boolean))].sort();
    useEffect(() => {
        if (kompaniyaKodiFilter && !kompaniyaKodiOptions.includes(kompaniyaKodiFilter)) {
            setKompaniyaKodiFilter("");
        }
    }, [kompaniyaKodiFilter, kompaniyaKodiOptions]);

    const filteredRows = kompaniyaKodiFilter
        ? allRows.filter(r => (r.group.firmaKodi || r.group.inn) === kompaniyaKodiFilter)
        : allRows;
    const inProgressRows = filteredRows.filter(r => !r.isPaid);

    return (
        <div>
            {/* Top filter */}


            {/* Stats */}
            <div style={{ display: "flex", alignItems: "center", gap: 16, padding: "10px 0 14px", borderBottom: "1px solid #111e2d", marginBottom: 12, flexWrap: "wrap" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ fontSize: 12, color: "#4e6a84" }}>Jarayonda:</span>
                    <span style={{ fontSize: 13, fontWeight: 700, color: "#7ec8f4" }}>{inProgressRows.length}</span>
                </div>
                <div style={{ width: 1, height: 16, background: "#1e3a5e" }} />
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ fontSize: 12, color: "#4e6a84" }}>Fakturalangan:</span>
                    <span style={{ fontSize: 13, fontWeight: 700, color: "#60a5fa" }}>{inProgressRows.filter(r => r.hasFaktura).length}</span>
                </div>
                <div style={{ width: 1, height: 16, background: "#1e3a5e" }} />
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ fontSize: 12, color: "#4e6a84" }}>Qaytarilgan:</span>
                    <span style={{ fontSize: 13, fontWeight: 700, color: "#fb923c" }}>{inProgressRows.filter(r => r.isQaytarilgan).length}</span>
                </div>
                <div style={{ width: 1, height: 16, background: "#1e3a5e" }} />
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ fontSize: 12, color: "#4e6a84" }}>To'langan:</span>
                    <span style={{ fontSize: 13, fontWeight: 700, color: "#4ade80" }}>{filteredRows.filter(r => r.isPaid).length}</span>
                </div>
            </div>

            {/* Table view */}
            {layout === "table" && (
                <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr>
                                <th style={{ ...hS, width: 44, textAlign: "center" }}>№</th>
                                <th style={hS}>Kompaniya kodi</th>
                                <th style={hS}>Buyurtma ID</th>
                                <th style={hS}>Sana</th>
                                <th style={hS}>Yo'nalish</th>
                                <th style={hS}>Avtomobil</th>
                                <th style={hS}>Tashuvchi</th>
                                <th style={hS}>Status</th>
                                <th style={hS}>Hujjatlar</th>
                                <th style={{ ...hS, color: "#fbbf24" }}>Summa</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredRows.length === 0 && (
                                <tr><td colSpan={10} style={{ ...cS, textAlign: "center", color: "#3e5a74", padding: "40px 0" }}>So'nggi 48 soatda buyurtma yo'q</td></tr>
                            )}
                            {filteredRows.map((row, i) => {
                                const statusText = getShartnomaStatus(row.groupKey, gState, sfState);
                                const statusCfg = {
                                    "to'lov qilish jarayonida": { bg: "#0f2a1a", bdr: "#0e3a5e", clr: "#38bdf8" },
                                    "faktura jo'natmagan": { bg: "#1e0a00", bdr: "#7c2d0c", clr: "#fb923c" },
                                    "shartnoma tuzishda": { bg: "#0a1825", bdr: "#1e3a5e", clr: "#8aaac8" },
                                };
                                const statusStyle = statusCfg[statusText] || statusCfg["shartnoma tuzishda"];
                                const rowBg = row.isPaid
                                    ? (i % 2 === 0 ? "#081a0e" : "#091e10")
                                    : row.isQaytarilgan
                                        ? (i % 2 === 0 ? "#1a0600" : "#1e0800")
                                        : (i % 2 === 0 ? "#0b1520" : "#0d1825");
                                const hoverBg = row.isPaid ? "#0a2418" : row.isQaytarilgan ? "#280a00" : "#0f2035";
                                const leftAccent = row.isPaid ? "#22c55e" : row.isQaytarilgan ? "#ea580c" : "transparent";
                                const shFile = gState?.[row.groupKey]?.shFile;
                                const otFile = otState?.[row.groupKey]?.otFile;
                                const fakturaFiles = (sfState?.[row.groupKey]?.history || []).filter(h => h.type === "faktura");
                                const docCount = (shFile ? 1 : 0) + (otFile ? 1 : 0) + fakturaFiles.length;
                                return (
                                    <DocTableRow key={row.id} row={row} i={i} rowBg={rowBg} hoverBg={hoverBg} leftAccent={leftAccent} statusStyle={statusStyle} statusText={statusText} docCount={docCount} shFile={shFile} otFile={otFile} fakturaFiles={fakturaFiles} />
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Grid / card view */}
            {layout === "grid" && (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 12 }}>
                    {filteredRows.length === 0 && (
                        <div style={{ gridColumn: "1/-1", textAlign: "center", color: "#3e5a74", padding: "40px 0" }}>So'nggi 48 soatda buyurtma yo'q</div>
                    )}
                    {filteredRows.map((row, i) => <TripStatusCard key={row.id} row={row} index={i} gState={gState} sfState={sfState} otState={otState} />)}
                </div>
            )}
        </div>
    );
}

// ── App ───────────────────────────────────────────────────────────────────────
export default function App() {
    const [activePage, setActivePage] = useState("shartnoma");
    const [activeTab, setActiveTab] = useState("Hammasi");
    const [activeRole, setActiveRole] = useState(ACTIVE_ROLE);
    const [firmaKodiFilter, setFirmaKodiFilter] = useState("");
    const [showCommonShartnoma, setShowCommonShartnoma] = useState(false);
    const [layout, setLayout] = useState("table");
    const [search, setSearch] = useState("");
    const [shartnomalarSubTab, setShartnomalarSubTab] = useState("asosiy");
    const [muddatSort, setMuddatSort] = useState(null); // null | "asc" | "desc"
    const [gState, dispatchG] = useState({});
    const [sfState, dispatchSF] = useState(INITIAL_SF_STATE);
    const [otState, dispatchOT] = useState({});
    const activeRoleLabel = ROLE_OPTIONS.find(r => r.key === activeRole)?.label || activeRole;

    useEffect(() => {
        ACTIVE_ROLE = activeRole;
    }, [activeRole]);

    const dispatchGFn = action => dispatchG(prev => groupReducer(prev, action));
    const dispatchSFFn = action => dispatchSF(prev => sfReducer(prev, action));
    const dispatchOTFn = action => dispatchOT(prev => otReducer(prev, action));

    const allGroups = groupData(mockData);
    const tabs = ["Hammasi", "SHOSH CARGO", "VODIY STAR TRANS", "IMB TRUCK", "UNITED CARGO", "AROBA"];
    const navItems = ["Shartnoma tuzish", "Schet faktura", "O'tkazmani yakunlash", "Shartnomalar", "O'tkazmalar statusi"];
    const firmaKodiOptions = [...new Set(
        allGroups
            .filter(g => activeTab === "Hammasi" || g.yetkazib === activeTab)
            .map(g => g.firmaKodi)
            .filter(Boolean)
    )].sort();

    const counts = {};
    tabs.forEach(tab => {
        counts[tab] = tab === "Hammasi" ? allGroups.length : allGroups.filter(g => g.yetkazib === tab).length;
    });

    const q = search.toLowerCase().trim();
    const filteredGroups = allGroups.filter(g => {
        if (activeTab !== "Hammasi" && g.yetkazib !== activeTab) return false;
        if (activePage === "shartnoma" && firmaKodiFilter && g.firmaKodi !== firmaKodiFilter) return false;
        if (!q) return true;
        return (
            g.yetkazib.toLowerCase().includes(q) ||
            g.tashuvchi.toLowerCase().includes(q) ||
            g.firmaKodi.toLowerCase().includes(q) ||
            g.inn.toLowerCase().includes(q) ||
            g.buxgalter.toLowerCase().includes(q) ||
            g.manager.toLowerCase().includes(q) ||
            g.rows.some(r => r.buyurtmaId.toLowerCase().includes(q) || r.avto.toLowerCase().includes(q) || r.qayerdan.toLowerCase().includes(q) || r.qayerga.toLowerCase().includes(q))
        );
    });

    const groups = [...filteredGroups]
        .filter(g => {
            const key = g.yetkazib + "||" + g.tashuvchi;
            if (activePage === "schet-faktura") {
                if (sfState[key]?.status === "sf_qaytarilgan") return false;
                if (sfState[key]?.status !== "banded" && sfState[key]?.history?.some(h => h.type === "faktura")) return false;
            }
            return true;
        })
        .sort((a, b) => {
            const aKey = a.yetkazib + "||" + a.tashuvchi;
            const bKey = b.yetkazib + "||" + b.tashuvchi;
            if (activePage === "shartnoma") {
                const aQ = sfState[aKey]?.status === "sf_qaytarilgan" ? -1 : 0;
                const bQ = sfState[bKey]?.status === "sf_qaytarilgan" ? -1 : 0;
                return aQ - bQ;
            }
            return 0;
        });
    const shartnomaTargetGroup = activePage === "shartnomalar" ? (groups[0] || null) : null;
    const shartnomaTargetKey = shartnomaTargetGroup ? (shartnomaTargetGroup.yetkazib + "||" + shartnomaTargetGroup.tashuvchi) : "";

    const sfTotalSum = groups.reduce((s, g) => s + (g.jamiSumma || 0), 0);

    const sfReturnedCount = allGroups.filter(g => {
        const key = g.yetkazib + "||" + g.tashuvchi;
        return sfState[key]?.status === "sf_qaytarilgan";
    }).length;

    return (
        <div style={{ minHeight: "100vh", background: "#080f18", color: "#c2d0df", fontFamily: "system-ui,-apple-system,sans-serif", fontSize: 13 }}>
            <style>{`
        * { box-sizing:border-box; margin:0; }
        ::-webkit-scrollbar{width:5px;height:5px}
        ::-webkit-scrollbar-thumb{background:#1a3a5f;border-radius:3px}
        input[type=date]::-webkit-calendar-picker-indicator{filter:invert(0.5)}
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.6} }
      `}</style>

            {/* NAV */}
            <div style={{ display: "flex", alignItems: "center", background: "#060d18", borderBottom: "1px solid #111e2d", padding: "0 18px", height: 48, gap: 2 }}>
                {navItems.map(n => {
                    const pageKey = n === "Shartnoma tuzish" ? "shartnoma" : n === "Schet faktura" ? "schet-faktura" : n === "O'tkazmani yakunlash" ? "otkazma" : n === "Shartnomalar" ? "shartnomalar" : n === "O'tkazmalar statusi" ? "otkazma-statusi" : null;
                    const isActive = pageKey && activePage === pageKey;
                    const showBadge = n === "Shartnoma tuzish" && sfReturnedCount > 0;
                    return (
                        <button key={n}
                            onClick={() => pageKey && setActivePage(pageKey)}
                            style={{
                                background: "transparent", border: "none", padding: "5px 12px", fontSize: 13,
                                color: isActive ? "#7ec8f4" : "#4e6a84",
                                cursor: pageKey ? "pointer" : "default",
                                borderRadius: 5,
                                borderBottom: isActive ? "2px solid #2563eb" : "2px solid transparent",
                                marginBottom: isActive ? "-2px" : 0,
                                fontWeight: isActive ? 600 : 400,
                                position: "relative", display: "inline-flex", alignItems: "center", gap: 6,
                            }}
                            onMouseEnter={e => { if (!isActive) e.currentTarget.style.color = "#a0c8f0"; }}
                            onMouseLeave={e => { if (!isActive) e.currentTarget.style.color = "#4e6a84"; }}
                        >
                            {n}
                            {showBadge && (
                                <span style={{ background: "#7c3aed", color: "#ede9fe", fontSize: 10, fontWeight: 800, borderRadius: 999, padding: "1px 6px", minWidth: 18, textAlign: "center", animation: "pulse 1.8s infinite" }}>
                                    {sfReturnedCount}
                                </span>
                            )}
                        </button>
                    );
                })}
                <div style={{ flex: 1 }} />
                <button style={{ background: "#1a56c4", border: "none", borderRadius: 7, padding: "6px 18px", fontSize: 13, color: "#fff", cursor: "pointer", fontWeight: 600 }}>+ Buyurtma</button>
            </div>

            {/* PAGE HEADER for Schet Faktura */}
            {activePage === "schet-faktura" && (
                <div style={{ background: "#060d18", borderBottom: "1px solid #111e2d", padding: "10px 18px", display: "flex", alignItems: "center", gap: 18 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <span style={{ fontSize: 13, color: "#4e6a84" }}>Jami guruhlar:</span>
                        <span style={{ fontSize: 14, fontWeight: 700, color: "#7ec8f4" }}>{groups.length}</span>
                    </div>
                    <div style={{ width: 1, height: 20, background: "#1e3a5e" }} />
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <span style={{ fontSize: 13, color: "#4e6a84" }}>Jami summa:</span>
                        <span style={{ fontSize: 15, fontWeight: 800, color: "#fbbf24", letterSpacing: "0.02em" }}>{fmtSum(sfTotalSum)}</span>
                    </div>
                </div>
            )}

            {/* TOOLBAR */}
            <div style={{ display: "flex", alignItems: "center", background: "#060d18", borderBottom: "1px solid #111e2d", padding: "8px 18px", gap: 12, flexWrap: "wrap" }}>
                <Dropdown options={tabs} value={activeTab} onChange={setActiveTab} counts={counts} />

                {activePage === "shartnoma" && (
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 12, color: "#4e6a84", whiteSpace: "nowrap" }}>Firma kodi:</span>
                        <select
                            value={firmaKodiFilter}
                            onChange={e => setFirmaKodiFilter(e.target.value)}
                            style={{ background: "#0a1825", border: "1px solid #1e3a5e", borderRadius: 8, padding: "7px 12px", fontSize: 13, color: "#c2d0df", outline: "none", minWidth: 150, colorScheme: "dark" }}
                        >
                            <option value="">Hammasi</option>
                            {firmaKodiOptions.map(code => (
                                <option key={code} value={code}>{code}</option>
                            ))}
                        </select>
                    </div>
                )}
                <div style={{ position: "relative", flex: 1, maxWidth: 380 }}>
                    <span style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#4e6a84", pointerEvents: "none" }}><SearchIcon /></span>
                    <input
                        value={search} onChange={e => setSearch(e.target.value)}
                        placeholder="Qidirish — tashuvchi, menejer, avtomobil..."
                        style={{ width: "100%", background: "#0a1825", border: "1px solid #1e3a5e", borderRadius: 8, padding: "7px 12px 7px 34px", fontSize: 13, color: "#c2d0df", outline: "none", fontFamily: "inherit" }}
                        onFocus={e => e.target.style.borderColor = "#2563eb"}
                        onBlur={e => e.target.style.borderColor = "#1e3a5e"}
                    />
                    {search && (
                        <button onClick={() => setSearch("")} style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "transparent", border: "none", color: "#4e6a84", cursor: "pointer", fontSize: 16, lineHeight: 1, padding: 0 }}>×</button>
                    )}
                </div>
                <div style={{ marginLeft: "auto", display: "flex", background: "#060d18", border: "1px solid #111e2d", borderRadius: 7, overflow: "hidden" }}>
                    <button onClick={() => setLayout("table")} style={{ background: layout === "table" ? "#163a6e" : "transparent", border: "none", padding: "7px 11px", cursor: "pointer", color: layout === "table" ? "#7ec4f0" : "#4e6a84", display: "flex", alignItems: "center" }}><TableIcon /></button>
                    <button onClick={() => setLayout("grid")} style={{ background: layout === "grid" ? "#163a6e" : "transparent", border: "none", padding: "7px 11px", cursor: "pointer", color: layout === "grid" ? "#7ec4f0" : "#4e6a84", display: "flex", alignItems: "center" }}><GridIcon /></button>
                </div>
            </div>

            {q && (
                <div style={{ padding: "6px 18px 0" }}>
                    <span style={{ fontSize: 12, color: "#4e6a84" }}>— {groups.length} natija</span>
                </div>
            )}


            {/* CONTENT */}
            <div style={{ padding: "6px 18px 32px" }}>
                {showCommonShartnoma && shartnomaTargetGroup && (
                    <ShartnomDialog
                        group={shartnomaTargetGroup}
                        onSave={({ form, fileName }) => {
                            dispatchGFn({ type: "SHARTNOMA", key: shartnomaTargetKey, form, author: actorName() });
                            if (fileName) dispatchGFn({ type: "SH_FILE", key: shartnomaTargetKey, fileName, author: actorName() });
                        }}
                        onClose={() => setShowCommonShartnoma(false)}
                    />
                )}
                {/* ── SHARTNOMA PAGE ── */}
                {activePage === "shartnoma" && (
                    layout === "table" ? (
                        <div style={{ overflowX: "auto" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                    <tr>
                                        <th style={{ ...hS, width: 44, textAlign: "center" }}>№</th>
                                        <th style={hS}>Firma kodi</th>
                                        <th style={hS}>Yetkazib beruvchi</th>
                                        <th style={hS}>Tashuvchi</th>
                                        <th style={hS}>INN</th>
                                        <th style={hS}>Buxgalter raqami</th>
                                        <th style={hS}><span style={{ display: "inline-flex", alignItems: "center", gap: 5 }}><UserIcon />Menejer</span></th>
                                        <th style={{ ...hS, textAlign: "right", paddingRight: 16 }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {groups.length === 0 && <tr><td colSpan={8} style={{ ...cS, textAlign: "center", color: "#3e5a74", padding: "40px 0" }}>Hech narsa topilmadi</td></tr>}
                                    {groups.map((g, i) => {
                                        const key = g.yetkazib + "||" + g.tashuvchi;
                                        const gs = gState[key] || { status: null, history: [], bandedAt: null };
                                        const sfReturned = sfState[key]?.status === "sf_qaytarilgan";
                                        return <TableGroupRow key={key} group={g} groupKey={key} index={i} groupState={gs} dispatch={dispatchGFn} sfReturned={sfReturned} />;
                                    })}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: 12 }}>
                            {groups.length === 0 && <div style={{ gridColumn: "1/-1", textAlign: "center", color: "#3e5a74", padding: "40px 0" }}>Hech narsa topilmadi</div>}
                            {groups.map((g, i) => {
                                const key = g.yetkazib + "||" + g.tashuvchi;
                                const gs = gState[key] || { status: null, history: [], bandedAt: null };
                                const sfReturned = sfState[key]?.status === "sf_qaytarilgan";
                                return <CardGroupItem key={key} group={g} groupKey={key} index={i} groupState={gs} dispatch={dispatchGFn} sfReturned={sfReturned} />;
                            })}
                        </div>
                    )
                )}

                {/* ── SCHET FAKTURA PAGE ── */}
                {activePage === "schet-faktura" && (
                    layout === "table" ? (
                        <div style={{ overflowX: "auto" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                    <tr>
                                        <th style={{ ...hS, width: 44, textAlign: "center" }}>№</th>
                                        <th style={hS}>Yetkazib beruvchi</th>
                                        <th style={hS}>Tashuvchi</th>
                                        <th style={hS}>INN</th>
                                        <th style={hS}>Buxgalter raqami</th>
                                        <th style={hS}><span style={{ display: "inline-flex", alignItems: "center", gap: 5 }}><UserIcon />Menejer</span></th>
                                        <th style={{ ...hS, color: "#fbbf24" }}>Jami summa</th>
                                        <th style={{ ...hS, textAlign: "right", paddingRight: 16 }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {groups.length === 0 && <tr><td colSpan={8} style={{ ...cS, textAlign: "center", color: "#3e5a74", padding: "40px 0" }}>Hech narsa topilmadi</td></tr>}
                                    {groups.map((g, i) => {
                                        const key = g.yetkazib + "||" + g.tashuvchi;
                                        const gs = sfState[key] || { status: null, history: [], bandedAt: null };
                                        return <SFTableGroupRow key={key} group={g} groupKey={key} index={i} groupState={gs} dispatch={dispatchSFFn} />;
                                    })}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: 12 }}>
                            {groups.length === 0 && <div style={{ gridColumn: "1/-1", textAlign: "center", color: "#3e5a74", padding: "40px 0" }}>Hech narsa topilmadi</div>}
                            {groups.map((g, i) => {
                                const key = g.yetkazib + "||" + g.tashuvchi;
                                const gs = sfState[key] || { status: null, history: [], bandedAt: null };
                                return <SFCardGroupItem key={key} group={g} groupKey={key} index={i} groupState={gs} dispatch={dispatchSFFn} />;
                            })}
                        </div>
                    )
                )}

                {/* ── SHARTNOMALAR PAGE (4-level hierarchy) ── */}
                {activePage === "shartnomalar" && (() => {
                    const asosiyGroups = groups.filter(g => {
                        const key = g.yetkazib + "||" + g.tashuvchi;
                        return !latestShartnomaDraft(gState[key]?.history || []);
                    });
                    const chernovikGroups = groups.filter(g => {
                        const key = g.yetkazib + "||" + g.tashuvchi;
                        return latestShartnomaDraft(gState[key]?.history || []);
                    });
                    const displayGroups = shartnomalarSubTab === "chernoviklar" ? chernovikGroups : asosiyGroups;
                    const sortedGroups = muddatSort ? [...displayGroups].sort((a, b) => {
                        const ka = a.yetkazib + "||" + a.tashuvchi;
                        const kb = b.yetkazib + "||" + b.tashuvchi;
                        const dA = latestShartnoma(gState[ka]?.history || [])?.tugash || a.muddat || "";
                        const dB = latestShartnoma(gState[kb]?.history || [])?.tugash || b.muddat || "";
                        if (!dA && !dB) return 0;
                        if (!dA) return 1;
                        if (!dB) return -1;
                        return muddatSort === "asc" ? dA.localeCompare(dB) : dB.localeCompare(dA);
                    }) : displayGroups;
                    const totalSum = displayGroups.reduce((s, g) => s + g.jamiSumma, 0);
                    const tasdiqlananCount = displayGroups.filter(g => {
                        const key = g.yetkazib + "||" + g.tashuvchi;
                        return otState[key]?.status === "tasdiqlangan";
                    }).length;
                    return (
                        <div>
                            {/* Sub-tabs: Asosiy / Chernoviklar */}
                            <div style={{ display: "flex", gap: 2, background: "#060d18", borderBottom: "1px solid #111e2d", marginBottom: 0 }}>
                                {[{ key: "asosiy", label: "Asosiy", count: asosiyGroups.length }, { key: "chernoviklar", label: "Chernoviklar", count: chernovikGroups.length }].map(tab => (
                                    <button key={tab.key} onClick={() => setShartnomalarSubTab(tab.key)}
                                        style={{ background: "transparent", border: "none", padding: "8px 16px", fontSize: 13, color: shartnomalarSubTab === tab.key ? "#7ec8f4" : "#4e6a84", cursor: "pointer", borderBottom: shartnomalarSubTab === tab.key ? "2px solid #2563eb" : "2px solid transparent", marginBottom: shartnomalarSubTab === tab.key ? "-1px" : 0, fontWeight: shartnomalarSubTab === tab.key ? 600 : 400, display: "inline-flex", alignItems: "center", gap: 6 }}
                                        onMouseEnter={e => { if (shartnomalarSubTab !== tab.key) e.currentTarget.style.color = "#a0c8f0"; }}
                                        onMouseLeave={e => { if (shartnomalarSubTab !== tab.key) e.currentTarget.style.color = "#4e6a84"; }}
                                    >
                                        {tab.label}
                                        <span style={{ fontSize: 11, fontWeight: 700, background: shartnomalarSubTab === tab.key ? "#163a6e" : "#0f1e30", color: shartnomalarSubTab === tab.key ? "#93c5fd" : "#4e7a9e", borderRadius: 999, padding: "1px 7px", minWidth: 20, textAlign: "center" }}>{tab.count}</span>
                                    </button>
                                ))}
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 20, padding: "10px 0 14px", borderBottom: "1px solid #111e2d", marginBottom: 12, flexWrap: "wrap" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <span style={{ fontSize: 12, color: "#4e6a84" }}>Shartnomalar:</span>
                                    <span style={{ fontSize: 13, fontWeight: 700, color: "#7ec8f4" }}>{displayGroups.length}</span>
                                </div>
                                <div style={{ width: 1, height: 16, background: "#1e3a5e" }} />
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <span style={{ fontSize: 12, color: "#4e6a84" }}>To'langan:</span>
                                    <span style={{ fontSize: 13, fontWeight: 700, color: "#4ade80" }}>{tasdiqlananCount}</span>
                                </div>
                                <div style={{ width: 1, height: 16, background: "#1e3a5e" }} />
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <span style={{ fontSize: 12, color: "#4e6a84" }}>Jami summa:</span>
                                    <span style={{ fontSize: 15, fontWeight: 800, color: "#fbbf24" }}>{fmtSum(totalSum)}</span>
                                </div>
                                <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>
                                    <button
                                        onClick={() => setShowCommonShartnoma(true)}
                                        disabled={!shartnomaTargetGroup}
                                        style={{ background: shartnomaTargetGroup ? "#163a6e" : "#0f2035", border: "1px solid #1e5599", borderRadius: 7, padding: "6px 12px", fontSize: 12, color: shartnomaTargetGroup ? "#7ec4f0" : "#4e6a84", cursor: shartnomaTargetGroup ? "pointer" : "not-allowed", fontWeight: 600, whiteSpace: "nowrap" }}
                                    >
                                        + Shartnoma
                                    </button>
                                </div>
                            </div>
                            {layout === "table" ? (
                                <div style={{ overflowX: "auto" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...hS, width: 44, textAlign: "center" }}>№</th>
                                                <th style={hS}>Shartnoma raqami</th>
                                                <th style={hS}>Yetkazib beruvchi</th>
                                                <th style={hS}>Tashuvchi</th>
                                                <th style={hS}>INN</th>
                                                <th style={hS}>Buxgalter</th>
                                                <th style={{ ...hS, color: "#a78bfa" }}>Limit</th>
                                                <th style={{ ...hS, cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}
                                                    onClick={() => setMuddatSort(s => s === null ? "asc" : s === "asc" ? "desc" : null)}
                                                    title="Muddat bo'yicha saralash"
                                                >
                                                    Muddat <span style={{ fontSize: 11, color: muddatSort ? "#7ec8f4" : "#3e5a74" }}>{muddatSort === "asc" ? "↑" : muddatSort === "desc" ? "↓" : "↕"}</span>
                                                </th>
                                                <th style={{ ...hS, color: "#4ade80" }}>Avto soni</th>
                                                <th style={{ ...hS, color: "#fbbf24" }}>Jami summa</th>
                                                <th style={{ ...hS, textAlign: "right", paddingRight: 16 }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {displayGroups.length === 0 && <tr><td colSpan={11} style={{ ...cS, textAlign: "center", color: "#3e5a74", padding: "40px 0" }}>Hech narsa topilmadi</td></tr>}
                                            {sortedGroups.map((g, i) => {
                                                const key = g.yetkazib + "||" + g.tashuvchi;
                                                return <ShartnomalarContractRow key={key} group={g} groupKey={key} index={i}
                                                    gState={gState} sfState={sfState} otState={otState}
                                                    dispatchG={dispatchGFn} dispatchOT={dispatchOTFn} dispatchSF={dispatchSFFn} />;
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: 12 }}>
                                    {displayGroups.length === 0 && <div style={{ gridColumn: "1/-1", textAlign: "center", color: "#3e5a74", padding: "40px 0" }}>Hech narsa topilmadi</div>}
                                    {sortedGroups.map((g, i) => {
                                        const key = g.yetkazib + "||" + g.tashuvchi;
                                        return <ShartnomalarCardItem key={key} group={g} groupKey={key} index={i}
                                            gState={gState} sfState={sfState} otState={otState}
                                            dispatchG={dispatchGFn} dispatchOT={dispatchOTFn} dispatchSF={dispatchSFFn} />;
                                    })}
                                </div>
                            )}
                        </div>
                    );
                })()}

                {/* ── O'TKAZMA STATUSI PAGE ── */}
                {activePage === "otkazma-statusi" && (
                    <OtkazmaStatusiPage
                        allGroups={allGroups} gState={gState} sfState={sfState} otState={otState}
                        activeTab={activeTab} q={q} layout={layout}
                    />
                )}

                {/* ── O'TKAZMA PAGE ── */}
                {activePage === "otkazma" && (() => {
                    const otGroups = [...groups]
                        .filter(g => {
                            const key = g.yetkazib + "||" + g.tashuvchi;
                            const sfHistory = sfState[key]?.history || [];
                            // Faqat fakturali va tasdiqlanmagan guruhlar
                            if (!sfHistory.some(h => h.type === "faktura")) return false;
                            if (otState[key]?.status === "tasdiqlangan") return false;
                            return true;
                        })
                        .sort((a, b) => {
                            const aKey = a.yetkazib + "||" + a.tashuvchi;
                            const bKey = b.yetkazib + "||" + b.tashuvchi;
                            const aQ = otState[aKey]?.status === "ot_qaytarilgan" ? -1 : 0;
                            const bQ = otState[bKey]?.status === "ot_qaytarilgan" ? -1 : 0;
                            return aQ - bQ;
                        });
                    const totalSum = otGroups.reduce((s, g) => s + g.jamiSumma, 0);
                    return (
                        <div>
                            <div style={{ display: "flex", alignItems: "center", gap: 20, padding: "10px 0 14px", borderBottom: "1px solid #111e2d", marginBottom: 12, flexWrap: "wrap" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <span style={{ fontSize: 12, color: "#4e6a84" }}>Guruhlar:</span>
                                    <span style={{ fontSize: 13, fontWeight: 700, color: "#7ec8f4" }}>{otGroups.length}</span>
                                </div>
                                <div style={{ width: 1, height: 16, background: "#1e3a5e" }} />
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <span style={{ fontSize: 12, color: "#4e6a84" }}>Jami to'lov:</span>
                                    <span style={{ fontSize: 15, fontWeight: 800, color: "#fbbf24" }}>{fmtSum(totalSum)}</span>
                                </div>
                            </div>
                            {layout === "table" ? (
                                <div style={{ overflowX: "auto" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...hS, width: 44, textAlign: "center" }}>№</th>
                                                <th style={hS}>Yetkazib beruvchi</th>
                                                <th style={hS}>Tashuvchi</th>
                                                <th style={hS}>INN</th>
                                                <th style={hS}>Buxgalter</th>
                                                <th style={hS}>Fakturalar</th>
                                                <th style={{ ...hS, color: "#fbbf24" }}>Jami summa</th>
                                                <th style={{ ...hS, textAlign: "right", paddingRight: 16 }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {otGroups.length === 0 && <tr><td colSpan={8} style={{ ...cS, textAlign: "center", color: "#3e5a74", padding: "40px 0" }}>Hali hech qanday faktura yuklanmagan</td></tr>}
                                            {otGroups.map((g, i) => {
                                                const key = g.yetkazib + "||" + g.tashuvchi;
                                                return <OtkazmaGroupRow key={key} group={g} groupKey={key} index={i}
                                                    otState={otState} dispatch={dispatchOTFn}
                                                    sfState={sfState} dispatchSF={dispatchSFFn} />;
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: 12 }}>
                                    {otGroups.length === 0 && <div style={{ gridColumn: "1/-1", textAlign: "center", color: "#3e5a74", padding: "40px 0" }}>Hali hech qanday faktura yuklanmagan</div>}
                                    {otGroups.map((g, i) => {
                                        const key = g.yetkazib + "||" + g.tashuvchi;
                                        return <OtkazmaCardItem key={key} group={g} groupKey={key} index={i}
                                            otState={otState} dispatch={dispatchOTFn}
                                            sfState={sfState} dispatchSF={dispatchSFFn} />;
                                    })}
                                </div>
                            )}
                        </div>
                    );
                })()}
            </div>
        </div>
    );
}
